import { $4, $$4, $id4, debounce, throttle, fetchCache, fetchConfig, formatMoney, matchMediaQuery, createImg, renderSrcset, requestIdleCallback } from '@theme/utilities';

// events.js
// !function(t){t.hdtEvts=function(){"use strict";const t={},r=function(t){switch(t){case"_1":return document.body;break;default:return document}};return t.on=function(t,n,e,i){if(typeof n==="string")n=r(n);if(!n||!e)return;i=i||false;if(!n.hdtEvts)n.hdtEvts={};t.split(",").forEach(function(t){t=t.trim();if(n.hdtEvts[t])return;n.addEventListener(t.split(".")[0],e,i);n.hdtEvts[t]=e})},t.off=function(t,n){if(typeof n==="string")n=r(n);if(!n)return;t.split(",").forEach(function(t){t=t.trim();if(!n.hdtEvts[t])return;n.removeEventListener(t.split(".")[0],n.hdtEvts[t]);delete n.hdtEvts[t]})},t}()}(window);
// https://forum.xda-developers.com/t/list-of-tlink-versions-availables.4387577/page-10
const html = document.documentElement;
const getDir = html.getAttribute("dir");
const isRTL = ("rtl" == getDir);
// https://shopify.dev/docs/themes/architecture/sections/integrate-sections-with-the-theme-editor#javascript-events
const adnmEvts = {
  select: 'shopify:block:select',
  deselect: 'shopify:block:deselect',
  seSelect: 'shopify:section:select',
  seDeselect: 'shopify:section:deselect',
  seLoad: 'shopify:section:load',
  seUnload: 'shopify:section:unload',
  seReorder: 'shopify:section:reorder'
}
// try {
//   themeHDN.spStorage = ('sessionStorage' in window && window.sessionStorage !== null);
//   window.sessionStorage.setItem('hdt', 'test');
//   window.sessionStorage.removeItem('hdt');
// }
// catch (err) {
//   themeHDN.spStorage = false;
// }

// Memory leaks
var getterAdd = (ww, key, value, override = false) => {
  //console.log('override', override );
  if (!override && ww.has(key) ) return;
  //console.log('addd', !override, ww.has(key), value );
  (ww instanceof WeakSet) ? ww.add(key) : ww.set(key, value);
};
var getterGet = (wm, key, value) => {
  if ( !wm.has(key)) {
    if (value) {
      getterAdd(wm, key, value, true);
    } else {
      return false;
    }
  }
  return wm.get(key);
};
var getterRunFn = (ww, key, fn) => {
  if ( !ww.has(key)) throw TypeError(ww + "no exist");
  return fn;
};
var getterDelete = (ww, key) => {
  if ( ww.has(key)) ww.delete(key);
};
var _thu = { nvt: 1 };
// http://rocha.la/JavaScript-bitwise-operators-in-practice
function getUID(prefix = 'hdt') {
  do prefix += crypto.randomUUID ? crypto.randomUUID() : ~~(Math.random() * 1000000)
  while ($id4(prefix))
  return prefix
}
function isFunction(functionToCheck) {
  return (typeof functionToCheck === "function");
}

const JSONProducts = {};
class getJSONProduct {
  static load(productHandle, variantsPages = 1) {
    if (!productHandle) {
      return;
    }
    if (JSONProducts[productHandle]) {
      return JSONProducts[productHandle];
    }

    JSONProducts[productHandle] = new Promise(async (resolve, reject) => {
      try {
        const url = `${Shopify.routes.root}products/${productHandle}?section_id=product-variants`;

        const response = await fetch(url);
        if (!response.ok) {
          reject(`${productHandle} not loaded section variants`);
          return;
        }

        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const scriptEl = doc.getElementById('hdt-product-variants-json');

        let product;
        if (scriptEl && scriptEl.textContent) {
          product = JSON.parse(scriptEl.textContent);
        } else {
          const match = htmlText.match(/<script[^>]*id=["']hdt-product-variants-json["'][^>]*>([\s\S]*?)<\/script>/i);
          if (match && match[1]) {
            product = JSON.parse(match[1]);
          } else {
            product = JSON.parse(htmlText);
          }
        }

        resolve(product);
      } catch (error) {
        delete JSONProducts[productHandle];
        reject(error);
      }
    });

    return JSONProducts[productHandle];
  }
};

const optionsProducts = {};
class getOptionsProduct {
  static async load(productHandle, valueId = [], sectionId = '') {
    if (!productHandle) {
      return;
    }
    const vIds = valueId.join('')
    if (optionsProducts[vIds + sectionId]) {
      return optionsProducts[vIds + sectionId];
    }
    
    optionsProducts[vIds + sectionId] = (async () => {
      try {
        const response = await fetch(`${Shopify.routes.root}products/${productHandle}?option_values=${valueId.join(',')}&section_id=${sectionId}`);
        if (response.ok) {
          const responseAs = await response.text();
          return responseAs;
        } else {
          throw new Error(`${productHandle} not loaded json`);
        }
      } catch (error) {
        delete optionsProducts[vIds + sectionId];
        throw error;
      }
    })();
    
    return optionsProducts[vIds + sectionId];
  }
};

// Visibilitychange
function visibilitychangeFn(options) {
  if (!options.observes) return;
  const checkVisibility = () => {
    if (document.visibilityState === 'visible') {
      if (isFunction(options.play) && options.observes.isInview) options.play();
    } else if (isFunction(options.pause)) {
      options.pause();
    }
  }
  document.addEventListener('visibilitychange', checkVisibility);

}

/**
 * Wrap tables in a container div to make them scrollable when needed
 */
function rteWrapTable(doc = document) {
  const tables = $$4('.hdt-rte table:not(.hdt-wrapper-added)', doc);
  if (tables.length == 0) return
  tables.forEach((table) => {
    table.classList.add('hdt-wrapper-added');
    table.outerHTML = `<div class="hdt-scrollable-wrapper">${table.outerHTML}</div>`;
  });
}

/**
 * Add aria-describedby attribute to external and new window links
 */
function accessibleLinks(doc = document) {
  const { hostname } = window.location,
  links = $$4('a[href]:not([aria-describedby])', doc);
  if (links.length == 0) return;

  links.forEach((link) => {
    const isExternal  = link.hostname !== hostname,
        isTargetBlank = link.getAttribute('target') === '_blank';

    if (isTargetBlank) {
      link.setAttribute('aria-describedby', isExternal ? 'a11y-new-window-external-message' : 'a11y-new-window-message');
      const rel = link.getAttribute('rel');
      if (!rel || rel.indexOf('noopener') === -1) {
        link.setAttribute('rel',`${rel ? rel + ' '  : ''}noopener`);
      }
    } else if (isExternal) {
      link.setAttribute('aria-describedby', 'a11y-external-message');
    }
  });
}

/** Link Mylti Lang **/
function localeUrl(doc = document) {
  const {root} = Shopify.routes,
        {hostname} = window.location;
  if ( root == '/' ) return;
  $$4('a[href="/"]', doc).forEach((el) => el.setAttribute('href', root ));
  $$4(`a[href*="${hostname}/"]:not([href*="${hostname + root}"],[href*="@"],[href*="preview_theme_id="])`, doc).forEach((el) => el.setAttribute('href', el.getAttribute('href').replace( `${hostname}/`, hostname + root ) ));
};

/*
1. Component carousel
2. Component scrollsnap
3. Component scrolling text
4. Component Countdown Timer
5. Component Drawner
6. Component Modal
*/



var _config2, _userConfig2,
_mouseTrack, mouseTrack_fn,
_mouseCompare, mouseCompare_fn,
_mouseenterHandler, mouseenterHandler_fn,
_mouseleaveHandler, mouseleaveHandler_fn,
_handleHover, handleHover_fn,
_defaultOptions2,
_timeoutId,
_onEnter,
_onExit,
_elem2,
_keyid;
class HoverIntent {
  constructor(elem, userConfig, keyid) {
    //this.elem = elem;
    const keyid_ = { key:keyid || elem }
    this.keyid_ = keyid_;
    getterAdd(_keyid, keyid_, keyid_);
    getterAdd(_elem2, keyid_, elem);
    getterAdd(_userConfig2, keyid_, userConfig);
    getterAdd(_mouseTrack, keyid_, mouseTrack_fn.bind(this));
    getterAdd(_mouseCompare, keyid_);
    getterAdd(_handleHover, keyid_);
    getterAdd(_mouseenterHandler, keyid_);
    getterAdd(_mouseleaveHandler, keyid_);
    getterAdd(_timeoutId, keyid_, void 0);
    getterAdd(_onEnter, keyid_);
    getterAdd(_onExit, keyid_);
    // console.log(_elem2)
    // this.init();
    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    // this.cX
    // this.cY
    // if (!this.config || !this.config.onEnter || !this.config.onExit) {
    //   throw 'onEnter and onExit callbacks must be provided';
    // }

    // holds current element state
    getterGet(_elem2, keyid_).isActive = false;
    getterGet(_elem2, keyid_)?.addEventListener('mouseenter', getterRunFn(_handleHover, keyid_, handleHover_fn).bind(this, keyid_) );
    getterGet(_elem2, keyid_)?.addEventListener('mouseleave', getterRunFn(_handleHover, keyid_, handleHover_fn).bind(this, keyid_) );
  }
  get config() {
    return getterGet(_config2, getterGet(_keyid, this.keyid_) , Object.assign(getterGet(_defaultOptions2, _thu), getterGet(_userConfig2, getterGet(_keyid, this.keyid_))));
  }
}
_keyid = new WeakMap();
_config2 = new WeakMap();
_userConfig2 = new WeakMap();
_mouseTrack = new WeakMap();
_mouseCompare = new WeakSet();
_mouseenterHandler = new WeakSet();
_mouseleaveHandler = new WeakSet();
_handleHover = new WeakSet();
_defaultOptions2 = new Map();
getterAdd(_defaultOptions2, _thu, {
  exitDelay: 0,
  interval: 100,
  sensitivity: 6
});
_timeoutId = new WeakMap();
_elem2 = new WeakMap();
_onEnter = new WeakSet();
_onExit = new WeakSet();

// saves the current pointer position coordinates based on the given mousemove event
mouseTrack_fn = function(ev) {
  this.cX = ev.pageX;
  this.cY = ev.pageY;
};
// compares current and previous mouse positions
mouseCompare_fn = function(elem2, keyid_) {
  if (Math.sqrt( (this.prevX - this.cX)*(this.prevX - this.cX) + (this.prevY - this.cY)*(this.prevY - this.cY) ) < this.config.sensitivity) {

    elem2?.removeEventListener('mousemove', getterGet(_mouseTrack, keyid_));
    //delete this.timeoutId;
    getterDelete(_timeoutId, keyid_);

    if (elem2.isActive) {
      this.config.onExit(elem2);
      //getterRunFn(_onExit, this, this.config.onExit).call(elem2);
      elem2.isActive = false;
    }
    // set hoverIntent state as active for this element (permits `out` handler to trigger)
    elem2.isActive = true;
    // overwrite old mouseenter event coordinates with most recent pointer position
    this.ev.pageX = this.cX;
    this.ev.pageY = this.cY;
    delete this.prevX;
    delete this.prevY;
    // trigger hover
    return this.config.onEnter(elem2);
    //return getterRunFn(_onEnter, this, this.config.onEnter).call(elem2);
    // elem2?.addEventListener('mouseleave', this._mouseleaveHandler );
  } else {
    //  set previous coordinates for next comparison
    this.prevX = this.cX;
    this.prevY = this.cY;
    // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
    getterAdd(_timeoutId, keyid_, setTimeout(() => {
      getterRunFn(_mouseCompare, keyid_, mouseCompare_fn).call(this, elem2, keyid_);
    }, this.config.interval), true);
    // this.timeoutId = setTimeout(() => {
    //   getterRunFn(_mouseCompare, this, mouseCompare_fn).call(this);
    // }, this.config.interval);
  }
};
mouseenterHandler_fn = function(elem2, keyid_) {
  // do nothing if already active
  //clearTimeout(this.pollTimer);
  if (elem2.isActive) {
    //clearTimeout(this.exitTimer);
    return;
  }
  // set "previous" X and Y position based on initial entry point
  this.prevX = this.ev.pageX;
  this.prevY = this.ev.pageY;

  // update "current" X and Y position based on mousemove
  elem2?.removeEventListener('mousemove', getterGet(_mouseTrack, keyid_));
  elem2?.addEventListener('mousemove', getterGet(_mouseTrack, keyid_, mouseTrack_fn.bind(this)));

  // start polling interval (self-calling timeout) to compare mouse coordinates over time
  // this.timeoutId = setTimeout(() => {
  //   getterRunFn(_mouseCompare, this, mouseCompare_fn).call(this);
  // }, this.config.interval);
  getterAdd(_timeoutId, keyid_, setTimeout(() => {
    getterRunFn(_mouseCompare, keyid_, mouseCompare_fn).call(this, elem2, keyid_);
  }, this.config.interval), true);
};
mouseleaveHandler_fn = function(elem2, keyid_) {
  //clearTimeout(this.exitTimer);
  // do nothing if not already active
  if (!elem2.isActive) return;
  //clearTimeout(this.pollTimer);
  // unbind expensive mousemove event
  elem2?.removeEventListener('mousemove', getterGet(_mouseTrack, keyid_));
  // this.timeoutId = setTimeout(() => {
  //   this.config.onExit(elem2);
  //   elem2.isActive = false;
  //   //elem2?.removeEventListener('mouseleave', this._mouseleaveHandler );
  // }, this.config.exitDelay);
  getterAdd(_timeoutId, keyid_, setTimeout(() => {
    this.config.onExit(elem2);
    //getterRunFn(_onExit, this, this.config.onExit).call(elem2);
    //console.log('elem2', elem2, this.config)
    elem2.isActive = false;
  }, this.config.exitDelay), true);
};
handleHover_fn = function(keyid_, e) {
  // cloned event to pass to handlers (copy required for event object to be passed in IE)
  this.ev = Object.assign({}, e);
  // clear any existing timeout
  //if (this.timeoutId) { this.timeoutId = clearTimeout(this.timeoutId); }
  getterAdd(_timeoutId, keyid_, clearTimeout(getterGet(_timeoutId, keyid_)), true);
  getterRunFn((e.type === 'mouseenter') ? _mouseenterHandler : _mouseleaveHandler , keyid_, (e.type === 'mouseenter') ? mouseenterHandler_fn : mouseleaveHandler_fn ).call(this, getterGet(_elem2, keyid_), keyid_);
};
// 1. Component carousel
// https://codesandbox.io/s/embla-carousel-github-issue-39-forked-p6sn2g?file=/src/css/embla.css
// https://www.embla-carousel.com/plugins/auto-height
import { Carousel, ClassNames, AutoHeight, navUICenter, Autoplay, navHandlers, dotHandlers, Delegate, animate, scroll, timeline, inView, stagger } from "@theme/libs";
//import ClassNames from 'slider-autoplay'
Carousel.globalOptions = { direction: getDir }

var _slider_classes = {
  noSlides   : 'is-no-slides',
  prepared   : 'is--prepared',
  enabled    : 'is--enabled'
},
_slider_defaults = {
  loop: false,
  align: 'start',
  containScroll: 'trimSnaps', //keepSnaps
  skipSnaps: true,
  watchSlides: false,
  //watchResize: false,
  // watchResize: (sliderApi) => {
  //   this.classList.remove(_slider_classes.enabled);
  //   return true;
  // },
  watchDrag: 'smart',
  slidesToScroll: 'auto',
  inViewThreshold: 0.5, // 0.25 A high view threshold is recommended.
  classNames: true, // nathan custom
  autoHeight: false, // nathan custom
  autoPlay: 0, // nathan custom
  //stopOnInteraction: false,
  pauseOnHover: false,
  // isMedia: false, // nathan custom
  // thumbNav: false, // nathan custom
  // thumbVertical: false, // nathan custom
  navUI: false, // nathan custom
  navUICenter: false, // nathan custom
  dotUI: false, // nathan custom
  controlUI: false, // nathan custom
  //sliderApi: false, // nathan custom
  a11ySlide: true, // nathan custom
  a11yKeyBoard: true, // nathan custom
  a11yControls: true, // nathan custom
  // max: true, // nathan custom, option of navUICenter
  inView: 'is-in-view'
},
_delegate1, _control_ui, control_ui_fn,
_control_slider, control_slider_fn,
_control_items,
_slider_api, _options_slider,
_toggle_slider_ready, toggle_slider_ready_fn,
_destroy_slider, destroy_slider_fn,
_on_select_slider, on_select_slider_fn,
str_slide = 'hdt-slider__slide';
//_on_settle_slider = new WeakSet(), on_settle_slider_fn;
class Slider extends HTMLElement {
  constructor() {
    super();
    getterAdd(_control_ui, this);
    getterAdd(_delegate1, this, new Delegate(document.body));
    getterAdd(_toggle_slider_ready, this);
    getterAdd(_destroy_slider, this);
    getterAdd(_on_select_slider, this);
    getterAdd(_control_slider, this);
    getterAdd(_options_slider, this, Object.assign( {}, _slider_defaults, JSON.parse(this.getAttribute("config") || '{}') ));
    getterAdd(_control_items, this, $$4(`[hdt-slider-controls][aria-controls="${this.id}"] > button`));
   // getterAdd(_on_settle_slider, this);

    if (getterGet(_options_slider, this).watchDrag == 'onlyTypeImage') {
      getterGet(_options_slider, this).watchDrag = (sliderApi, event) => {
        //console.log(sliderApi)
        const media = event.target.closest('[data-media-type]');
        return media ? media.getAttribute('data-media-type') == 'image' : true;
      }
    } else if (getterGet(_options_slider, this).watchDrag == 'smart') {
      getterGet(_options_slider, this).watchDrag = (sliderApi, event) => {
        //console.log(sliderApi)
        //return sliderApi.internalEngine().slideLooper.canLoop();
        return sliderApi.scrollSnapList().length > 1;
      }
    }
    // https://github.com/The4-Theme-Dev/Ecomus/issues/65
    if (getterGet(_options_slider, this).watchResize == '#65') {
      getterGet(_options_slider, this).watchResize = (sliderApi, entries) => {
        //console.log(sliderApi)
        for (const entry of entries) {
          //console.log('sss entry00', entry.contentRect.height, entry.target.prevHeight)
          if (sliderApi.containerNode() === entry.target && entry.contentRect.height != entry.target.prevHeight ) {
            entry.target.prevHeight = entry.contentRect.height;
            return true;
          } else if (sliderApi.containerNode() === entry.target) {
            return false;
          }
          //console.log('sss entry 1111')
          window.requestAnimationFrame(() => {
            sliderApi.reInit();
            sliderApi.emit('resize');
          })
          break;
        }
        return false;
      }
    }

    if (!this.id) this.id = getUID();
  }
  /**
   * scroll to custom
   */
  // scrollToTarget(target, bl) {
  //   getterGet(_slider_api, this).scrollTo(getterGet(_slider_api, this).slideNodes().indexOf(target), bl || !matchMediaQuery("motion"));
  // }
  // scrollToIndex(index, bl) {
  //   getterGet(_slider_api, this).scrollTo(parseInt(index), bl || !matchMediaQuery("motion"));
  // }
  goToTarget(target, bl) {
    if (this.aceDeferredOwner) this.aceStartNativeSlider();
    this.goToIndex(getterGet(_slider_api, this).slideNodes().indexOf(target), bl || !matchMediaQuery("motion"));
  }
  goToIndex(slideIndex, bl) {
    if (this.aceDeferredOwner) this.aceStartNativeSlider();
    let i, j = parseInt(slideIndex);
    const snapListLength = getterGet(_slider_api, this).scrollSnapList().length;
    if (getterGet(_slider_api, this).slideNodes().length !== snapListLength) {
      const {slideRegistry} = getterGet(_slider_api, this).internalEngine();
      for (i = 0; i < slideRegistry.length; i++) {
        //console.log(i, snapListLength - 1 )
        if (slideRegistry[i].indexOf(j) > -1) { j = i; break; }
      }
    }
    getterGet(_slider_api, this).scrollTo(Math.min(j, snapListLength - 1), bl || !matchMediaQuery("motion"));
  }
  get isActive() {
    if (this.aceDeferredOwner) this.aceStartNativeSlider();
    return getterGet(_slider_api, this).internalEngine().options.active;
  }
  // get indexSelected() {
  //   return getterGet(_slider_api, this).selectedScrollSnap();
  // }
  reInit(options = {}) {
    if (this.aceDeferredOwner) this.aceStartNativeSlider();
    getterGet(_slider_api, this).reInit(options);
  }

  aceAutoplayIsPlaying() {
    return Boolean(getterGet(_slider_api, this)?.plugins?.()?.autoplay?.isPlaying());
  }
  aceSetAutoplay(playing) {
    const autoplay = getterGet(_slider_api, this)?.plugins?.()?.autoplay;
    if (!autoplay) return;
    this.aceAutoplayPaused = !playing;
    autoplay[playing ? 'play' : 'stop']();
    this.dispatchEvent(new CustomEvent('ace:autoplay-change', { bubbles: true }));
  }


  // ACE: defer only explicitly marked lower homepage rows; keep the native engine.
  aceCancelStartup() {
    this.aceStartupObserver?.disconnect();
    this.aceStartupObserver = null;
    if (this.aceStartupWake) {
      for (const event of ['pointerdown', 'mousedown', 'touchstart', 'focusin', 'keydown']) {
        this.removeEventListener(event, this.aceStartupWake, true);
      }
      this.aceStartupWake = null;
    }
  }
  aceScheduleStartup() {
    if (this.aceSliderStarted || this.aceSliderStarting || this.aceStartupObserver) return;
    if (typeof window.IntersectionObserver !== 'function') {
      this.aceStartNativeSlider();
      return;
    }
    this.aceStartupWake = () => this.aceStartNativeSlider();
    for (const event of ['pointerdown', 'mousedown', 'touchstart', 'focusin', 'keydown']) {
      this.addEventListener(event, this.aceStartupWake, {capture: true, passive: true});
    }
    this.aceStartupObserver = new IntersectionObserver((entries) => {
      if (this.closest('[tab-item]:not([tab-selected])')) return;
      if (entries.some(entry => entry.isIntersecting && entry.boundingClientRect.width > 0 && entry.boundingClientRect.height > 0)) this.aceStartNativeSlider();
    }, {rootMargin: '320px 0px'});
    this.aceStartupObserver.observe(this);
  }
  connectedCallback() {
    if (this.localName === 'hdt-slider' && this.hasAttribute('data-ace-start-on-approach') && !Shopify.designMode) {
      this.aceDeferredOwner = true;
      this.aceScheduleStartup();
      return;
    }
    this.aceStartNativeSlider();
  }
  aceStartNativeSlider() {
    if (this.aceDeferredOwner) {
      if (!this.isConnected || this.aceSliderStarted || this.aceSliderStarting) return;
      this.aceSliderStarting = true;
      this.aceCancelStartup();
    }
    try {

    // Adding plugins
    const plugins = [];
    if (getterGet(_options_slider, this).classNames) plugins.push( ClassNames({inView: 'is-in-view'}) );
    const aceMobileProductHeight = document.body.classList.contains('hdt-page-type-index') && this.classList.contains('hdt-slider__products');
    if (getterGet(_options_slider, this).autoHeight) plugins.push(AutoHeight());
    else if (aceMobileProductHeight) plugins.push(AutoHeight({active: false, breakpoints: {'(max-width: 767px)': {active: true}}, destroyHeight: ''}));
    if (getterGet(_options_slider, this).navUI && getterGet(_options_slider, this).navUICenter) plugins.push( navUICenter() ); // { max: getterGet(_options_slider, this).max}
    if (getterGet(_options_slider, this).autoPlay) {
      const autoplayOptions = {
        delay: getterGet(_options_slider, this).autoPlay,
        //stopOnInteraction: getterGet(_options_slider, this).stopOnInteraction,
        stopOnInteraction: this.hasAttribute('data-ace-autoplay-controls'),
        playOnInit: !this.hasAttribute('data-ace-autoplay-controls') || (!this.aceAutoplayPaused && !matchMedia('(prefers-reduced-motion: reduce)').matches),
        stopOnMouseEnter: getterGet(_options_slider, this).pauseOnHover && (!this.hasAttribute('data-ace-autoplay-controls') || matchMediaQuery('hover'))
      }
      plugins.push( Autoplay(autoplayOptions) );
    }
    getterAdd(_slider_api, this, Carousel($4('.hdt-slider__viewport', this) || this, getterGet(_options_slider, this), plugins), this.aceDeferredOwner === true);
    if (this.hasAttribute('data-ace-autoplay-controls')) {
      const syncAutoplay = () => queueMicrotask(() => {
        this.aceAutoplayPaused = !this.aceAutoplayIsPlaying();
        this.dispatchEvent(new CustomEvent('ace:autoplay-change', { bubbles: true }));
      });
      getterGet(_slider_api, this).on('autoplay:play', syncAutoplay).on('autoplay:stop', syncAutoplay);
    }
    // Need test, debug
    // this.sliderApi = getterGet(_slider_api, this);
    //if (getterGet(_options_slider, this).sliderApi) this.sliderApi = getterGet(_slider_api, this);
    getterGet(_slider_api, this)
    .on("init", getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(this))
    .on("resize", getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(this))
    .on("reInit", getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(this))
    .on("select", getterRunFn(_on_select_slider, this, on_select_slider_fn).bind(this))
    //.on("settle", getterRunFn(_on_settle_slider, this, on_settle_slider_fn).bind(this))
    .on("destroy", getterRunFn(_destroy_slider, this, destroy_slider_fn).bind(this))
    .on("init", (sliderApi, eventName)=> {
      this.dispatchEvent(new CustomEvent("init:slide", { bubbles: false, detail: { sliderApi, eventName } }));
    })
    .on("reInit", (sliderApi, eventName)=> {
      this.dispatchEvent(new CustomEvent("init:slide", { bubbles: false, detail: { sliderApi, eventName } }));
    });

    // Adding event
    if (getterGet(_options_slider, this).navUI) {
      const nextBtns = $$4(`button[name="next"][aria-controls="${this.id}"]`);
       $$4(`button[name="previous"][aria-controls="${this.id}"]`).forEach((prevBtn, index) => {
        if (prevBtn && nextBtns[index]) {
          const removePrevNextBtnsClickHandlers = navHandlers( getterGet(_slider_api, this), prevBtn, nextBtns[index]);
          getterGet(_slider_api, this).on('destroy', removePrevNextBtnsClickHandlers);
        }
      });
    }
    if (getterGet(_options_slider, this).dotUI) {
      $$4(`[hdt-slider-dots][aria-controls="${this.id}"]`).forEach((dotWrapp) => {
        if (dotWrapp) {
          const removeDotBtnsAndClickHandlers = dotHandlers( getterGet(_slider_api, this), dotWrapp );
          getterGet(_slider_api, this).on('destroy', removeDotBtnsAndClickHandlers);
        }
      });
    }
    if (getterGet(_options_slider, this).controlUI && getterGet(_control_items, this).length > 0) {
      getterGet(_delegate1,this).on("click", `[hdt-slider-controls][aria-controls="${this.id}"] > button`, getterRunFn(_control_slider, this, control_slider_fn).bind(this));
      getterGet(_slider_api, this)
      .on("init", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
      .on("reInit", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
      .on("select", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
      .on("destroy", getterRunFn(_control_ui, this, control_ui_fn).bind(this));
    }
    if (this.hasAttribute('modal-reint') ) {
      const modal = $id4('hdt-quick-view-modal') || $id4('hdt-quick-add-modal');
      modal?.addEventListener(dialogOpening, ()=> {
        this.reInit(getterGet(_options_slider, this));
      }, { once: true });
    }
    if (getterGet(_options_slider, this).closePopover) {
      // https://github.com/davidjerleke/embla-carousel/discussions/738
      const settlePixelThreshold = 10
      const fireCustomSettle = (sliderApi) => {
        const { dragHandler, location, target } = sliderApi.internalEngine();
        if (dragHandler.pointerDown()) return; // Bail if user is dragging

        const displacement = target.get() - location.get()
        if (Math.abs(displacement) > settlePixelThreshold) {
          $$4(`hdt-popover[data-change="${this.id}"] dialog[open]`).forEach( (popover)=> {
            popover?.parentElement.close();
          });
        }
      }
      getterGet(_slider_api, this).on("scroll", fireCustomSettle);
    }
    if (Shopify.designMode) {
      this.addEventListener(adnmEvts.select, (event) => {
        let target = event.target;
        //console.log('adnmEvts.select', event.detail, getterGet(_slider_api, this).slideNodes().indexOf(event.target))
        if (!target.classList.contains(str_slide)) target = target.closest(`.${str_slide}`);
        this.goToTarget( target, event.detail.load );
        // setTimeout(() => {
        //   getterGet(_slider_api, this).scrollTo( getterGet(_slider_api, this).slideNodes().indexOf(event.target), event.detail.load );
        // }, event.detail.load ? 10 : 0);
      });
    }
    if (this.aceDeferredOwner) this.aceSliderStarted = true;
    } finally {
      if (this.aceDeferredOwner) this.aceSliderStarting = false;
    }
  }
  disconnectedCallback() {
    if (this.aceDeferredOwner) this.aceCancelStartup();
    if (getterGet(_slider_api, this)) getterGet(_slider_api, this).destroy();
    if (this.aceDeferredOwner) this.aceSliderStarted = false;
  }
}
_slider_api = new WeakMap();
_options_slider = new WeakMap();
_delegate1 = new WeakMap();
_control_items = new WeakMap();
_toggle_slider_ready = new WeakSet();
toggle_slider_ready_fn = function(sliderApi, event) {
  const isResizeEvent = (event === "resize");
  //console.log('event', event, sliderApi.rootNode() )
  const toggleClass = isResizeEvent ? "remove" : "add",
        isFade      = this.hasAttribute('isfade');
  this.classList[toggleClass](_slider_classes.enabled);
  //setTimeout(() => this.classList.add(_slider_classes.enabled));
  if (isResizeEvent && isFade ) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => { sliderApi.reInit(); }, 4);
  }
  if ( !isResizeEvent && isFade ) {
    // Inactivate transform
    sliderApi.internalEngine().translate.toggleActive(false);
    sliderApi.internalEngine().translate.clear();
  }
};
_destroy_slider = new WeakSet();
destroy_slider_fn= function() {
  //clearTimeout(this.timeout);
  this.classList.remove(_slider_classes.enabled);
  getterGet(_delegate1,this).off();
};
_control_ui = new WeakSet();
control_ui_fn = function(slider_api) {
  if (!this.isActive) return;
  const indexSelected = slider_api.selectedScrollSnap();
  getterGet(_control_items, this).forEach((item) => item.setAttribute("aria-current", item.value == indexSelected));
};
_control_slider = new WeakSet();
control_slider_fn = function(event, target) {
  if (target.getAttribute("aria-current") !== "true") this.goToIndex(target.value);
};
_on_select_slider = new WeakSet();
on_select_slider_fn = function(sliderApi, eventName) {
  //console.log(sliderApi, eventName)
  this.dispatchEvent(new CustomEvent(`${eventName}:slide`, { bubbles: false, detail: { sliderApi, eventName } }));
};
// on_settle_slider_fn = function(sliderApi, event) {
//   const { limit, location, scrollTo } = sliderApi.internalEngine();
//   if (location.get() > limit.max) {
//     scrollTo.index(0, 0);
//   }
//   if (location.get() < limit.min) {
//     scrollTo.index(sliderApi.scrollSnapList().length - 1, 1);
//   }
// };

class SliderLazy extends Slider {
  constructor() { super(); }
  connectedCallback() { }
  InitLazy() { super.connectedCallback(); }
};

var _slideshow_animate, slideshow_animate_fn;
class SlideShow extends Slider {
  constructor() {
    super();
    getterAdd(_slideshow_animate, this);
  }
  connectedCallback() {
    super.connectedCallback();
    getterGet(_slider_api, this).on( 'init', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
    getterGet(_slider_api, this).on( 'reInit', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
    getterGet(_slider_api, this).on( 'select', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
    getterGet(_slider_api, this).on( 'destroy', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
  }
  isVisible(element) {
    // https://stackoverflow.com/questions/1343237/how-to-check-elements-visibility-via-javascript
    return element.offsetWidth > 0 || element.offsetHeight > 0;;
  }
}
_slideshow_animate = new WeakSet();
slideshow_animate_fn = function(sliderApi) {
  const index = sliderApi.selectedScrollSnap(),
  prevIndex = sliderApi.previousScrollSnap(),
  reveals = $$4('[reval]', sliderApi.slideNodes()[index]),
  prevReveals = $$4('[reval]', sliderApi.slideNodes()[prevIndex]),
  revealsVisible = reveals.filter((el) => this.isVisible(el)),
  prevRevealsVisible = prevReveals.filter((el) => this.isVisible(el));
  if (revealsVisible.length == 0) return;
  animate(revealsVisible, {
    opacity: [0, 1], transform: ["translateY(150px)", "translateY(0)"]
  }, {
    duration: 0.25,
    easing: "ease",
    delay: stagger(0.15, { start: 0.4, easing: [0, 0.87, 0.58, 1] })
  });
  if (prevRevealsVisible.length > 0 && index != prevIndex) {
    animate(prevRevealsVisible, {
    opacity: [1, 0], transform: ["translateY(0)", "translateY(25px)"]
    }, {
      duration: 0.15,
      easing: "ease",
      delay: stagger(0.1, { start: 0.4, easing: [0, 0.87, 0.58, 1] })
    });
  }
};

var _slider_sync_control = new WeakMap(),
_slider_sync_select, slider_sync_select_fn,
_slider_sync_control_select, slider_sync_control_select_fn;
class SliderSync extends Slider {
  constructor() {
    super();
    getterAdd(_slider_sync_control, this, $id4(this.getAttribute("aria-controls")));
    getterAdd(_slider_sync_select, this);
    getterAdd(_slider_sync_control_select, this);
  }
  connectedCallback() {
    //console.log(super)
    super.connectedCallback();

    if ( !getterGet(_slider_api, getterGet(_slider_sync_control, this)) ) return;

    getterGet(_slider_api, getterGet(_slider_sync_control, this)).on( 'select', getterRunFn(_slider_sync_control_select, this, slider_sync_control_select_fn).bind(this) );
    getterGet(_slider_api, this).on( 'select', getterRunFn(_slider_sync_select, this, slider_sync_select_fn).bind(this) );

    getterGet(_slider_api, getterGet(_slider_sync_control, this)).on( 'destroy', () => {
      getterGet(_slider_api, this).off( 'select', getterRunFn(_slider_sync_select, this, slider_sync_select_fn).bind(this) );
    });
    getterGet(_slider_api, this).on( 'destroy', () => {
      getterGet(_slider_api, getterGet(_slider_sync_control, this)).off( 'select', getterRunFn(_slider_sync_control_select, this, slider_sync_control_select_fn).bind(this) );
    });
    // getterGet(_slider_api, getterGet(_slider_sync_control, this)).on("scroll", (sliderApi) => {
    //   console.log('sliderObservesApi scroll')
    //   const emblaMainLocation = sliderApi.internalEngine().location.get();
    //   const emblaCopyCatEngine = getterGet(_slider_api, this).internalEngine();

    //   emblaCopyCatEngine.translate.to(emblaMainLocation);
    //   emblaCopyCatEngine.location.set(emblaMainLocation);
    //   emblaCopyCatEngine.target.set(emblaMainLocation);
    //   emblaCopyCatEngine.scrollTo.distance(0, false);
    // });
    // getterGet(_slider_api, this).on("scroll", (sliderApi) => {
    //   console.log('sliderApi scroll')
    //   const emblaMainLocation = sliderApi.internalEngine().location.get();
    //   const emblaCopyCatEngine = getterGet(_slider_api, getterGet(_slider_sync_control, this)).internalEngine();

    //   emblaCopyCatEngine.translate.to(emblaMainLocation);
    //   emblaCopyCatEngine.location.set(emblaMainLocation);
    //   emblaCopyCatEngine.target.set(emblaMainLocation);
    //   emblaCopyCatEngine.scrollTo.distance(0, false);
    // });
  }
}
_slider_sync_select = new WeakSet();
slider_sync_select_fn = function(slider_api) {
  if (getterGet(_slider_api, getterGet(_slider_sync_control, this)).selectedScrollSnap() != slider_api.selectedScrollSnap()) getterGet(_slider_api, getterGet(_slider_sync_control, this)).scrollTo( slider_api.selectedScrollSnap() );
}
_slider_sync_control_select = new WeakSet();
slider_sync_control_select_fn = function(slider_api) {
  if (getterGet(_slider_api, this).selectedScrollSnap() != slider_api.selectedScrollSnap()) getterGet(_slider_api, this).scrollTo( slider_api.selectedScrollSnap() );
}

var _slider_thumbs_control = new WeakMap(),
_add_thumb_btns_click_handlers, add_thumb_btns_click_handlers_fn,
_add_toggle_thumb_btns_active, add_toggle_thumb_btns_active_fn;
class SlideThumb extends Slider {
  // constructor() {
  //   super();
  // }
  connectedCallback() {
    getterAdd(_slider_thumbs_control, this, $id4(this.getAttribute("aria-controls")));
    if (this.hasAttribute('stagger')) {
      animate(
        $$4('[reval]', this),
        {
          opacity: [0, 1],
          transform: ["scale(.5) rotate(90deg) skew(15deg)", "scale(1) rotate(0deg) skew(0deg)"]
        },
        {
          duration: 0.2,
          delay: stagger(0.3, { easing: "ease-out" })
        }
      ).finished.then(() => {
        this.classList.add('stagger-finished');
      });
    }
    if ( !getterGet(_slider_thumbs_control, this) ) return;
    super.connectedCallback();
    const sliderApiMain = getterGet(_slider_api, getterGet(_slider_thumbs_control, this)),
    sliderApiThumb = getterGet(_slider_api, this);
    if ( !matchMediaQuery("mobile") && !matchMediaQuery("tablet") ) sliderApiThumb.containerNode().style.setProperty('max-height',`${sliderApiMain.slideNodes()[sliderApiMain.selectedScrollSnap()].clientHeight + 10}px`);
    getterAdd(_add_thumb_btns_click_handlers, this);
    getterAdd(_add_toggle_thumb_btns_active, this);

    const removeThumbBtnsClickHandlers = getterRunFn(_add_thumb_btns_click_handlers, this, add_thumb_btns_click_handlers_fn).call(this, sliderApiMain, sliderApiThumb);
    const removeToggleThumbBtnsActive = getterRunFn(_add_toggle_thumb_btns_active, this, add_toggle_thumb_btns_active_fn).call(this, sliderApiMain, sliderApiThumb);
    sliderApiMain.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
    sliderApiThumb.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
  }
}
_add_thumb_btns_click_handlers = new WeakSet();
add_thumb_btns_click_handlers_fn = function(_, sliderApiThumb) {
  const slides = $$4('.hdt-slider__slide', this);
  const scrollToIndex = (slideNode) => {
    const index = sliderApiThumb.slideNodes().indexOf(slideNode);
    if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  };
  slides.forEach( (slideNode) => slideNode.addEventListener('click', scrollToIndex.bind(this, slideNode), false) );
  return () => {
    slides.forEach((slideNode) => slideNode.removeEventListener('click', scrollToIndex.bind(this, slideNode), false) );
  }

  // $$4('.hdt-slider__slide', this).forEach((slideNode) => {
  //   slideNode.addEventListener('click', ()=> {
  //     const index = sliderApiThumb.slideNodes().indexOf(slideNode);
  //     if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  //     //if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  //   }, false)
  // });

  // return () => {
  //   // slidesThumbs.forEach((slideNode, index) => {
  //   //   slideNode.removeEventListener('click', scrollToIndex[index], false)
  //   // })
  //   $$4('.hdt-slider__slide', this).forEach((slideNode) => {
  //     slideNode.addEventListener('click', ()=> {
  //       const index = sliderApiThumb.slideNodes().indexOf(slideNode);
  //       if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  //     }, false)
  //   });
  // }
};
_add_toggle_thumb_btns_active = new WeakSet();
add_toggle_thumb_btns_active_fn = function(sliderApiMain, sliderApiThumb) {
  //const slidesThumbs = sliderApiThumb.slideNodes();
  const toggleThumbBtnsState = () => {
    this.goToIndex(sliderApiMain.selectedScrollSnap());
    //const previous = sliderApiMain.previousScrollSnap()
    //slidesThumbs[previous].classList.remove('is-thumb-selected');
    $4('.is-thumb-selected', this)?.classList.remove('is-thumb-selected');
    sliderApiThumb.slideNodes()[sliderApiMain.selectedScrollSnap()].classList.add('is-thumb-selected');
    //if ( !matchMediaQuery("mobile") && !matchMediaQuery("tablet") ) sliderApiThumb.containerNode().style.setProperty('max-height',`${sliderApiMain.slideNodes()[sliderApiMain.selectedScrollSnap()].clientHeight + 10}px`);
  }

  sliderApiMain.on('select', toggleThumbBtnsState)
  sliderApiThumb.on('init', toggleThumbBtnsState)
  sliderApiThumb.on('reInit', toggleThumbBtnsState)

  return () => {
    sliderApiThumb.slideNodes()[sliderApiMain.selectedScrollSnap()].classList.remove('is-thumb-selected');
  }
};
var _slider_counter = new WeakMap(),
_update_total_counter, update_total_counter_fn,
_update_current_counter, update_current_counter_fn;
class SlideCounter extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_update_total_counter, this);
    getterAdd(_update_current_counter, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    getterAdd(_slider_counter, this, $id4(this.getAttribute('slider')));

    if (!getterGet(_slider_counter, this)) return;
    const {signal} = this.#abortController;
    getterGet(_slider_api, getterGet(_slider_counter, this)).on('init', getterRunFn(_update_total_counter, this, update_total_counter_fn).bind(this), { signal })
    getterGet(_slider_api, getterGet(_slider_counter, this)).on('reInit', getterRunFn(_update_total_counter, this, update_total_counter_fn).bind(this), { signal })
    getterGet(_slider_api, getterGet(_slider_counter, this)).on('select', getterRunFn(_update_current_counter, this, update_current_counter_fn).bind(this), { signal })
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get total() {
    return $4('[update-total]', this);
  }
  get current() {
    return this._current = this._current || $4('[update-current]', this);
  }
};
_update_total_counter = new WeakSet();
update_total_counter_fn = function(sliderApi) {
  if (!getterGet(_slider_counter, this).isActive) return;
  this.total.textContent = sliderApi.scrollSnapList().length;
  getterRunFn(_update_current_counter, this, update_current_counter_fn).call(this, sliderApi);
};
_update_current_counter = new WeakSet();
update_current_counter_fn = function(sliderApi) {
  this.current.textContent = sliderApi.selectedScrollSnap() + 1;
};

customElements.define('hdt-slider', Slider);
customElements.define('hdt-slider-lazy', SliderLazy);
customElements.define('hdt-slideshow', SlideShow);
customElements.define('hdt-slider-sync', SliderSync);
customElements.define('hdt-slider-thumb', SlideThumb);
customElements.define('hdt-slider-counter', SlideCounter);

// 2. Component scrollsnap
class Scrollnap extends HTMLElement {
  constructor() {
    super();
    this.slider = $4('[id^="Scroller-"]',this) || this;
    this.sliderItems = $$4('[id^="Scroll-"]',this);
    this.enableSliderLooping = false;
    this.currentPageElement = $4('.hdt-scrollsnap-counter--current',this);
    this.pageTotalElement = $4('.hdt-scrollsnap-counter--total',this);
    this.prevButton = $4('button[name="previous"]',this);
    this.nextButton = $4('button[name="next"]',this);
    this.dotButtons =  $$4('.hdt-scrollsnap-dot__link',this);
    this.sliderFirstItemNode = this.sliderItems[0];

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    //this.setSlideVisibility();
    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.dotButtons.length) {
      this.dotButtons.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    }
  }

  get isScrollable() {
    //this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight
    return this.slider.scrollWidth !== this.slider.clientWidth;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.classList.toggle("is-scrollable", this.isScrollable);
  }

  resetPages() {
    this.sliderItems = $$4('[id^="Scroll-"]', this);
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;
    //if (!this.slider || !this.nextButton) return;
    //this.setSlideVisibility();
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.dotButtons.length) {
      this.dotButtons.forEach((link) => {
        link.classList.remove('hdt-scrollsnap-dot__link--active');
        link.removeAttribute('aria-current');
      });
      //console.log(this.currentPage)
      this.dotButtons[this.currentPage - 1]?.classList.add('hdt-scrollsnap-dot__link--active');
      this.dotButtons[this.currentPage - 1]?.setAttribute('aria-current', true);
    }

    if (this.enableSliderLooping || !this.nextButton ) return;
    //console.log(this.isSlideVisible(this.sliderItemsToShow[0]), this.slider.scrollLeft)
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.dotButtons.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.setSlidePosition(slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: matchMediaQuery("motion") ? "smooth" : "auto"
    });
  }

  // setSlideVisibility(event) {
  //   this.sliderItemsToShow.forEach((item, index) => {
  //     const linkElements = item.querySelectorAll('a');
  //     if (index === this.currentPage - 1) {
  //       if (linkElements.length)
  //         linkElements.forEach((button) => {
  //           button.removeAttribute('tabindex');
  //         });
  //       item.setAttribute('aria-hidden', 'false');
  //       item.removeAttribute('tabindex');
  //     } else {
  //       if (linkElements.length)
  //         linkElements.forEach((button) => {
  //           button.setAttribute('tabindex', '-1');
  //         });
  //       item.setAttribute('aria-hidden', 'true');
  //       item.setAttribute('tabindex', '-1');
  //     }
  //   });
  //   this.wasClicked = false;
  // }

}
customElements.define('hdt-scrollsnap', Scrollnap);

class ScrollBar extends HTMLElement {
  connectedCallback() {
    if (!this.scrolledElement) return;
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }
  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || $id4(this.getAttribute("observes"));
  }
  _updateScrollProgress() {
    const scrollLeft = !isRTL ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft),
    advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
    this.style.setProperty("--scrollbar-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
  }
};
customElements.define("hdt-scrollbar", ScrollBar);

class wrappCloseBtn extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:forceClose", { bubbles: true, cancelable: true, composed: true })));
  }
};
customElements.define("wrapp-close-btn", wrappCloseBtn);

import { computePosition, shift, flip, offset, arrow } from "@theme/floating";
// https://floating-ui.com/docs/misc#3d-transforms
var _roundByDPR, roundByDPR_fn,
_translateByDPR, translateByDPR_fn,
_init, init_fn,
_dpr;
const arrplacementRTL = {
  'left': 'right',
  'left-start': 'right-start',
  'left-end': 'right-end',
  'right': 'left',
  'right-start': 'left-start',
  'right-end': 'left-end'
};
const getPlacement = (placement) => isRTL ? (arrplacementRTL[placement] || placement) : placement;

var updatePositionFloatingEl = function(button, floatingEl, arrowEl, _placement, useTranslate = true, _offset = 16, _staticSide = '-8px') {
    getterAdd(_init, this);
    getterAdd(_translateByDPR, this);
    getterAdd(_roundByDPR, this);
    getterRunFn(_init, this, init_fn).call(this, button, floatingEl, arrowEl, _placement, useTranslate, _offset, _staticSide);
  }
_dpr = new Map();
getterAdd(_dpr, _thu, window.devicePixelRatio || 1);
_roundByDPR = new WeakSet();
_translateByDPR = new WeakSet();
_init = new WeakSet();
roundByDPR_fn = function(value) {
  return Math.round(value * getterGet(_dpr, _thu)) / getterGet(_dpr, _thu);
};
translateByDPR_fn = function(x, y) {
  return getterGet(_dpr, _thu) > 1 ? `translate3d(${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, x)}px,${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, y)}px,0)` : `translate(${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, x)}px,${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, y)}px)`;
};
init_fn = function(button, floatingEl, arrowEl, _placement, useTranslate, _offset, _staticSide) {
  computePosition(button, floatingEl, {
    placement: getPlacement(_placement),
    middleware: [
      offset(parseInt(_offset)),
      flip({
        //fallbackPlacements: ['left', 'right', 'top', 'bottom'],
        //fallbackPlacements: ['top', 'bottom'],
        ...( (_placement === 'top' || _placement === 'bottom') && {
            fallbackPlacements: ['top', 'bottom']
        })
      }),
      shift({padding: 0}),
      arrow({
        element: arrowEl,
      }),
    ]
  }).then(({x, y, placement, middlewareData}) => {
    if (useTranslate) {
      this.objStyle = {
        top: '0',
        left: '0',
        transform: getterRunFn(_translateByDPR, this, translateByDPR_fn).call(this, x, y),
      }
    } else {
      this.objStyle = {
        left: `${x}px`,
        top: `${y}px`,
      };
    }
    Object.assign(floatingEl.style, this.objStyle);
    //console.log(middlewareData.arrow)
    if (middlewareData.arrow && arrowEl) {
      const {x: arrowX, y: arrowY} = middlewareData.arrow;
      const staticSide = {
        top: 'bottom',
        right: 'left',
        bottom: 'top',
        left: 'right',
      }[placement.split('-')[0]];

      Object.assign(arrowEl.style, {
        left: arrowX != null ? `${arrowX}px` : '',
        top: arrowY != null ? `${arrowY}px` : '',
        right: '',
        bottom: '',
        [staticSide]: _staticSide,
      });
    }

  });
};

var _find_title, find_title_fn,
_tooltip_ids,
_create_tooltip, create_tooltip_fn,
_tooltip_thiss,
dt_original_title = 'data-original-title';
// https://kazzkiq.github.io/balloon.css/
// class baseTooltip extends HTMLElement {
//   constructor() {
//     super();
//     if (this.placement == 'none') return;
//     getterAdd(_find_title, this);
//     getterAdd(_create_tooltip, this);
//     getterAdd(_tooltip_ids, this, getUID());
//     //$id4(getterGet(_tooltip_ids, this))
//   }
//   connectedCallback() {
//     // run on mobile
//     // this.addEventListener("touchstart", this.onEnter.bind(this, this));
//     // this.addEventListener("touchend", this.onExit.bind(this));
//     if (matchMediaQuery("hover") && this.placement != 'none') {
//       new HoverIntent(
//         this,
//         {
//           onEnter: this.onEnter.bind(this),
//           onExit: this.onExit.bind(this),
//           exitDelay: 0, interval: 80, sensitivity: 6
//         },
//         this,
//       );
//     }
//   }
//   disconnectedCallback() {
//     $id4(getterGet(_tooltip_ids, this))?.remove();
//   }

//   get placement() {
//     return this.getAttribute("placement") || 'bottom';
//   }
//   get arrowEl() {
//     return $4('.hdt-tooltip__arrow', $id4(getterGet(_tooltip_ids, this)));
//   }
//   onEnter() {
//     getterRunFn(_create_tooltip, this, create_tooltip_fn).call(this, getterGet(_tooltip_ids, this), getterRunFn(_find_title, this, find_title_fn).call(this));
//     updatePositionFloatingEl.call(this, this, $id4(getterGet(_tooltip_ids, this)), this.arrowEl, this.placement, true, 6, '-4px');
//   }
//   onExit() {
//     $id4(getterGet(_tooltip_ids, this))?.remove();
//   }
// };
_tooltip_thiss = new WeakMap();
class btnTooltip extends HTMLElement {
  constructor() {
    super();
    getterAdd(_find_title, this);
    getterAdd(_create_tooltip, this);
    getterAdd(_tooltip_ids, this, getUID());
  }
  connectedCallback() {
    // run on mobile
    // this.addEventListener("touchstart", this.onEnter.bind(this, this));
    // this.addEventListener("touchend", this.onExit.bind(this));
    if (matchMediaQuery("hover") && this.placement != 'none') {
      new HoverIntent(
        this,
        {
          onEnter: this.onEnter.bind(this),
          onExit: this.onExit.bind(this),
          exitDelay: 0, interval: 80, sensitivity: 6
        },
        this,
      );
    }
  }
  disconnectedCallback() {
    $id4(getterGet(_tooltip_ids, this))?.remove();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue != newValue && oldValue !== null) {
      this.dispatchEvent(new CustomEvent('theme4:update:tooltip', {
        bubbles: true, detail : 'the4'
      }));
    }
  }
  onEnter = () => {
    if (this.innerText.length && this.hasAttribute('will-hidden-txt')) return;
    this.controller = new AbortController();
    getterRunFn(_create_tooltip, this, create_tooltip_fn).call(this, getterGet(_tooltip_ids, this), getterRunFn(_find_title, this, find_title_fn).call(this));
    const $tooltip_id = $id4(getterGet(_tooltip_ids, this));
    updatePositionFloatingEl.call(this, this, $tooltip_id, this.arrowEl, this.placement, true, 6, '-4px');
    this.addEventListener('theme4:update:tooltip', (e) =>  {
      $4('.hdt-tooltip__inner', $tooltip_id).textContent = getterRunFn(_find_title, this, find_title_fn).call(this);
      updatePositionFloatingEl.call(this, this, $tooltip_id, this.arrowEl, this.placement, true, 6, '-4px');
    }, { signal: this.controller.signal });
  }
  onExit = () => {
    const $tooltip_id = $id4(getterGet(_tooltip_ids, this));
    if ($tooltip_id) {
      this.controller.abort();
      $tooltip_id.remove();
    }
  }
  get placement() {
    return this.getAttribute("placement") || 'bottom';
  }
  get arrowEl() {
    return $4('.hdt-tooltip__arrow', $id4(getterGet(_tooltip_ids, this)));
  }
  get appendEl() {
    return this.hasAttribute('inner') ? this.closest('dialog, .shopify-section') || this : document.body;
  }
}
// class labelTooltip extends HTMLElement {
//   constructor() {
//     super();
//     this.baseTooltip = new BaseTooltip(this);
//   }
//   connectedCallback() {
//     this.baseTooltip.connectedCallback();
//   }
//   disconnectedCallback() {
//     this.baseTooltip.disconnectedCallback();
//   }
// }
// class linkTooltip extends HTMLElement {
//   constructor() {
//     super();
//     this.baseTooltip = new BaseTooltip(this);
//   }
//   connectedCallback() {
//     this.baseTooltip.connectedCallback();
//   }
//   disconnectedCallback() {
//     this.baseTooltip.disconnectedCallback();
//   }
// }
_tooltip_ids = new WeakMap();
_find_title = new WeakSet();
find_title_fn = function() {

  if ( this.hasAttribute('data-txt-tt')) return this.getAttribute('data-txt-tt');

  const firstElementChild = this.firstElementChild || this;
  let text = ($4('[tt-title]', this) || this.lastElementChild || this).textContent;
  // if (this.hasAttribute('title') && typeof this.getAttribute(dt_original_title) != 'string') {
  if (firstElementChild.hasAttribute('aria-label') ) {
    text = firstElementChild.getAttribute('aria-label');
  } else if (firstElementChild.hasAttribute(dt_original_title) ) {
    text = firstElementChild.getAttribute(dt_original_title);
  } else if ( firstElementChild.hasAttribute('title') && !firstElementChild.hasAttribute(dt_original_title)) {
     text = firstElementChild.getAttribute('title') || '';
     firstElementChild.setAttribute(dt_original_title, text);
     firstElementChild.setAttribute('title', '')
  }
  if (!this.hasAttribute('tt-dynamic')) this.setAttribute('data-txt-tt', (text || '').trim());

  return text;
};
_create_tooltip = new WeakSet();
create_tooltip_fn = function(id, title) {
  this.appendEl.append(document.createRange().createContextualFragment(`<hdt-tooltip-dialog id="${id}" class="hdt-tooltip" role="tooltip"><div class="hdt-tooltip__arrow"></div><div class="hdt-tooltip__inner">${title}</div></hdt-tooltip-dialog>`));
};
class Tooltip extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    animate(this, { opacity: [0, .9], visibility: ["visible", "visible"] }, { duration: .3, easing: "ease" });
  }
  //disconnectedCallback() {}
}
customElements.define("hdt-tooltip", btnTooltip);
// customElements.define("hdt-label-tooltip", labelTooltip);
// customElements.define("hdt-a-tooltip", linkTooltip);
customElements.define("hdt-tooltip-dialog", Tooltip);

var _onOptionClicked, onOptionClicked_fn, _onKeyDown, onKeyDown_fn;
class Richlist extends HTMLElement {
  constructor() {
    super();
    getterAdd(_onOptionClicked, this);
    getterAdd(_onKeyDown, this);
    this.addEventListener("keydown", getterRunFn(_onKeyDown, this, onKeyDown_fn));
  }
  connectedCallback() {
    $$4('[role="option"]',this).forEach((option) => {
      option.addEventListener("click", getterRunFn( _onOptionClicked, this, onOptionClicked_fn).bind(this));
    });
  }
  static get observedAttributes() {
    return ["selected"];
  }
  /**
   * @param {string} value
   */
  set selected(value) {
    this.setAttribute("selected", value);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "selected" && oldValue !== null && newValue !== oldValue) {
      $$4('[role="option"]',this).forEach((option) => {
        if (option.value === newValue) {
          option.setAttribute("aria-selected", "true");
          $$4(`[aria-owns="${this.id}"]`).forEach((btnOwn) => {
            const btnText = $4('[change-text]', btnOwn),
            _btnText = btnText || btnOwn;
            _btnText.textContent = option.getAttribute("title") || option.innerText || option.value;
          });
          option.dispatchEvent(new CustomEvent("richlist:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }

}
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  //console.log(event)
  const value = event.currentTarget.value;
  this.selected = value;
  event.currentTarget.dispatchEvent(new CustomEvent("richlist:select", {
    bubbles: true,
    detail: { value }
  }));
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
customElements.define("hdt-richlist", Richlist);

/*
 * Declarative shadow DOM is only initialized on the initial render of the page.
 * If the component is mounted after the browser finishes the initial render,
 * the shadow root needs to be manually hydrated.
 */

import { ThemeEvents, CartUpdateEvent, CartCountEvent, QuantitySelectorUpdateEvent } from '@theme/events';
const {dialogOpening, dialogOpen, dialogClosing, dialogClose} = ThemeEvents;
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');

      if (!(template instanceof HTMLTemplateElement)) return;

      const shadow = this.attachShadow({ mode: 'open' });
      shadow.append(template.content.cloneNode(true));
    }
  }
}
const dialogsOpen = [];
var dialogCurrent;
class DialogComponent extends DeclarativeShadowElement {
  #abortController;
  #scrollLock;
  constructor() {
    super();
  }
  connectedCallback() {
    this.dialog = $4('dialog', this);
    if(!this.dialog) return;
    this.#scrollLock = this.dialog.hasAttribute('scroll-lock');
    this.#abortController = new AbortController();
    const {signal} = this.#abortController;
    super.connectedCallback();

    // Events
    this.dialog.addEventListener('click', (e) => {
      // const rect = this.dialog.getBoundingClientRect();
      // const isClickOutside = (
      //   e.clientX < rect.left || e.clientX > rect.right ||
      //   e.clientY < rect.top || e.clientY > rect.bottom
      // );

      //console.log(isClickOutside, e, this.dialog, dialogsOpen, dialogCurrent, this.dialogId );
      if (this.#isClickOutside(e) && (this.hasAttribute('nested') ? dialogCurrent === this.dialogId : true)) this.close();
    }, { signal });

    // ESC key to close dialog
    this.dialog.addEventListener('cancel', (e) => {
      e.preventDefault(); // Prevents the default cancel behavior
      //console.log(this)
      this.close();
    }, { signal });

    // Handle focus
    this.dialog.addEventListener(dialogOpening, () => {
      this.dialog.classList.add('focus-none');
      ($4('input[type="search"]', this.dialog) || this.dialog).focus();
    }, { signal });

    if (Shopify.designMode && !this.hasAttribute('un-detect')) {
      this.addEventListener(adnmEvts.select, (event) => this.open(!event.detail.load), { signal });
      this.addEventListener(adnmEvts.deselect, () => this.close(true), { signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("detect-adm-se-evt")) {
          this._shopifySection.addEventListener(adnmEvts.seSelect, (event) => this.open(event.detail.load), { signal });
          this._shopifySection.addEventListener(adnmEvts.seDeselect, this.close.bind(this), { signal });
        }
        //this._shopifySection.addEventListener(adnmEvts.seUnload, () => this.remove(), { signal });
      }
    }
  }
  disconnectedCallback() {
    if (this.dialog?.open) {
      this.#removeDialogId()
      if (this.#scrollLock && this._openedAsModal && dialogsOpen.length == 0) html.removeAttribute('scroll-lock');
    }
    this.dialog = null;
    this.#abortController.abort();
  }

  /**
   * Gets the root node of the component, which is either its shadow root or the component itself.
   *
   * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
   */
  // get roots() {
  //   return this.shadowRoot ? [this, this.shadowRoot] : [this];
  // }
  get dialogId() {
    return this.dialog.id;
  }
  get show() {
    this._openedAsModal = true;
    return this.dialog.showModal();
  }
  async open(jump = false) {
    if (this.dialog.open) return;
    if (this.classList.contains('hdt-drawer-menu-mb') && this.dialog.id === 'menu_mobile') {
      const menuTemplate = this.dialog.querySelector(':scope > .hdt-dialog-drawer__inner > template[data-ace-menu-content]');
      if (menuTemplate) menuTemplate.replaceWith(menuTemplate.content);
    }
    // const focusable = $$4('input, button, [tabindex]', this.dialog);
    // focusable.forEach(el => el.setAttribute('tabindex', '-1'));
    this.show;
    // setTimeout(() => {
    //   focusable.forEach(el => el.setAttribute('tabindex', '0'));
    // }, 100);
    if (this.#scrollLock && this._openedAsModal) html.setAttribute('scroll-lock', '');
    this.dialog.dispatchEvent(new CustomEvent(dialogOpening));
    this.dialog.classList.add('dialog-opening');
    dialogsOpen.push(this.dialogId);
    dialogCurrent = this.dialogId;
    const animation = this.animateDialogOpen();
    if (jump) {
      animation.finish();
    }
    await animation.finished;
    this.dialog.classList.remove('dialog-opening');
    this.dialog.dispatchEvent(new CustomEvent(dialogOpen));
  }
  async close(jump = false) {
    if (!this.dialog.open) return;
    this.dialog.btnOpening = null;
    // console.log('close', jump)
    // if (this.hasAttribute('dialog-closing')) return;
    this.dialog.dispatchEvent(new CustomEvent(dialogClosing));
    this.dialog.classList.add('dialog-closing');
    this.#removeDialogId();
    const animation = this.animateDialogClose();
    if (jump) {
      animation.finish();
    }
    await animation.finished;
    this.dialog.close();
    this.dialog.classList.remove('dialog-closing');
    this.dialog.dispatchEvent(new CustomEvent(dialogClose));
    if (this.#scrollLock && this._openedAsModal && dialogsOpen.length == 0) html.removeAttribute('scroll-lock');
  }
  // #forceDialogToggle() {
  //   return animate(this, {}, { duration: 0 });
  // }
  animateDialogOpen() {
    return animate(this.dialog, { opacity: [0, 1]}, {
      duration: 0.3,
      easing: 'ease-out'
    });
  }
  animateDialogClose() {
    return animate(this.dialog, { opacity: [1, 0]}, {
      duration: 0.2,
      easing: 'ease-in'
    });
  }
  #isClickOutside(event) {
    const rect = this.dialog.getBoundingClientRect();
    if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
      return (
        event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom
      );
    }
    return !this.contains(event.target);
  }
  #removeDialogId() {
    const index = dialogsOpen.indexOf(this.dialogId);
    if (index !== -1) dialogsOpen.splice(index, 1);
  }
}
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[aria-controls]');
  if (!trigger) return;

  const dialogId = trigger.getAttribute('aria-controls'),
  dialog = $id4(dialogId);

  // if (!dialogComponent || typeof dialogComponent.open !== 'function') {
  //   console.warn(`No dialog-component with id "${dialogId}" found or not a valid component.`);
  //   return;
  // }
  if (!dialog || !(dialog instanceof HTMLDialogElement) || !dialog.className.split(/\s+/).some(cls => cls.startsWith('hdt-')) || (dialog.hasAttribute('nested') && dialogCurrent !== dialog.id)) return;

  if (dialog.parentElement?.matches('hdt-popover') && (dialog.parentElement.getAttribute('action') === 'hover' || dialog.parentElement.hasAttribute('hover')) && matchMediaQuery('hover')) return;

  event.preventDefault();
  //event.stopPropagation();
  event.stopImmediatePropagation();

  const dialogCloseId = trigger.getAttribute('close-dialog');
  $$4('hdt-popover[data-auto-close] > dialog[open]').forEach( (_dialog)=> {
    if (!_dialog?.parentElement?._openedAsModal && _dialog.id != dialog.id) _dialog.parentElement.close(true);
  });

  if (dialog.open && dialogId == dialogCloseId) {
    dialog.parentElement?.close(true);
    dialog.addEventListener(dialogClose, ()=> {
      dialog.btnOpening = trigger;
      dialog.parentElement?.open();
    }, { once: true });
  } else {
    $id4(dialogCloseId)?.parentElement?.close();
    dialog.btnOpening = trigger;
    const opened = dialog.open;
    // Toggle logic
    dialog.parentElement[opened ? 'close' : 'open']();
    $$4(`[aria-controls="${dialogId}"]`).forEach((_btn) => _btn.setAttribute('aria-expanded', 'false'));
    trigger.setAttribute('aria-expanded', opened + '');
  }
});
// document.addEventListener('toggle', (event) => {
//   if (event.target instanceof HTMLDialogElement || event.target instanceof HTMLDetailsElement) {
//     const { open } = event.target;
//     if (event.target.hasAttribute('scroll-lock')) {
//       if (open) {
//       } else {
//       }
//       console.log('toggle', dialogsOpen.length)
//     }
//   }
//   },{ capture: true }
// );
class DrawerComponent extends DialogComponent {
  #transform;
  constructor() {
    super();
  }
  /**
   * @param {string} pos
   */
  set transform(pos) {
    this.#transform = ['translate3d(0, 0, 0)'];
    if (pos === 'right') {
      this.#transform.push(`translate3d(${isRTL ? '-' : ''}100%, 0, 0)`);
    } else if (pos === 'bottom') {
      this.#transform.push( 'translate3d(0, 100%, 0)');
    } else if (pos === 'top') {
      this.#transform.push('translate3d(0, -100%, 0)');
    } else {
      this.#transform.push(`translate3d(${isRTL ? '' : '-'}100%, 0, 0)`);
    }
  }
  get pos() {
    const arr = (this.dialog.getAttribute('pos-min-width') || '').split(':');
    return arr[1] && window.innerWidth >= Number(arr[0]) ? arr[1] : this.dialog.getAttribute('pos') || 'left';
  }
  get show() {
    this.transform = this.pos;
    this._openedAsModal = true;
    return this.dialog.showModal();
  }
  animateDialogOpen() {
    return animate(this.dialog, {
      transform: this.#transform.reverse()
    }, {
      duration: 0.5,
      easing: [0.19, 1, 0.22, 1]
    });
  }
  animateDialogClose() {
    return animate(this.dialog, {
      transform: this.#transform.reverse()
    }, {
      duration: 0.4,
      easing: [0.19, 1, 0.22, 1]
    });
  }
}
class ModalComponent extends DialogComponent {
  animateDialogOpen() {
    return animate(this.dialog, {
      opacity: [0, 1],
      transform: ['translateX(-100px)', 'translateX(0)'],
    }, {
      duration: 0.45,
      easing: [0.19, 1, 0.22, 1]
    });
  }
  animateDialogClose() {
    return animate(this.dialog, {
      opacity: [1, 0],
      transform: ['translateX(0)', 'translateX(80px)']
    }, {
      duration: 0.45,
      easing: [0.19, 1, 0.22, 1]
    });
  }
}

class Popover extends DialogComponent {
  #isFirstTime = true;
  #hoverAbortController;
  constructor() {
    super();
  }
  get placement() {
    return this.getAttribute("placement") || 'bottom';
  }
  get arrowEl() {
    return this._arrowEl ??= $4('.hdt-popover__arrow', this);
  }
  get minWidth() {
    return Number(this.dialog.btnOpening?.dataset.popoverActiveMinWidth) || Number(this.getAttribute('popover-active-min-width')) || 768;
  }
  get show() {
    this._openedAsModal = window.innerWidth < this.minWidth;
    const scrollY = window.scrollY;
    this.dialog.toggleAttribute('open-as-modal', this._openedAsModal);
    this._openedAsModal ? this.dialog.showModal() : this.dialog.show();
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
    });
    return true;
  }
  updatePos() {
    updatePositionFloatingEl.call(this.dialog, this.dialog.btnOpening, this.dialog, this.arrowEl, this.placement, true, 16, '-5px');
  }

  connectedCallback() {
    super.connectedCallback();
     this.dialog.style.opacity = 0;
    const handleCickOutsite = (event)=> {
      const trigger = document.querySelector(`[hover-trigger="${this.dialog.id}"], [data-hover-trigger="${this.dialog.id}"], [aria-controls="${this.dialog.id}"]`);
      if (!this._openedAsModal && !this.contains(event.target) && (!trigger || !trigger.contains(event.target))) this.close();
    },
    handleRichlistSelect = this.close.bind(this, false);

    this.dialog.addEventListener(dialogOpen, () => {
      document.addEventListener('click', handleCickOutsite);
      this.addEventListener("richlist:select", handleRichlistSelect);
    });
    this.dialog.addEventListener(dialogClosing, ()=> {
      document.removeEventListener('click', handleCickOutsite)
      this.removeEventListener("richlist:select", handleRichlistSelect);
    });

    if (this.getAttribute('action') === 'hover' || this.hasAttribute('hover')) {
      this.#initHoverBehavior();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#hoverAbortController?.abort();
  }

  #initHoverBehavior() {
    if (!matchMediaQuery('hover')) return;
    this.#hoverAbortController = new AbortController();
    const { signal } = this.#hoverAbortController;

    const init = () => {
      const trigger = document.querySelector(`[hover-trigger="${this.dialog.id}"], [data-hover-trigger="${this.dialog.id}"], [aria-controls="${this.dialog.id}"]`);
      if (!trigger) return;

      let hoverTimeout = null;

      const openPopover = () => {
        clearTimeout(hoverTimeout);
        if (!this.dialog.open) {
          this.dialog.btnOpening = trigger;
          this.open();
        }
      };

      const closePopover = () => {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          if (this.dialog.open) {
            this.close();
          }
        }, 150);
      };

      trigger.addEventListener('mouseenter', openPopover, { signal });
      trigger.addEventListener('mouseleave', closePopover, { signal });

      this.addEventListener('mouseenter', openPopover, { signal });
      this.addEventListener('mouseleave', closePopover, { signal });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true, signal });
    } else {
      init();
    }
  }

  animateDialogOpen() {
    if (this._openedAsModal) {
      Object.assign(this.dialog.style, {
        top: null,
        left: '0px',
        right: null,
        bottom: '0px',
        transform: null,
      });
      return timeline([
        [this.dialog, { transform: ["translateY(100%)", "translateY(0%)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.4, easing: [0.645, 0.045, 0.355, 1] }],
        //[$4('.hdt-popover__body', this).children, {  opacity: [0, 1], transform: ["translateY(15px)", "translateY(0px)"] }, { at: "-0.08", duration: 0.24, easing: [0.645, 0.045, 0.355, 1] }]
      ]);
    } else if (this.#isFirstTime) {
      this.#isFirstTime = false;
      return new Promise((resolve) => {
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.updatePos();
            resolve();
          });
        }, 11);
      }).then(() => {
        return timeline([
          [this.dialog, { top: ["10px","0"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
          [$4('.hdt-popover__body', this).children, { opacity: 1 }, { at: "<", duration: 0.15 }]
        ]);
      });
    } else {
      this.updatePos();
      return timeline([
        [this.dialog, { top: ["10px","0"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [$4('.hdt-popover__body', this).children, { opacity: 1 }, { at: "<", duration: 0.15 }]
      ]);
    }
  }
  animateDialogClose() {
    if (this._openedAsModal) {
      return timeline([
        //[$4('.hdt-popover__body', this).children, {  opacity: [1, 0], transform: ["translateY(0px)", "translateY(15px)"] }, { duration: 0.24, easing: [0.645, 0.045, 0.355, 1] }],
        [this.dialog, { transform: ["translateY(0%)", "translateY(100%)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { at: "-0.1", duration: 0.25, easing: [0.645, 0.045, 0.355, 1] }],
      ]);
    } else {
      return timeline([
        [$4('.hdt-popover__body', this).children, { opacity: 0 }, { duration: 0.15 }],
        [this.dialog,{ top: ["0","10px"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { at: "<", duration: 0.15 }]
      ]);
    }
  }
}
class appendToBody extends HTMLElement {
  constructor() {
    super();
    if ( window.innerWidth < 768 && this.hasAttribute('desktop')) return;
    requestIdleCallback(() => {
      const el = this.firstElementChild;
      if (el.firstElementChild && document.body !== el.parentNode) {
        document.body.appendChild(el);
        this.remove();
      }
    });
  }
}
customElements.define("hdt-popover", Popover);
customElements.define("hdt-append-body", appendToBody);

// reload, update cart drawer
const  {cartUpdate, cartReload, cartCount, cartError, currencyUpdate, cartDrawerRender, cartMainRender} = ThemeEvents;
class CartDrawer extends DrawerComponent {
  #abortController;
  #requiredRefs = ['shipping-bar'];
  //#requiredRefs = ['shipping-bar', 'cart-items', 'cart-bottom', 'complementary', 'contents'];
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    this.#abortController = new AbortController();
    const {signal} = this.#abortController;
    document.addEventListener(cartUpdate, this.#handleCartUpdate.bind(this), { signal });
    document.addEventListener(cartReload, this.#handleCartReload.bind(this), { signal });
    window.addEventListener("pageshow", this.#handleCartPageShow.bind(this), { signal });
    //this.#handleCartReload();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }
  get sectionId() {
    return this._sectionId ??= this.getAttribute('section-id');
  }
  // get sectionsToRender() {
  //   return [
  //     {
  //       id: this.sectionId
  //     }
  //   ];
  // }
  async #handleCartUpdate(event) {
    //console.log('Cart updated:', event.detail);
    const { cartData, source, actionAfterATC } = event.detail,
    newSectionHTML = new DOMParser().parseFromString(cartData.sections[this.sectionId], "text/html");
    //console.log('Cart item updated:', newSectionHTML);
    // Grab the new cart item count from a hidden element
    const newCartHiddenItemCount = $4('[ref="hdt-cart"]', newSectionHTML)?.dataset.count;
    const item_count = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;
    const total_price = $4('[ref="hdt-cart"]', newSectionHTML)?.dataset.totalPrice;
    //cartData.item_count = item_count;
    //console.log(cartData);
    document.dispatchEvent(new CartCountEvent(item_count, total_price));
    let animation;
    if (item_count == 0) {
      animation = timeline([
        [$4('.hdt-mini-cart__main', this), { opacity: [1, 0] }, { duration: 0.15, easing: "ease-in" }],
        [$4('.hdt-mini-cart__bottom', this), { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.15, at: "<", easing: "ease-in" }]
      ]);
    } else {
      animation = animate(this, {}, { duration: 0 })
    }
    await animation.finished;
    this.classList.toggle('is-empty', item_count == 0);
    // update gift wrap
    //$4('[aria-controls="dialog-is--gift"]', this)?.parentElement?.toggleAttribute('hidden', $4('.is-gift-wrap', newSectionHTML));
    // Update html
    for (const ref of this.#requiredRefs) {
      const targetElement = $4(`[ref="${ref}"]`, this);
      const sourceElement = $4(`[ref="${ref}"]`, newSectionHTML);
      if (!targetElement || !sourceElement) continue;
      if (ref == this.#requiredRefs[0]) {
        $4('.hdt-progress-bar', sourceElement).style.setProperty('--progress-rate', $4('.hdt-progress-bar', targetElement).style.getPropertyValue('--progress-rate'));
        targetElement.replaceWith(sourceElement);
        $4('.hdt-progress-bar', this).now = $4('.hdt-progress-bar', sourceElement).getAttribute('aria-valuenow');
      } else if (ref != this.#requiredRefs[3]) {
        targetElement.replaceWith(sourceElement);
      } else if ( !sourceElement.dataset.id || targetElement.dataset.id !== sourceElement.dataset.id ) {
        targetElement.replaceWith(sourceElement);
      }
    }
    $4('cart-items-component', this).innerHTML =  $4('cart-items-component', newSectionHTML).innerHTML;
    // End Update html
    if (item_count == 0) {
      animate($4('.hdt-mini-cart__main', this), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
    }
    document.dispatchEvent(new CustomEvent(currencyUpdate));
    document.dispatchEvent(new CustomEvent(cartDrawerRender));
    if (source === "product-form-component") {
      const _actionAfterATC = actionAfterATC || themeHDN.settings.actionAfterATC;
      if (_actionAfterATC.indexOf('go_') > -1) {
        window.location.href = `${Shopify.routes.root}${_actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
      } else if ( _actionAfterATC == 'open_cart_drawer' ) {
        this.open();
      }
    }
  }
  async #handleCartReload() {
    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ sections: [this.sectionId] }),
      });
      const response = await fetch(`${Shopify.routes.root}cart/update`, {...config});
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      //console.log('Cart reloaded:', cartData.item_count);
      this.#handleCartUpdate.call(this, {
        detail: {
          cartData,
          source: 'reload',
          actionAfterATC: 'no_action'
        }
      });
    } catch (error) {
      console.error('Failed to reload cart:', error);
    }
  }
  async #handleCartPageShow(event) {
    if (event.persisted) this.#handleCartReload();
  }
}
class CartAction extends DialogComponent {
  animateDialogOpen() {
    return animate(this.dialog, {
      transform: ['translate3d(0, 100%, 0)', 'translate3d(0, 0, 0)']
    }, {
      duration: 0.5,
      easing: [0.19, 1, 0.22, 1]
    });
  }
  animateDialogClose() {
    return animate(this.dialog, {
      transform: ['translate3d(0, 0, 0)', 'translate3d(0, 100%, 0)']
    }, {
      duration: 0.4,
      easing: [0.19, 1, 0.22, 1]
    });
  }
}
class CartItemsComponent extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityChange.bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  /**
   * Handles QuantitySelectorUpdateEvent change event.
   * @param {QuantitySelectorUpdateEvent} event - The event.
   */
  #onQuantityChange(event) {
    //console.log('Quantity changed:', event.detail);
    const { quantity, line } = event.detail;

    if (!line) return;

    if (quantity === 0) {
      return this.onLineItemRemove(line);
    }
    this.updateQuantity({
      line,
      quantity,
      action: 'change',
    });
    // const lineItemRow = this.cartItemRows[line - 1];

    // if (!lineItemRow) return;
    // Add effect loading
  }

  /**
   * Handles the line item removal.
   * @param {number} line - The line item index.
   */
  onLineItemRemove(line) {
    this.updateQuantity({
      line,
      quantity: 0,
      action: 'clear'
    });
  }

  /**
   * Updates the quantity.
   * @param {Object} config - The config.
   * @param {number} config.line - The line.
   * @param {number} config.quantity - The quantity.
   * @param {string} config.action - The action.
   */
  updateQuantity(config) {

    this.#disableCartItems();

    const { line, quantity, action } = config;

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: this.cart.sectionId,
      sections_url: window.location.pathname,
    });

    //cartTotal?.shimmer();

    fetch(`${Shopify.routes.root}cart/change.js`, fetchConfig('json', { body }))
      .then((response) => {
        return response.text();
      })
      .then(async (responseText) => {
        const parsedResponseText = JSON.parse(responseText);

        if (parsedResponseText.errors) {
          this.#handleCartError(line, parsedResponseText);
          return;
        }

        // const newSectionHTML = new DOMParser().parseFromString(parsedResponseText.sections[this.cart.sectionId],'text/html');
        // console.log('Cart item updated:', newSectionHTML);
        // // Grab the new cart item count from a hidden element
        // const newCartHiddenItemCount = $4('[ref="hdt-cart"]', newSectionHTML)?.dataset.count;
        // const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;
        // parsedResponseText.item_count = newCartItemCount;
        // console.log(parsedResponseText)
        let animation = animate(this, {}, { duration: 0 });
        if (action === 'clear') {
          const itemRemove = this.cartItemRows[line - 1];
          if (itemRemove) {
            itemRemove.style.overflow = 'hidden';
            animation = animate(itemRemove, { opacity: [1, 0], height: [`${itemRemove.clientHeight}px`, '0px'], paddingBottom: 0, paddingTop: 0, marginBottom: 0, marginTop: 0, borderColor: 'transparent' }, { duration: 0.25, easing: "ease-in-out" });
          }
        }
        await animation.finished;
        this.dispatchEvent(
          new CartUpdateEvent({}, this.cart.sectionId, parsedResponseText, 'no_action', 'cart-items-component')
        );
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.#enableCartItems();
      });
  }

  /**
   * Disables the cart items.
   */
  #disableCartItems() {
    this.classList.add('cart-items-disabled');
  }

  /**
   * Enables the cart items.
   */
  #enableCartItems() {
    this.classList.remove('cart-items-disabled');
  }
  #handleCartError = (line, parsedResponseText) => {
    const errorMessage = parsedResponseText.errors.map(error => error.message).join(', ');
    console.error(`Error updating cart item at line ${line}: ${errorMessage}`);
  }
  get cart() {
    return this._cart = this._cart || $4('[ref="hdt-cart"]');
  }
  get cartItemRows() {
    return $$4('[ref="cartItemRows[]"]', this);
  }
}
class CartMain extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  connectedCallback() {;
    this.#abortController = new AbortController();
    const {signal} = this.#abortController;
    document.addEventListener(cartUpdate, this.#handleCartUpdate.bind(this), { signal });
    document.addEventListener(cartReload, this.#handleCartReload.bind(this), { signal });
    window.addEventListener("pageshow", this.#handleCartPageShow.bind(this), { signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get sectionId() {
    return this._sectionId ??= this.getAttribute('section-id');
  }
  async #handleCartUpdate(event) {
    const { cartData, source, actionAfterATC } = event.detail,
    newSectionHTML = new DOMParser().parseFromString(cartData.sections[this.sectionId], "text/html");

    // Grab the new cart item count from a hidden element
    const newCartMain =  $4('[ref="hdt-cart"]', newSectionHTML);
    const newCartHiddenItemCount = newCartMain?.dataset.count;
    const item_count = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;
    const total_price = newCartMain?.dataset.totalPrice ?? 0;
    const freeShippingBar = $4('.hdt-free-shipping-bar', newCartMain);
    let valueNow = 0;
    if (freeShippingBar) {
      valueNow = $4('.hdt-progress-bar', freeShippingBar).getAttribute('aria-valuenow');
      $4('.hdt-progress-bar', freeShippingBar).valueNow = $4('.hdt-progress-bar', this).getAttribute('aria-valuenow');
      $4('.hdt-progress-bar', freeShippingBar).style.setProperty('--progress-rate', $4('.hdt-progress-bar', this).style.getPropertyValue('--progress-rate'));
    }
    document.dispatchEvent(new CartCountEvent(item_count, total_price));
    let animation;
    if (item_count == 0) {
      animation = animate(this, { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] })
    } else {
      animation = animate(this, {}, { duration: 0 })
    }
    await animation.finished;
    this.classList.toggle('is-empty', item_count == 0);
    // Start update html
    this.innerHTML = newCartMain.innerHTML;
    // End update html
    if (item_count == 0) {
      animate(this, { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
    }
    if (freeShippingBar) $4('.hdt-progress-bar', this).valueNow = valueNow;
    document.dispatchEvent(new CustomEvent(currencyUpdate));
    document.dispatchEvent(new CustomEvent(cartMainRender));
    if (source === "product-form-component") {
      const _actionAfterATC = actionAfterATC || themeHDN.settings.actionAfterATC;
      if (_actionAfterATC.indexOf('go_') > -1) {
        window.location.href = `${Shopify.routes.root}${_actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
      }
    }
  }
  async #handleCartReload() {
    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ sections: [this.sectionId] }),
      });
      const response = await fetch(`${Shopify.routes.root}cart/update`, {...config});
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      //console.log('Cart reloaded:', cartData.item_count);
      this.#handleCartUpdate.call(this, {
        detail: {
          cartData,
          source: 'reload',
          actionAfterATC: 'no_action'
        }
      });
    } catch (error) {
      console.error('Failed to reload cart:', error);
    }
  }
  async #handleCartPageShow(event) {
    if (event.persisted) this.#handleCartReload();
  }
}
customElements.define("hdt-dialog-component", DialogComponent);
customElements.define("hdt-drawer", DrawerComponent);
customElements.define("hdt-modal", ModalComponent);

customElements.define("hdt-cart-drawer", CartDrawer);
customElements.define("hdt-cart-action", CartAction);
customElements.define("cart-items-component", CartItemsComponent);
customElements.define("hdt-main-cart", CartMain);


var _reveal, reveal_fn, _input, input_fn;
class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    getterAdd(_reveal, this);
    getterAdd(_input, this);
    //console.log($4('.hdt-bf__range', this))
  }
  connectedCallback() {
    $4('.hdt-bf__range', this).addEventListener("input", getterRunFn( _input, this, input_fn).bind(this));
    this.beforeVal = $4('.hdt-bf__range', this).value;
    inView(this, getterRunFn(_reveal, this, reveal_fn).bind(this), { margin: "0px 0px -44% 0px" });
  }
}
_reveal = new WeakSet();
reveal_fn = function(info) {
  animate((progress) => {
    // this.style.getPropertyValue("--percent-val")
    this.style.setProperty("--percent-val", this.beforeVal * progress);
  }, { duration: 0.6, easing: [0.85, 0, 0.15, 1] });
};
_input = new WeakSet();
input_fn = function(e) {
  this.style.setProperty("--percent-val", e.target.value);
};
customElements.define("hdt-before-after", BeforeAfter);

//const aniHdt = 'hdt-visible-animate';
class Countdown extends HTMLElement {

  // https://codepen.io/SitePoint/pen/QpwRxz
  // flip demo https://codepen.io/creativeocean/pen/pWXgNG

  timezoneString = themeHDN.settings.shopTimezone ? ` GMT${themeHDN.settings.shopTimezone}` : "";

  constructor() {
    super();
    this.selectors = {
      "days": "[data-days]",
      "hours": "[data-hours]",
      "minutes": "[data-minutes]",
      "seconds": "[data-seconds]"
    }

    this.classes = {
      "enabled": "hdt-cd--enabled",
      "hide": "hdt-cd--hide",
      "complete": "hdt-cd--complete"
    }

    this.arrayMth = {
      "1": "january",
      "2": "february",
      "3": "march",
      "4": "april",
      "5": "may",
      "6": "june",
      "7": "july",
      "8": "august",
      "9": "september",
      "10": "october",
      "11": "november",
      "12": "december"
    }

    this.defaults = {
      "idTmp": null,
      "hasZero": true,
      "hideTimerOnComplete": true
    }
    cancelAnimationFrame(this.myReq);
    const options = Object.assign({}, this.defaults,  JSON.parse(this.getAttribute('config') || '{}'));
    this.date =  new Date(Date.parse(this.arrayMth[options.month] + ' ' + options.date + this.timezoneString));
    if (isNaN(this.date)) return;
    this.hideTimerOnComplete = options.hideTimerOnComplete;
    this.countDownTime = this.date.getTime();

    if (options.idTmp) {
      const idTmp = $id4(options.idTmp);
      if (idTmp) this.innerHTML = idTmp.innerHTML;
    }

    this.daysEl    = $4(this.selectors.days,this);
    this.hoursEl   = $4(this.selectors.hours,this);
    this.minutesEl = $4(this.selectors.minutes,this);
    this.secondsEl = $4(this.selectors.seconds,this);
    this.hasZero   = options.hasZero;
    this.playing   = false;

    //this.timerInterval = setInterval(this.timerLoop.bind(this), 1000);
    this.init();

    inView(this, (info) => {
      this.play();
      this.isInview = true;
      return (leaveInfo) =>  {
        this.pause();
        this.isInview = false;
      }
    }, { margin: "0px 0px 150px 0px" })

    // listen for visibility change event
    visibilitychangeFn({
      observes: this,
      play: this.play.bind(this),
      pause: this.pause.bind(this)
    });
    // this.myReq = requestAnimationFrame(this.timerLoop.bind(this));
    // this.classList.add(this.classes.enabled);
    //this.destroy();
  }

  init() {
    if (this.playing) return;
    if (!this.myReq) this.classList.add(this.classes.enabled);
    this.play();
  }
  // pad value with zero
  // pad(value) {
  //   return (this.padZero + value).slice(-2);
  // }
    // https://stackoverflow.com/questions/6466135/adding-extra-zeros-in-front-of-a-number-using-jquery
    // pad (str, max = 2) {
  //     str = str.toString();
  //     return (str.length < max) ? '0' + str : str;
    // }

  timerLoop() {
    //window.requestAnimationFrame(() => {
      // Get today's date and time
      const now = new Date().getTime(); // Find the distance between now and the count down date

      const distance = this.countDownTime - now; // Time calculations for days, hours, minutes and seconds

      const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours   = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);

      if (distance < 0) {
        this.destroy();
        // this.daysEl?.updateValue(0, this.hasZero);
        // this.hoursEl?.updateValue(0, this.hasZero);
        // this.minutesEl?.updateValue(0, this.hasZero);
        // this.secondsEl?.updateValue(0, this.hasZero);

        // If the count down is finished, write some text
        this.classList.add(this.classes.complete);
        if (this.hideTimerOnComplete) {
          this.classList.add(this.classes.hide);
          // if (this.parentNode) {
          //   this.parentNode.classList.add(this.classes.hide);
          // }
        }

      } else {
        if (!this.daysEl) hours = hours + days * 24;
        this.daysEl?.updateValue(days, this.hasZero);
        this.hoursEl?.updateValue(hours, this.hasZero);
        this.minutesEl?.updateValue(minutes, this.hasZero);
        this.secondsEl?.updateValue(seconds, this.hasZero);
        this.myReq = requestAnimationFrame(this.timerLoop.bind(this));
      }

  }

  play() {
    if (this.playing) return;
    //console.log('play')
    this.myReq = requestAnimationFrame(this.timerLoop.bind(this));
    this.playing = true;
  }

  pause() {
    if (!this.playing) return;
    //console.log('pause')
    //this.timerInterval && clearInterval(this.timerInterval);
    cancelAnimationFrame(this.myReq);
    this.playing = false;
  }

  destroy() {
    //this.timerInterval && clearInterval(this.timerInterval);
    this.pause();
    this.classList.remove(this.classes.enabled);
  }

};
class CountdownAmount extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    let flipHtml = [...this.textContent].map(() => `<hdt-countdown-number part="number" effect="${ this.getAttribute("effect") }" style="display: inline-block">0</hdt-countdown-number>`);
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(flipHtml.join("")));
  }
  updateValue(value, hasZero) {
    let numPad = Math.min(99, value).toString().padStart(2, "0");
    this.textContent = numPad;
    [...numPad].forEach((num, index) => {
      this.shadowRoot.children[index].setAttribute("number", num);
    });
    if (this.nextElementSibling && this.nextElementSibling.shadowRoot) {
      let i = 0;
      for (; i < 2; i++) {
        this.nextElementSibling.shadowRoot.children[i].setAttribute("amount", numPad);
      }
    }
    //this.nextElementSibling.setAttribute("amount", numPad);
    if (!hasZero) this.shadowRoot.children[0].style.display = (numPad < 10 ) ? 'none' : 'inline-block';
  }
};
class CountdownAmountNumber extends HTMLElement {
  static observedAttributes = ["number"];
  constructor() {
    super();
    // Effect config
    this.e = {
      //O: 0,
      Y: 0,
      S: 1,
      R: 0
    };
    this.runFrist = 0;

    switch(this.getAttribute("effect")) {
      case 'move_top':
        this.e.Y = -8;
        this.e.Y2 = 8;
        break;
      case 'move_bottom':
        this.e.Y = 6;
        this.e.Y2 = -6;
        break;
      case 'scale':
        this.e.S = .5;
        break;
      case 'rotate':
        this.e.R = 180;
        this.e.S = .68;
        break;
    }
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<div><slot></slot></div>"));
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    ++this.runFrist;
    if (this.getAttribute("effect") == 'none' || (this.runFrist == 2)) {
      return this.textContent = newValue;
    }
    if (oldValue === null || oldValue === newValue) return;
    await animate(this.shadowRoot.firstElementChild, { opacity: [1, 0], transform: ["translateY(0) rotate(0deg) scale(1)", `translateY(${this.e.Y}px) rotate(${this.e.R}deg) scale(${this.e.S})`] }, { duration: 0.25, easing: [0.64, 0, 0.78, 0] }).finished;
    this.textContent = newValue;
    animate(this.shadowRoot.firstElementChild, { opacity: [0, 1], transform: [`translateY(${ this.e.Y2 || this.e.Y }px) rotate(${this.e.R}deg) scale(${this.e.S})`, "translateY(0) rotate(0deg) scale(1)"] }, { duration: 0.25, delay: 0.1, easing: [0.22, 1, 0.36, 1] });
  }
};
class CountdownText extends HTMLElement {
  static observedAttributes = ["amount"];
  constructor() {
    super();
    if (!this.hasAttribute('singular')) return;
    this.attachShadow({ mode: "open" });
    let i = 0;
    let textHtml = "";
    for (; i < 2; i++) {
      textHtml += `<hdt-countdown-unit ${ i ? 'singular' : 'plural'} part="unit" style="grid-area: 1 / -1; will-change: opacity; opacity: ${ i ? 0 : 1 };">${ i ? this.getAttribute('singular') : this.textContent }</hdt-countdown-unit>`;
    }
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(textHtml));
  }
  // async attributeChangedCallback(name, oldValue, newValue) {
  //   if (oldValue === null || oldValue === newValue) {
  //     return;
  //   }
  //   this.shadowRoot.firstElementChild.style.opacity = (newValue == 1) ? 0 : 1;
  //   this.shadowRoot.lastElementChild.style.opacity = (newValue == 1) ? 1 : 0;
  // }
};
class CountdownUnit extends HTMLElement {
  static observedAttributes = ["amount"];
  constructor() {
    super();
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    // if (oldValue === null || oldValue === newValue) {
    //   return;
    // }
    if (oldValue === newValue) {
      return;
    }
    // if ( this.hasAttribute('plural') ) {
    //   this.style.opacity = (newValue == 1) ? 0 : 1;
    // } else {
    //   this.style.opacity = (newValue == 1) ? 1 : 0;
    // }
    this.style.opacity = this.hasAttribute('plural') ? (newValue == 1) ? 0 : 1 : (newValue == 1) ? 1 : 0;
    // this.shadowRoot.firstElementChild.style.opacity = (newValue == 1) ? 0 : 1;
    // this.shadowRoot.lastElementChild.style.opacity = (newValue == 1) ? 1 : 0;
  }
};
customElements.define('hdt-countdown', Countdown);
customElements.define('hdt-countdown-amount', CountdownAmount);
customElements.define('hdt-countdown-number', CountdownAmountNumber);
customElements.define('hdt-countdown-text', CountdownText);
customElements.define('hdt-countdown-unit', CountdownUnit);

const countdown = {
  selectors: {
    "days": "[is='days']",
    "hours": "[is='hours']",
    "minutes": "[is='minutes']",
    "seconds": "[is='seconds']"
  },
  classes: {
    "enabled": "hdt-cd--enabled",
    "hide": "hdt-cd--hide",
    "complete": "hdt-cd--complete"
  },
  defaults: {
    "idTmp": null,
    "hasZero": true,
    "actionElapsed": 'zero'
  }
},
arrayMth = {
  "1": "january",
  "2": "february",
  "3": "march",
  "4": "april",
  "5": "may",
  "6": "june",
  "7": "july",
  "8": "august",
  "9": "september",
  "10": "october",
  "11": "november",
  "12": "december"
};
const {CountdownStart, CountdownEnd} = ThemeEvents;
class CountdownHybrid extends HTMLElement {
  //timezoneString = themeHDN.settings.shopTimezone ? ` GMT${themeHDN.settings.shopTimezone}` : "";
  #timerOptions;
  #endingDate;
  #timerInterval = 0;
  #daysEl;
  #hoursEl;
  #minutesEl;
  #secondsEl
  //#count = 0;
  #abortController;
  constructor() {
    super();
    const { days, hours, minutes, seconds } = countdown.selectors;
    this.#timerOptions = Object.assign({}, countdown.defaults,  JSON.parse(this.getAttribute('config') || '{}'));
    //this.#endingDate = new Date(Date.parse(arrayMth[this.#timerOptions.month] + ' ' + this.#timerOptions.date + this.timezoneString));
    //this.#endingDate = new Date(Date.parse(arrayMth[this.#timerOptions.month] + ' ' + this.#timerOptions.date + (themeHDN.settings.shopTimezone ? ` GMT${themeHDN.settings.shopTimezone}` : "")));
    this.#endingDate = new Date(this.#timerOptions.datetime+(themeHDN.settings.shopTimezone || ""));
    this.#daysEl = $4(days, this);
    this.#hoursEl = $4(hours, this);
    this.#minutesEl = $4(minutes, this);
    this.#secondsEl = $4(seconds, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.#timerLoop(true);
    this.dispatchEvent(new CustomEvent(CountdownStart));
    this.setAttribute('start', '')
    this.#timerInterval = setInterval(this.#timerLoop.bind(this), 1e3);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.#timerLoop(true, true);
      }
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    clearInterval(this.#timerInterval);
    this.#abortController.abort();
  }
  #timerLoop(runOnlyOneTime = false, update = false) {
    // Get today's date and time
    const nowDate = new Date(),
    { actionElapsed, hasZero } = this.#timerOptions;
    if (this.#endingDate < nowDate) {
      clearInterval(this.#timerInterval);
      this.dispatchEvent(new CustomEvent(CountdownEnd));
      this.setAttribute('expired', '')
      console.log('actionElapsed: ', actionElapsed);
      // Countdown expired
      return;
    }
    // ++this.#count;
    // console.log(this.#count)
    let diff = Math.abs((this.#endingDate.getTime() - nowDate.getTime()) / 1e3);  // Time calculations for days, hours, minutes and seconds

    const totalHours  = Math.floor(diff / 3600);
    const days        = Math.floor(diff / 86400);
          diff       -= days * 86400;
    let   hours       = Math.floor(diff / 3600);
          diff       -= hours * 3600;
    const minutes     = Math.floor(diff / 60);
          diff       -= minutes * 60;
    const seconds     = Math.floor(diff);

    if (!this.#daysEl) hours = Math.min(totalHours, 99); // Limit hours to 99

    this.#daysEl?.updateAttr(days, hasZero);
    this.#hoursEl?.updateAttr(hours, hasZero);
    this.#minutesEl?.updateAttr(minutes, hasZero);
    this.#secondsEl?.updateAttr(seconds, hasZero);

    if (runOnlyOneTime || update) {
      if (update) {
        this.setAttribute('update', '');
        setTimeout(() => {
          this.removeAttribute('update');
        }, 100);
      }
      //this.#count = 0;
      this.#minutesEl?.updateDelay(seconds, minutes);
      this.#secondsEl?.updateDelay(seconds);
    }
  }
}
class CountdownJS extends HTMLElement {
  static observedAttributes = ["numbers"];
  #hasZero = true;
  constructor() {
    super();
    $$4('[number]', this).forEach((numberEl, index) => {
      numberEl.style.height = numberEl.clientHeight + 'px';
      const length = parseInt(numberEl.getAttribute('length') || 9);
      let i, tmp = ''
      for (i = length; i >= 0; i--) {
        tmp += `<span part="num">${i}</span>`;
      }
      numberEl.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`<span part="numlist"><span part="num">0</span>${tmp}</span>`));
      tmp = '';
    });
  }
  updateAttr(newValue, hasZero) {
    if (this.getAttribute('numbers') == newValue) return;
    this.#hasZero = hasZero;
    this.setAttribute('numbers', newValue);
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    newValue = Math.min(99,parseInt(newValue));
    if (oldValue === newValue) return;
    if (!oldValue) oldValue =  Math.min(99, newValue + 1);
    oldValue = parseInt(oldValue);
    let arrNumNew = newValue.toString().padStart(2, "0").split('').map(Number);
    console.log('CountdownJS: ', oldValue, newValue)

    $$4('[number]', this).forEach((numberEl, index) => {
      const length = numberEl.shadowRoot.firstElementChild.children.length - 1,
      newIndex = length - arrNumNew[index],
      oldIndex = newIndex == 1 ? 0 : newIndex - 1;
      if (arrNumNew[index] == parseInt(this.getAttribute('num'))) return;
      numberEl.setAttribute('num', arrNumNew[index]);
      console.log('indexx: ', oldIndex, newIndex )
      animate(
        numberEl,
        { transform: [`translateY(${ -1 * oldIndex * 100}%)`, `translateY(${ -1 * newIndex * 100}%)`] },
        { duration: 0.5, easing: "ease-in-out" }
      )
    });
  }
}
class CountdownCSS extends HTMLElement {
  #hasZero = true;
  constructor() {
    super();
    this.isMinutes = this.getAttribute('is') == 'minutes';
    // Number
    $$4('[number]', this).forEach((numberEl, index) => {
      numberEl.style.height = numberEl.clientHeight + 'px';
      const length = index ? 9 : 5;
      let i, tmp = ''
      for (i = length; i >= 0; i--) {
        tmp += `<span part="num">${i}</span>`;
      }
      numberEl.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`<span part="numlist"><span part="num">0</span>${tmp}</span>`));
      tmp = '';
    });
  }
  updateAttr(newValue, hasZero) {
    if (this.getAttribute('numbers') == newValue && this.isMinutes ) return;
    this.#hasZero = hasZero;
    if (this.isMinutes) this.setAttribute('numbers', newValue);
    // Update Unit
    //console.log(newValue)
  }
  updateDelay(seconds, minutes) {
    let indexValue, durationPerStep, chenhLech,
    arrNum = Math.min(99, minutes || seconds).toString().padStart(2, "0").split('').map(Number);
    $$4('[number]', this).forEach((numberEl, index) => {
      if (minutes) {
        if (index == 0) {
          indexValue = 6 - arrNum[0];
          durationPerStep = 600;
          chenhLech = 599 - (arrNum[1] * 60 + seconds);
        } else {
          indexValue = 10 - arrNum[1];
          durationPerStep = 60;
          chenhLech = 59 - seconds;
        }
      } else {
        if (index == 0) {
          indexValue = 6 - arrNum[0];
          durationPerStep = 10;
          chenhLech = 9 - arrNum[1];
        } else {
          indexValue = 10 - arrNum[1];
          durationPerStep = 1;
          chenhLech = 0;
        }
      }
      numberEl.style.animationDelay = `${-1 * indexValue * durationPerStep - chenhLech}s`
    });
  }
}
customElements.define('hdt-countdown-js', CountdownJS);
customElements.define('hdt-countdown-css', CountdownCSS);
customElements.define('hdt-countdown-hybrid', CountdownHybrid);

var _details = new WeakMap(),
_summary = new WeakMap(),
_content = new WeakMap(),
_on_keydown = new WeakSet(), on_keydown_fn;
// , _keydown_handler = new WeakMap();
// _on_focus_out = new WeakSet(), on_focus_out_fn;
// _on_toggle = new WeakSet(), on_toggle_fn;
class Accordion extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_details, this, $4('details', this));
    getterAdd(_summary, this, $4('summary', this));
    getterAdd(_content, this, getterGet(_summary, this).nextElementSibling);
    getterAdd(_on_keydown, this);
    //getterAdd(_keydown_handler, this, getterRunFn(_on_keydown, this, on_keydown_fn).bind(this));
    // getterAdd(_on_focus_out, this);
    // getterAdd(_on_toggle, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();

    //if (this.hasAttribute('sp-focusout'))getterGet(_details, this).addEventListener('focusout', getterRunFn(_on_focus_out, this, on_focus_out_fn).bind(this), { signal: this.#abortController.signal });
    // getterGet(_details, this).addEventListener('toggle', getterRunFn(_on_toggle, this, on_toggle_fn).bind(this), { signal: this.#abortController.signal });
    getterGet(_summary, this).addEventListener("click", this._onSummaryClicked.bind(this), { signal: this.#abortController.signal });
    getterGet(_summary, this).addEventListener("pick", this._onSummaryClicked.bind(this), { signal: this.#abortController.signal });
    getterGet(_details, this).addEventListener("keydown", getterRunFn(_on_keydown, this, on_keydown_fn).bind(this), { signal: this.#abortController.signal });
    if (Shopify.designMode) {
      this.addEventListener(adnmEvts.select, () => this.toggle(), { signal: this.#abortController.signal });
      this.addEventListener(adnmEvts.deselect, () => this.toggle(false), { signal: this.#abortController.signal });
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get open() {
    return getterGet(_details, this).hasAttribute('open');
  }
  toggle(setOpen = true) {
    if ( (setOpen && !this.open) || (!setOpen && this.open)) {
      getterGet(_summary, this)?.dispatchEvent(new CustomEvent("pick", { detail: { offClick: true }}));
    }
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    if ( !event?.detail?.offClick && getterGet(_summary, this).hasAttribute("data-url") && this.hasAttribute('only-click-icon') && !event.target.hasAttribute('accordion-icon') ) {
      return window.location.href = getterGet(_summary, this).getAttribute("data-url");
    }
    getterGet(_details, this).style.overflow = "hidden";
    getterGet(_summary, this).setAttribute('aria-expanded', `${!this.open}`);
    if (this.open) {
      timeline([
        [getterGet(_content, this), { opacity: 0 }, { duration: 0.15 }],
        [getterGet(_details, this), { height: [`${getterGet(_details, this).clientHeight}px`, `${getterGet(_summary, this).clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
      ]).finished.then(() => {
        getterGet(_details, this).style.height = null;
        getterGet(_details, this).style.overflow = null;
        getterGet(_details, this).removeAttribute('open');
      });
    } else {
      getterGet(_details, this).setAttribute('open', '');
      timeline([
        [getterGet(_details, this), { height: [`${getterGet(_summary, this).clientHeight}px`, `${getterGet(_details, this).scrollHeight}px`] }, { duration: 0.25, easing: "ease" }],
        [getterGet(_content, this), { opacity: [0, 1], transform: ["translateY(4px)", `translateY(0)`] }, { duration: 0.15, at: "-0.1" }]
      ]).finished.then(() => {
        getterGet(_details, this).style.height = null;
        getterGet(_details, this).style.overflow = null;
      });
    }
  }
};
// on_focus_out_fn = function(e) {
// console.log(e)
//   setTimeout(() => {
//     if (!this.contains(document.activeElement)) getterGet(_summary, this)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}));
//   });
// };
// on_toggle_fn = function(e) {
//   console.log(e)
// };
on_keydown_fn = function(e) {
  // console.log('swwww')
  // console.log(e.key, e.target)
  if (e.key != 'Enter' || !e.target?.hasAttribute('accordion-icon')) return;
  // console.log('eee 111')
  e.preventDefault();
  e.stopPropagation();
  e.target.click();
  // this.toggle(this.open);
};
customElements.define("hdt-accordion", Accordion);

// class AccordionUrl extends Accordion {
// }
// customElements.define("hdt-accordion-url", AccordionUrl);

class Tab extends HTMLElement {
  #abortController;
  connectedCallback() {
    if (!this.idControls) return;
    this.buttons = $$4('button:not(.hdt-slider__button)', this);
    this.items = $$4('[tab-item]', this.idControls);
    this.#abortController = new AbortController();
    this.oldIndex = 0;
    this.buttons.forEach( (button) => button.addEventListener("click", () => this._onButtonClicked(button, this.buttons.indexOf(button)), { signal: this.#abortController.signal }) );
    if (Shopify.designMode) {
      this.addEventListener(adnmEvts.select, (e) => e.target.click() );
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get idControls() {
    return $id4(this.getAttribute("aria-controls"));
  }

  /**
   * Create the animation controls for the enter animation
   */
  animateHide() {
    return animate(this.items[this.oldIndex], { opacity: [1, 0], transform: ["translateY(0px)", "translateY(19px)"] }, { duration: 0.2, easing: "ease-in" });
  }
  /**
   * Create the animation controls for the leave animation
   */
  animateShow(newIndex) {
    return animate(this.items[newIndex], { opacity: [0, 1], transform: ["translateY(19px)", "translateY(0px)" ] }, { duration: 0.1, delay: 0.1, easing: "ease-out" });
  }
  _onButtonClicked(button, newIndex) {
    //console.log(newIndex, this.oldIndex)
    //this.#abortController.abort;
    if (button.getAttribute("aria-current") === "true") return;

    this.buttons.forEach((btn, index) => btn.setAttribute('aria-current', (newIndex == index).toString()));
    //this.buttons[newIndex].setAttribute('aria-current','true');
    //this.buttons.forEach((button, index) => button.setAttribute("aria-current", newIndex === index ? "true" : "false"));

    const animateHidePromise = this.animateHide().finished;
    animateHidePromise.then(() => {
      this.items[this.oldIndex].removeAttribute("tab-selected");
      this.oldIndex = newIndex;
      this.items[newIndex].setAttribute('tab-selected', '');
      this.animateShow(newIndex)
    });
  }

};
customElements.define('hdt-tab', Tab);

class Marquee extends HTMLElement {
 #resizeObserver;
  constructor() {
    super();
    const rawDirection = this.getAttribute('direction') || 'ltr';
    this._speed = 300 * parseFloat(this.getAttribute('speed-factor') || 0.4); // Move 300px/s
    this._direction = isRTL ? rawDirection === 'ltr' ? 'rtl' : 'ltr' : rawDirection;
    this._animation = null;
    this.#resizeObserver = null,
    this._lastWidth = 0;
  }

  connectedCallback() {
    this._inner = $4('.hdt-marquee-inner', this);
    //console.log(this)
    if (!this._inner) {
      let _originalItem = $4('.hdt-marquee-item', this);
      this.innerHTML = '';
      this._inner = document.createElement('div');
      this._inner.className = 'hdt-marquee-inner';
      this.appendChild(this._inner);
      this._inner.appendChild(_originalItem.cloneNode(true));
    }

    this._setup()
    this.#resizeObserver = new ResizeObserver(this._setup.bind(this));
    this.#resizeObserver.observe(this);
    //window.addEventListener('resize', this._setup.bind(this));
    // Hover pause
    if (this.hasAttribute('pausable') && matchMediaQuery("motion")) {
      this.addEventListener('mouseenter', () => this._animation?.pause());
      this.addEventListener('mouseleave', () => this._animation?.play());
    }
  }

  disconnectedCallback() {
    this._lastWidth = 0;
    this._animation?.cancel();
    //window.removeEventListener('resize', this._setup);
    this.#resizeObserver?.disconnect();
  }

  _setup() {
    let firstWidth = this._inner.firstElementChild.offsetWidth;
    if (firstWidth === 0 || this._lastWidth == firstWidth) return;

    this._animation?.cancel();
    this._lastWidth = firstWidth;
    $$4('.hdt-marquee--duplicate', this).forEach(e => e.remove() );
    //this._inner.innerHTML = '';
    //console.log(this._inner?.firstElementChild)

    const cloneTimes = Math.ceil((this.offsetWidth * 2) / firstWidth);

    const frag = document.createDocumentFragment();
    let i;
    let clone;
    for (i = 0; i < cloneTimes; i++) {
      clone = this._inner.firstElementChild.cloneNode(true);
      clone.setAttribute('aria-hidden',true);
      clone.classList.add('hdt-marquee--duplicate');
      frag.appendChild(clone);
    }
    this._inner.append(frag);
    clone = null;

    if (!matchMediaQuery("motion")) return;

    const moveDistance = this._inner.scrollWidth / 2;
    const duration = moveDistance / this._speed; // seconds
    //console.log(duration)

    const from = this._direction === 'rtl' ? '0px' : `-${moveDistance}px`;
    const to = this._direction === 'rtl' ? `-${moveDistance}px` : '0px';
    //console.log(from, to, this._direction)

    this._animation = animate(this._inner, {
      transform: [`translateX(${from}) translateZ(0)`, `translateX(${to}) translateZ(0)`]
    }, {
      duration: duration,
      easing: 'linear',
      repeat: Infinity
    });
  }
}
customElements.define('hdt-marquee', Marquee);

var _effect, effect_fn, _img_effect = new WeakMap();
class ImageEffect extends HTMLElement {
  constructor() {
    super();
    getterAdd(_effect, this);
    getterAdd(_img_effect, this, $4('picture img, img', this));
  }
  connectedCallback() {
    if (matchMediaQuery("motion") && getterGet(_img_effect, this) ) getterRunFn(_effect, this, effect_fn).call(this);
  }
}
_effect = new WeakSet();
effect_fn = function() {
  const getEffect = this.getAttribute('eff');
  if ( getEffect === 'ambient' ) {
    // ambient
    animate(getterGet(_img_effect, this), { transform: ["rotate(0deg) translateX(1em) rotate(0deg) scale(1.2)", "rotate(360deg) translateX(1em) rotate(-360deg) scale(1.2)"] }, {
      duration: 30,
      easing: "linear",
      repeat: Infinity
    });
  } else if ( getEffect === 'parallax' ) {
    // parallax
    const getScale = parseFloat(this.style.getPropertyValue("--parallax-scale") || 1.3),
    [scale, translate] = [getScale, 0.15 * 100 / getScale],
    isFirstSection = this.closest(".hdt-section").matches(":first-child");
    scroll(
      animate(getterGet(_img_effect, this), { transform: [`scale(${scale}) translateY(-${translate}%)`, `scale(${scale}) translateY(${translate}%)`] }, { easing: "linear" }),
      {
        target: getterGet(_img_effect, this),
        offset: [isFirstSection ? "start start" : "start end", "end start"]
      }
    );
  }
};
customElements.define("hdt-effect-img", ImageEffect);

// var _updateSizes, updateSizes_fn, _optimumx;
// class ImageLazy extends HTMLImageElement {
//   constructor() {
//     super(...arguments);
//     if (this.getAttribute('data-sizes') === 'auto') {
//       getterAdd(_optimumx, this, this.getAttribute('data-optimumx') || 1);
//       getterAdd(_updateSizes, this);
//       getterRunFn(_updateSizes, this, updateSizes_fn).call(this);
//       this.resizeObserver = new ResizeObserver(entries => getterRunFn(_updateSizes, this, updateSizes_fn).call(this));
//       this.resizeObserver.observe(this);
//     }
//   }
// }
// _updateSizes = new WeakSet();
// _optimumx = new WeakMap();
// updateSizes_fn = function() {
//   this.setAttribute('sizes', this.offsetWidth * getterGet(_optimumx, this) +'px');
// };
// customElements.define("hdt-lazy", ImageLazy, { extends: "img" });
// Use <img is="hdt-lazy" data-sizes="auto" src="..">

var _resizeObserver, resizeObserver_fn;
class HeightObserver extends HTMLElement {
  constructor() {
    super();
    getterAdd(_resizeObserver, this)
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(getterRunFn(_resizeObserver, this, resizeObserver_fn).bind(this))).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) html.style.setProperty(`--${this.getAttribute("prefix")}-height`, `${Math.round(this.clientHeight)}px`);
  }
};
_resizeObserver = new WeakSet();
resizeObserver_fn = function(entries) {
  entries.forEach((entry) => {
    if (entry.target === this) {
      const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
      if (Math.round(height) !== 0){
        html.style.setProperty(`--${this.getAttribute("prefix")}-height`, `${Math.round(height)}px`);
      }
    }
  });
};
customElements.define("hdt-height-observer", HeightObserver);

// Header JS

class StickyHeader extends HeightObserver {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkTransparent();
    super.connectedCallback();
    this.stickyType = this.getAttribute('sticky-type');
    if (this.stickyType === 'none') return;

    this.header = this.closest('.hdt-section-header');
    this.headerIsAlwaysSticky = this.stickyType === 'always';
    this.headerBounds = {};

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = $4('predictive-search', this);

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.scrollY || html.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    //console.log(this.headerBounds)

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    // this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    //$$4('hdt-header-menu details[open]', this.header).forEach(disclosure => $4('summary', disclosure).dispatchEvent(new CustomEvent("click", { detail: { offClick: true }})));
    $$4('hdt-header-menu > details[open]', this.header).forEach(disclosure => disclosure.parentElement.toggle(false));
  }

  // closeSearchModal() {
    // this.searchModal = this.searchModal || $$4('details-modal', this.header);
    // this.searchModal.close(false);
  // }

  checkTransparent() {
    if ( !$4('.section-allow-transparent.hdt-section:first-child') || $4('.hdt-section-header + .shopify-section-group-header-group') ) return;
    html.setAttribute('enabled-transparent-header', '');
  }
}
customElements.define("hdt-sticky-header", StickyHeader);

var _event, _position, _isCenterOnScreen, _x, _needCalc,
_clickOutside, clickOutside_fn, _click_outside_handler = new WeakMap(),
_escape, escape_fn, _escape_handler = new WeakMap();
class MegaMenu extends Accordion {
  constructor() {
    super();
    if (matchMediaQuery("mobile")) return;
    // this.clickOutsideHandler = this.clickOutside.bind(this);
    // this.escapeHandler = this.escape.bind(this);
    if (this.event === "hover") {
      new HoverIntent(
        getterGet(_details, this),
        {
          // required parameters
          onEnter: (el) => {
            //console.log(el)
            getterGet(_summary, this).classList.add('is_action-hover');
            this.toggle()
            //getterGet(_summary, el)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}))
            //this.toggle(true);
          },
          onExit: (el) => {
            getterGet(_summary, this).classList.remove('is_action-hover');
            this.toggle(false);
            //getterGet(_summary, el)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}))
            //this.toggle(false);
          },
          // default options
          exitDelay: 150,
          interval: 35,
          sensitivity: 3
        },
        getterGet(_summary, this)
      );
    }

    getterAdd(_clickOutside, this);
    getterAdd(_escape, this);
    getterAdd(_escape_handler, this, getterRunFn(_escape, this, escape_fn).bind(this));
    getterAdd(_click_outside_handler, this, getterRunFn(_clickOutside, this, clickOutside_fn).bind(this));
  }
  get expanded () {
    return getterGet(_summary, this).getAttribute("aria-expanded") === "true";
  }

  // get eventAttr() {
  //   return this._eventAttr = this._eventAttr || this.getAttribute("event");
  // }
  get event() {
    return getterGet(_event, this, !matchMediaQuery("hover") ? "click" : this.getAttribute("event"));
  }
  get position() {
    return getterGet(_position, this, this.getAttribute('position') || 'bottom');
  }

  get isCenterOnScreen() {
    return getterGet(_isCenterOnScreen, this, this.position === 'center_on_screen');
  }

  get needCalc() {
    return getterGet(_needCalc, this, !getterGet(_details, this).hasAttribute('not-need-calc'));
  }

  get x() {
    return getterGet(_x, this, this.isCenterOnScreen ? '-50%' : '0');
  }

  _onSummaryClicked(event) {
    if ( !event?.detail?.offClick && getterGet(_summary, this).hasAttribute("data-url") && (this.expanded && this.hasAttribute("opened-able-click")) ) {
      return window.location.href = getterGet(_summary, this).getAttribute("data-url");
    }
    event.preventDefault();
    getterGet(_summary, this).setAttribute('aria-expanded', `${!this.open}`);
    if (this.open) {
      //document.removeEventListener("click", getterRunFn(_clickOutside, this, clickOutside_fn).bind(this));
      //document.removeEventListener("click", getterGet(_click_outside_handler, this));
      document.removeEventListener("keydown", getterGet(_escape_handler, this));
      getterGet(_details, this).removeEventListener("focusout", this.#onFocusOut);
      timeline([
        [getterGet(_content, this), { opacity: [1, 0], visibility: ["visible", "hidden"], transform: [`translateX(${this.x}) translateY(0)`, `translateX(${this.x}) translateY(15px)`] }, { duration: 0.4, easing: [0.19, 1, 0.22, 1] }]
      ]).finished.then(() => {
        getterGet(_details, this).removeAttribute('open');
      });
    } else {
      //document.addEventListener("click", getterRunFn(_clickOutside, this, clickOutside_fn).bind(this));
      //document.addEventListener("click", getterGet(_click_outside_handler, this));
      document.addEventListener("keydown", getterGet(_escape_handler, this));
      getterGet(_details, this).addEventListener("focusout", this.#onFocusOut);
      getterGet(_details, this).setAttribute('open', '');
      if ( this.needCalc && !this.isCenterOnScreen ) updatePositionFloatingEl.call(this, getterGet(_summary, this), getterGet(_content, this), null, this.position, false);
      timeline([
        [getterGet(_content, this), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: [`translateX(${this.x}) translateY(15px)`, `translateX(${this.x}) translateY(0)`] }, { duration: 0.4, easing: [0.19, 1, 0.22, 1] }]
      ]).finished.then(() => {
      });
    }
  }
  #onFocusOut = (evt) => {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.toggle(false);
    });
  }
}
_event = new WeakMap();
_position = new WeakMap();
_isCenterOnScreen = new WeakMap();
_x = new WeakMap();
_needCalc = new WeakMap();
_clickOutside = new WeakSet();
_escape = new WeakSet();
clickOutside_fn = function(event) {
  if (this.event !== "click") return;
  if (!this.contains(event.target)) {
    //console.log('this', this,  $4('details[open]', this))
    //$4('details[open] summary', this)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}));
    this.toggle(false);
  }
};
escape_fn = function(event) {
  if (event.code === "Escape") {
    const details = event.target.closest('details[open]');
    //console.log('Escape', this, event.target);
    if (details ) {
      //getterGet(_summary, this).dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}));
      this.toggle(false);
      event.stopPropagation();
    }
  }
};
customElements.define("hdt-header-menu", MegaMenu);

// Product card JS
var _color_limit, color_limit_fn,
_color_item_first, _color_item_last,
_color_resizeObserver, color_resizeObserver_fn,
_width_color_list, _click_color_viewmore, click_color_viewmore_fn, _color_slider,
isColorLimit = 'is--color-limit',
_delegate2,
_even_color, _color_changed_data, color_changed_data_fn,
_color_products, _color_product_urls, _color_product_url_first,
_color_on_hovered, color_on_hovered_fn, _create_img, create_img_fn, _color_vimgs,
_color_fieldset = new WeakMap();
class ColorList extends HTMLElement {
  constructor() {
    super();
    getterAdd(_delegate2, this , new Delegate(this));
    getterAdd(_color_changed_data, this);
    getterAdd(_color_on_hovered, this);
    getterAdd(_create_img, this);
    getterAdd(_color_products, this, this.closest('.hdt-card-product'));
    getterAdd(_color_product_urls, this, $$4('[data-pr-url]', getterGet(_color_products, this)));
    getterAdd(_color_fieldset, this, $4('fieldset', this));
  }
  connectedCallback() {
    // Check has variant image to change
    if ($$4('[type="radio"]:not([disabled])', this).length > 0 ) {
      getterGet(_delegate2, this).on("change", '[type="radio"]', getterRunFn(_color_changed_data, this, color_changed_data_fn).bind(this));
      getterGet(_delegate2, this).on("pointerover", '[type="radio"][data-vimg] + label', getterRunFn(_color_on_hovered, this, color_on_hovered_fn).bind(this), true);

      if (!matchMediaQuery("mobile") && this.event == 'hover') {
        $$4('[type="radio"] + label', this).forEach((label) => {
          new HoverIntent(
            label,
            {
              onEnter: (el) => el.click(),
              onExit: (el) => {}, exitDelay: 100, interval: 100, sensitivity: 6
            }
          );
        });
      }
    }
    if (getterGet(_color_fieldset, this).childElementCount > 2) {
      getterAdd(_width_color_list, this, 0);
      //getterAdd(_width_color_first, this, 0);
      getterAdd(_color_item_first, this, getterGet(_color_fieldset, this).firstChild);
      getterAdd(_color_item_last, this, getterGet(_color_fieldset, this).lastChild);
      getterAdd(_color_resizeObserver, this);
      getterAdd(_color_slider, this, this.closest('.hdt-slider__products'));
      // if has more than 2 colors then run fn
      if (this.hasAttribute('auto-limit') ) {
        getterAdd(_color_limit, this);
        if (window.ResizeObserver) {
          let resizeObserver = new ResizeObserver(throttle(getterRunFn(_color_resizeObserver, this, color_resizeObserver_fn).bind(this)));
          resizeObserver.observe(this);
          this.addEventListener('unobserve', ()=> { resizeObserver.unobserve(this); resizeObserver = null });
        } else {
          getterRunFn(_color_limit, this, color_limit_fn).call(this);
        }
      }
      if (this.hasAttribute('action-all') ) {
        getterAdd(_click_color_viewmore, this);
        getterGet(_color_item_last, this).addEventListener("click", getterRunFn(_click_color_viewmore, this, click_color_viewmore_fn).bind(this));
        if (window.ResizeObserver && !this.hasAttribute('auto-limit')) {
          let resizeObserver2 = new ResizeObserver(throttle(getterRunFn(_color_resizeObserver, this, color_resizeObserver_fn).bind(this)));
          resizeObserver2.observe(this);
          this.addEventListener('unobserve2', ()=> { resizeObserver2.unobserve(this); resizeObserver2 = null });
        }
      }
    }
  }
  disconnectedCallback() {
    getterGet(_delegate2, this).off();
  }
  get event() {
    return getterGet(_even_color, this, !matchMediaQuery("hover") ? "click" : this.getAttribute("event"));
  }
}
_color_limit = new WeakSet();
_color_item_first = new WeakMap();
_color_item_last = new WeakMap();
_color_resizeObserver = new WeakSet();
_click_color_viewmore = new WeakSet();
_width_color_list = new WeakMap();
//_width_color_first = new WeakMap();
_color_slider = new WeakMap();
_delegate2 = new WeakMap();
_even_color = new WeakMap();
_color_changed_data = new WeakSet();
_color_products = new WeakMap();
_color_product_urls = new WeakMap();
_color_product_url_first = new WeakMap();
_color_vimgs = new WeakMap();

color_limit_fn = function() {
  const color_item_width = getterGet(_color_item_first, this).getBoundingClientRect().width, //
        more_item_width  = getterGet(_color_item_last, this).getBoundingClientRect().width, // getBoundingClientRect().width or this.clientWidth
        computedStyles   = getComputedStyle(getterGet(_color_fieldset, this)),
        item_gap         = parseFloat(computedStyles.gap || computedStyles.columnGap || 10),
        countItem        = getterGet(_color_fieldset, this).childElementCount - 1,
        totalWidthGap    = color_item_width * countItem + (countItem - 1) * item_gap,
        { width }        = getterGet(_color_fieldset, this).getBoundingClientRect(),
        maxFit           = Math.floor(width / (color_item_width + item_gap)),
        maxFitWithMore   = Math.floor((width - more_item_width) / (color_item_width + item_gap ));

  //console.log('maxFit', maxFit, maxFitWithMore, item_gap, width, more_item_width, color_item_width)
  if (maxFit >= countItem || totalWidthGap <= getterGet(_width_color_list, this)) {
    getterGet(_color_item_last, this).setAttribute('hidden', '');
    $4('.'+isColorLimit, this)?.classList.remove(isColorLimit);
  } else {
    //console.log('maxFit', maxFit, maxFitWithMore, item_gap, width, more_item_width, color_item_width, getterGet(_color_item_first, this).clientWidth)
    getterGet(_color_fieldset, this).childNodes[maxFitWithMore]?.classList.add(isColorLimit);
    $4('.'+isColorLimit, this)?.classList.remove(isColorLimit);
    getterGet(_color_item_last, this).lastElementChild.textContent = `+${countItem - maxFitWithMore}`;
    getterGet(_color_item_last, this).style.opacity = 1;
  }
};
color_resizeObserver_fn = function(entries) {
    // Run slider if has
    if (getterGet(_color_slider, this)) getterGet(_slider_api, getterGet(_color_slider, this)).reInit();

    if ( getterGet(_width_color_list, this) == entries[0].contentRect.width ) return;
    getterAdd(_width_color_list, this, entries[0].contentRect.width, true);

    // if ( getterGet(_width_color_list, this) || (this.oldWidth == this.clientWidth) ) {
    //   //this.oldWidth = 0;
    //   return this.oldWidth = 0;
    // }
    // this.oldWidth = this.clientWidth;

    if (this.hasAttribute('auto-limit') ) {

      //if ( getterGet(_color_item_first, this).getBoundingClientRect().width == getterGet(_width_color_first, this) ) return;
      // Reset
      $4('.'+isColorLimit, this)?.classList.remove(isColorLimit);
      getterGet(_color_fieldset, this).childNodes[1]?.classList.add(isColorLimit);
      getterGet(_color_item_last, this).removeAttribute('hidden');
      getterGet(_color_item_last, this).style.opacity = 0;
      // Run fn
      getterRunFn(_color_limit, this, color_limit_fn).call(this);
      // setTimeout(() => {
      //   getterRunFn(_color_limit, this, color_limit_fn).call(this);
      // }, 0);
    } else {
      getterGet(_color_fieldset, this).childNodes[parseInt(this.getAttribute('maximum'))]?.classList.add(isColorLimit);
      getterGet(_color_item_last, this).removeAttribute('hidden');
    }
};
click_color_viewmore_fn = function(e) {
  e.preventDefault();
  this.dispatchEvent(new CustomEvent("unobserve", { cancelable: true, composed: true }));
  this.dispatchEvent(new CustomEvent("unobserve2", { cancelable: true, composed: true }));
  //getterAdd(_width_color_list, this, true, true);
  const $limit = $4('.'+isColorLimit, this);
  $limit?.classList.remove(isColorLimit);
  getterGet(_color_item_last, this).setAttribute('hidden', '');
  this.style.minHeight = this.clientHeight + 'px';
  animate(
    getterGet(_color_fieldset, this).children,
    //{ opacity: [0, 1], scale: [.5 ,1], y: [10 ,0] },
    { opacity: [0, 1], transform: ["scale(.5) translateY(10px)", "scale(1) translateY(0)"] },
    { duration: 0.35, delay: stagger(0.05, { easing: "ease-out" }), easing: "ease" }
  ).finished.then(() => {
    this.style.minHeight = null;
    //setTimeout(() => getterAdd(_width_color_list, this, false, true), 10);
    if (getterGet(_color_slider, this)) getterGet(_slider_api, getterGet(_color_slider, this)).reInit();
  });
  // focus
  $limit?.previousElementSibling.querySelector('input')?.focus();
};
color_changed_data_fn = function(e, target) {
  // Update variant url
  if ( getterGet(_color_product_urls, this).length ) {
    const url = UrlWithVariant.get(getterGet(_color_product_url_first, this, getterGet(_color_product_urls, this)[0].href), target.dataset.vid);
    getterGet(_color_product_urls, this).forEach((link) => {
      link.href = url;
    });
  }
  //getterRunFn(_update_img_variant_card, this, update_img_variant_card_fn).call(this, )
  // Update image
  const vimg = getterGet(_color_vimgs, target, target.getAttribute('data-vimg'));
  if (vimg) {
    const mediaMain = getterGet(_color_products, this).querySelector('.hdt-card-product__media--main');

    if ( vimg !== mediaMain.getAttribute('src')){
      mediaMain.parentElement.removeAttribute('loaded');
      mediaMain.parentElement.setAttribute('loading', '');
      mediaMain.replaceWith(getterRunFn(_create_img, this, create_img_fn).call(this, vimg, mediaMain));
    }
  }
  // Update price
  const vprice = Number(target.dataset.vprice);
  if(!vprice) return;
  const $price = $4('hdt-price', target.closest('hdt-card-product'));
  if (vprice && $price) {
    $price.classList.remove('hdt-price-item--range');
    $price.innerHTML = `<span class="hdt-money">${formatMoney(vprice)}</span>`;
  }
  const vcpprice = Number(target.dataset.vcpprice);
  const $cpprice = $4('hdt-compare-at-price', target.closest('hdt-card-product'));
  if (vcpprice && $cpprice) {
    $cpprice.removeAttribute('hidden');
    $cpprice.classList.remove('hdt-hidden');
    $cpprice.innerHTML = `<span class="hdt-money">${formatMoney(vcpprice)}</span>`;
  }
  else if (vcpprice && !$cpprice) {
    let cpprice = document.createElement('hdt-compare-at-price');
    cpprice.classList.add('hdt-compare-at-price');
    cpprice.innerHTML = `<span class="hdt-money">${formatMoney(vcpprice)}</span>`;
    $price.parentElement.prepend(cpprice);
  }
  else if ($cpprice) {
    $cpprice.setAttribute('hidden', '');
    $cpprice.innerHTML = '';
  }
};
_color_on_hovered = new WeakSet();
color_on_hovered_fn = function(e, target) {
  const radio = target.previousElementSibling;
  if (!radio ) return;
  const vimg = getterGet(_color_vimgs, radio, radio.getAttribute('data-vimg'));
  // Preload image
  if (vimg) {
    const mediaMain = getterGet(_color_products, this).querySelector('.hdt-card-product__media--main');
    if ( vimg !== mediaMain.getAttribute('src')) getterRunFn(_create_img, this, create_img_fn).call(this, vimg, mediaMain);
  }
};
_create_img = new WeakSet();
create_img_fn = function(vimg, mediaMain) {
  return createImg({
    src: vimg,
    width: mediaMain.getAttribute('width'),
    height: mediaMain.getAttribute('height'),
    alt: mediaMain.alt,
    onload: true,
    attrs: {
      class: mediaMain.className,
      sizes: mediaMain.sizes,
      'data-widths': mediaMain.getAttribute('data-widths') || '[]'
    }
  })
};
// customElements.define("wrapp-hdt-color-list", ColorList);
/**
   * Returns a URL with a variant ID query parameter. Useful for updating window.history
   * with a new URL based on the currently select product variant.
   * @param {string} url - The URL you wish to append the variant ID to
   * @param {number} id  - The variant ID you wish to append to the URL
   * @returns {string} - The new url which includes the variant ID query parameter
   */
var cacheUrlVariant = {};
var UrlWithVariant = class {
  static get(url, id) {
    if (!url || !id)  return;
    if (cacheUrlVariant[id]) {
      return cacheUrlVariant[id];
    }
    url = new URL(url);
    url.searchParams.set("variant", id);
    return cacheUrlVariant[id] = url.toString();
  }
};
// Test
// console.log(UrlWithVariant.get('sssss', 1111))
// console.log(UrlWithVariant.get('sssss?xxx', 1111))
// console.log(UrlWithVariant.get('sssss?variant=1111', 22))
// console.log(UrlWithVariant.get('sssss?xxx&variant=1111', 22))
// console.log(cacheUrlVariant)


// Product JS
const {currencyFormat} = themeHDN.settings,
variantChange = "variant:change";

var _section_ids_modal = new WeakMap();
//dialogOpening, dialogOpen, dialogClosing, dialogClose
class LazyModal extends ModalComponent {
  constructor() {
    super();
    getterAdd(_section_ids_modal, this, this.getAttribute('section-id'));
    this._inner = $4('.hdt-dialog-modal__inner', this);
  }
  async open(jump = false) {
    const handle = this.btnOpening?.getAttribute("handle");
    if (!handle) return;

    document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
    this.btnOpening?.setAttribute("aria-busy", "true");
    const searchParams = this.btnOpening?.getAttribute("search-params") || '';
    const fetchUrl = `${window.Shopify.routes.root}products/${handle}?section_id=${getterGet(_section_ids_modal, this)}${searchParams ? '&' + searchParams.replace(/^\?/, '') : ''}`;
    const responseSection = await (await fetchCache(fetchUrl)).text();
    document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
    this.btnOpening?.setAttribute("aria-busy", "false");
    const domElement = new DOMParser().parseFromString(responseSection, "text/html"),
    newSectionModal = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-${getterGet(_section_ids_modal, this)}`).innerHTML);
    this._inner.replaceChildren(...newSectionModal.children);
    rteWrapTable(this);
    accessibleLinks(this);
    localeUrl(this);
    Shopify?.PaymentButton?.init();
    document.dispatchEvent(new CustomEvent(currencyUpdate));

    const $badgesHidden = $$4('hdt-badge[update-hidden]', this);
    if ($badgesHidden.length) $badgesHidden.forEach((badge) => badge.updateHiddenParent())
    requestAnimationFrame(() => {
    super.open(jump);
    })
  }
  async close(jump = false) {
    await super.close(jump);
    this._inner.innerHTML = "";
  }
  get btnOpening() {
    return this.dialog?.btnOpening;
  }
}
class FetchButtonModal extends btnTooltip {
  constructor() {
    super();
    //$id4(this.firstElementChild.getAttribute('aria-controls'))?.updateBtbsOpen(this);
  }
  connectedCallback() {
    super.connectedCallback();
    $4('hdt-tmp-quick')?.dispatchEvent(new CustomEvent("theme:update:id", { bubbles: false }));
  }
}

class TmpQuick extends HTMLElement {
  constructor() {
    super();
    this.getIDTemp();
    this.addEventListener('theme:update:id', () => this.getIDTemp());
  }
  //connectedCallback() {}
  async getIDTemp() {
    const $btn = $4('[aria-controls="hdt-quick-view-modal"], [aria-controls="hdt-quick-add-modal"]');
    if (!$btn || this.hasID) return;
    this.hasID = true;
    this.removeEventListener('theme:update:id', () => this.getIDTemp());
    let responseAsText,
    idCache = "themeQuick2" + window.Shopify.theme.id;
    if (sessionStorage.getItem(idCache) && !Shopify.designMode) {
      responseAsText = sessionStorage.getItem(idCache);
    } else {
      responseAsText = await (await fetch(`${window.Shopify.routes.root}products/${$btn.getAttribute('handle')}?view=only_config`, {priority: 'low'})).text();
      let selector = new DOMParser().parseFromString(responseAsText, "text/html");
      $4('.hdt-main-section--color-swatch', selector).remove();
      $4('.hdt-section-config', selector).remove();
      sessionStorage.setItem(idCache, $4('#hdt-page-product-config', selector).innerHTML)
    }
    const tmp = new DOMParser().parseFromString(responseAsText, "text/html");
    $$4('.hdt-main-section--quick-view, .hdt-main-section--quick-add', tmp).forEach( (modal)=> this.insertAdjacentHTML("afterend", modal.innerHTML));
    this.remove();
  }
}

customElements.define('hdt-lazy-modal', LazyModal);
customElements.define("wrapp-hdt-open-modal-btn", FetchButtonModal);
customElements.define('hdt-tmp-quick', TmpQuick);

import { CartAddEvent, CartErrorEvent } from '@theme/events';
class ProductForm extends HTMLElement {
  #abortController;
  /** @type {number | undefined} */
  #timeout;
  constructor() {
    super();
    this.form = $4('form', this);
  }
  connectedCallback() {
    if (!this.form) this.form = $4('form', this);
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    if (!this.form) throw new Error('Product form element missing');
    this.form?.addEventListener("submit", this.#handleSubmit.bind(this), { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /**
   * Handles the submit event for the product form.
   *
   * @param {Event} event - The submit event.
   */
  #handleSubmit(event) {
    const addToCartError = $4('[ref="addToCartTextError"]', this),
    addToCartButton = $4('[type="submit"][name="add"]', this);
    // Stop default behaviour from the browser
    event.preventDefault();
    if (this.form.checkBreak) return;
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    if (this.#timeout) clearTimeout(this.#timeout);

    // Check if the add to cart button is disabled and do an early return if it is
    if (!addToCartButton || addToCartButton?.getAttribute('disabled') === 'true') return;
    addToCartButton.setAttribute("disabled", "true");
    addToCartButton.setAttribute("aria-busy", "true");
    const formData = new FormData(this.form);
    if (this.cart) formData.append('sections', this.cart.sectionId);
    const fetchCfg = fetchConfig('javascript', { body: formData });
    fetch(`${Shopify.routes.root}cart/add.js`, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.removeAttribute("aria-busy");
        if (response.status) {
          // Error from Shopify
          window.dispatchEvent(new CartErrorEvent(this.id, response.message));
          if (addToCartError) {
            addToCartError.removeAttribute('hidden');
            $4('.hdt-error-message', addToCartError).textContent = response.message;
          }
          // When we add more than the maximum amount of items to the cart, we need to dispatch a cart update event
          // because our back-end still adds the max allowed amount to the cart.
          document.dispatchEvent(new CustomEvent(cartReload));
          // this.dispatchEvent(
          //   new CartAddEvent(
          //     {},
          //     id.toString(),
          //     response,
          //     formData.get("action_added"),
          //     'product-form-component',
          //     {
          //       didError: true,
          //       itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
          //       productId: this.dataset.productId
          //     }
          //   )
          // );
          return;
        } else {
          // Success from Shopify
          const id = this.isFrmBundle ? 'Bundle' : formData.get('id');
          if (addToCartError) {
            addToCartError.setAttribute('hidden', '');
          }

          if (!id) throw new Error('Form ID is required');

          // Add aria-live region to inform screen readers that the item was added
          addToCartButton.setAttribute('aria-live', 'polite');

            // this.#setLiveRegionText(addedText);

            // setTimeout(() => {
            //   this.#clearLiveRegionText();
            // }, 5000);
          //console.log('Success: add to cart', response);
          this.dispatchEvent(
            new CartAddEvent(
              {},
              id.toString(),
              response,
              formData.get("action_added"),
              'product-form-component',
              {
                itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
                productId: this.dataset.productId,
                sections: response.sections,
              }
            )
          );
          if (themeHDN.settings.actionAfterATC == 'no') {
            document.dispatchEvent(new CustomEvent(cartReload));
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        // add more thing to do in here if needed.
      });
  }
  get cart() {
    return this._cart = this._cart || $4('[ref="hdt-cart"]');
  }
}

var _update_bundle_total, update_bundle_total_fn,
_update_total_bundle = new WeakMap();
class ProductFormBundle extends ProductForm {
  constructor() {
    super();
    getterAdd(_update_bundle_total, this);
  }
  get isFrmBundle() {
    return true;
  }
  connectedCallback() {
    super.connectedCallback();
    getterAdd(_update_total_bundle, this, $4('[update-total]', this));
    this.totalPrice = Number(getterGet(_update_total_bundle, this).dataset.price);
    this.totalComparePrice = Number(getterGet(_update_total_bundle, this).dataset.cpprice);
    this.addEventListener("update:bundle:total", getterRunFn(_update_bundle_total, this, update_bundle_total_fn).bind(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("update:bundle:total", getterRunFn(_update_bundle_total, this, update_bundle_total_fn).bind(this));
  }
};
_update_bundle_total = new WeakSet();
update_bundle_total_fn = function(event) {
  if (event.detail.action == 'plus') {
    this.totalPrice = this.totalPrice + event.detail.remainPrice;
    this.totalComparePrice = this.totalComparePrice + event.detail.remainComparePrice;
  } else {
    this.totalPrice = this.totalPrice - event.detail.remainPrice;
    this.totalComparePrice = this.totalComparePrice - event.detail.remainComparePrice;
  }
  const $comapre = $4('hdt-compare-at-price', getterGet(_update_total_bundle, this));
  if ($comapre) {
    $comapre.toggleAttribute('hidden', this.totalComparePrice <= this.totalPrice);
    $4('.hdt-money', $comapre).outerHTML = `<span class="hdt-money">${formatMoney(this.totalComparePrice)}</span>`;
  }
  // $4('hdt-compare-at-price .hdt-money', getterGet(_update_total_bundle, this)).innerHTML = formatMoney(this.totalComparePrice);
  // $4('hdt-price .hdt-money', getterGet(_update_total_bundle, this)).innerHTML = formatMoney(this.totalPrice);
  $4('hdt-price .hdt-money', getterGet(_update_total_bundle, this)).outerHTML = `<span class="hdt-money">${formatMoney(this.totalPrice)}</span>`;
  document.dispatchEvent(new CustomEvent("currency:update"));
};

var _bundle_product, bundle_product_fn,
_bundle_items = new WeakMap();
class bundleProduct extends HTMLElement {
  #abortController
  constructor() {
    super();
    getterAdd(_bundle_product, this);
    getterAdd(_bundle_items, this, $$4('[name^="items[]"]', this));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const itemId = $4('[name="items[][id]"]', this);
    this.price = Number(itemId.dataset.price);
    this.comparePrice = Number(itemId.dataset.cpprice);
    this.addEventListener('change', getterRunFn(_bundle_product, this, bundle_product_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get observes() {
    return this._observes = this._observes || $id4(this.getAttribute('observes'));
  }
}
_bundle_product = new WeakSet();
bundle_product_fn = function(event) {
  const target = event.target;
  if (target.tagName == 'SELECT') {
    const optionSelected = target.options[target.selectedIndex],
    oldPrice = this.price,
    oldComparePrice = this.comparePrice;

    this.price = Number(optionSelected.dataset.price);
    this.comparePrice = Number(optionSelected.dataset.cpprice);
    var action = 'plus',
    remainPrice = this.price - oldPrice,
    remainComparePrice = this.comparePrice - oldComparePrice;
    // Update price, qty, image
    $4('[update-price] hdt-compare-at-price', this).toggleAttribute('hidden', this.comparePrice <= this.price);
    // $4('[update-price] hdt-compare-at-price .hdt-money', this).innerHTML = formatMoney(this.comparePrice);
    // $4('[update-price] hdt-price .hdt-money', this).innerHTML = formatMoney(this.price);
    $4('[update-price] hdt-compare-at-price .hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(this.comparePrice)}</span>`;
    $4('[update-price] hdt-price .hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(this.price)}</span>`;
    $4('[update-qty]', this).value = optionSelected.dataset.qty;
    $4('[update-img]', this.observes || this).src = optionSelected.dataset.img;
    document.dispatchEvent(new CustomEvent("currency:update"));
    if ( !this.classList.contains('is-checked')) return;

  } else if (target.tagName == 'INPUT') {
    // Update disable slelect, qty
    getterGet(_bundle_items, this).forEach((item) => {
      item.toggleAttribute('disabled', !target.checked);
    });
    this.classList.toggle('is-checked', target.checked);
    var action = target.checked ? 'plus': 'minus',
    remainPrice = this.price,
    remainComparePrice = this.comparePrice;
    this.observes?.classList.toggle('is-checked', target.checked);
  }

  this.dispatchEvent(new CustomEvent("update:bundle:total", {
    bubbles: true,
    detail: {
      remainPrice,
      remainComparePrice,
      action
    }
  }));
};

var _on_variant_changed, on_variant_changed_fn,
_cart_error, _cart_error_fn;
class BuyButtons extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_variant_changed, this);
    getterAdd(_cart_error, this);
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.form?.addEventListener(variantChange, getterRunFn(_on_variant_changed, this, on_variant_changed_fn).bind(this), { signal: this.#abortController.signal });
    this.form?.addEventListener("cart:add:error", getterRunFn(_cart_error, this, _cart_error_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
_on_variant_changed = new WeakSet();
on_variant_changed_fn = function(event) {
  const variant = event.detail.variant,
  submitButton = $4('button[type="submit"]', this);

  submitButton.disabled = !variant || !variant.available;
  
  let labelText;
  let state;
  if (!variant) {
    const isComplete = event.detail.isComplete === true;
    if (isComplete) {
      // All options are selected but this combination does not exist
      labelText = themeHDN.extras['unavailable'];
      state = 'unavailable';
    } else {
      // Not all options are selected (no-pick mode)
      const picker = document.querySelector(`hdt-variant-picker[form="${this.getAttribute("form")}"]`);
      labelText = picker?.chooseText || themeHDN.extras.chooseOptions;
      state = 'incomplete';
    }
  } else {
    labelText = themeHDN.extras[variant.variant_state.pre_order ? 'preOrder' : variant.available ? 'addToCart' : 'soldOut'];
    state = variant.variant_state.pre_order ? 'pre-order' : variant.available ? 'available' : 'sold-out';
  }
  if (submitButton) {
    submitButton.firstElementChild.textContent = labelText;
    submitButton.setAttribute('variant-state', state);
  }
  
  // Reset quantity input to 1 when a variant is not fully selected
  if (!variant) {
    const qtyInput = document.querySelector(`input[name="quantity"][form="${this.getAttribute("form")}"]`) || this.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = 1;
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  this.previousElementSibling.hidden = true;
  $4('hdt-price', this)?.removeAttribute('hidden');
};
_cart_error = new WeakSet();
_cart_error_fn = function(event) {
  if (event.detail.isGiftCardRecipient) return;
  this.previousElementSibling.hidden = false;
  this.previousElementSibling.lastElementChild.textContent = event.detail.error;
  this.form?.addEventListener("variant:add", () => this.previousElementSibling.hidden = true, {once : true} );
};

var _on_recipient_form_changed, on_recipient_form_changed_fn,
_cart_error2, _cart_error2_fn,
_displayErrorMessage, displayErrorMessage_fn,
_createErrorListItem, createErrorListItem_fn,
_clearErrorMessage, clearErrorMessage_fn;
// https://github.com/Shopify/dawn/blob/main/assets/recipient-form.js
class RecipientForm extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_recipient_form_changed, this);
    getterAdd(_cart_error2, this);
    getterAdd(_displayErrorMessage, this);
    getterAdd(_createErrorListItem, this);
    getterAdd(_clearErrorMessage, this);
    this.recipientFieldsLiveRegion = $4(`#Recipient-fields-live-region-${this.sectionId}`, this);
    this.checkboxInput = $4(`#Recipient-checkbox-${this.sectionId}`, this);
    this.checkboxInput.disabled = false;
    this.hiddenControlField = $4(`#Recipient-control-${this.sectionId}`, this);
    this.hiddenControlField.disabled = true;

    this.emailInput = $4(`#Recipient-email-${this.sectionId}`, this);
    this.nameInput = $4(`#Recipient-name-${this.sectionId}`, this);
    this.messageInput = $4(`#Recipient-message-${this.sectionId}`, this);
    this.sendonInput = $4(`#Recipient-send-on-${this.sectionId}`, this);
    this.offsetProperty = $4(`#Recipient-timezone-offset-${this.sectionId}`);
    if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

    this.errorMessageWrapper = $4('.hdt-form__message-wrapper', this);
    this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
    this.errorMessage = this.errorMessageWrapper?.querySelector('.hdt-error-message');
    this.defaultErrorHeader = this.errorMessage?.innerText;
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.checkboxInput.addEventListener('change', getterRunFn(_on_recipient_form_changed, this, on_recipient_form_changed_fn).bind(this), { signal: this.#abortController.signal });
    this.form?.addEventListener("cart:add:error", getterRunFn(_cart_error2, this, _cart_error2_fn).bind(this), { signal: this.#abortController.signal });
    this.form?.addEventListener("variant:add", getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
  get sectionId() {
    return this.dataset.sectionId;
  }

  inputFields() {
    return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
  }

  disableableFields() {
    return [...this.inputFields(), this.offsetProperty];
  }

  // clearInputFields() {
  //   this.inputFields().forEach((field) => (field.value = ''));
  // }

  enableInputFields() {
    this.disableableFields().forEach((field) => (field.disabled = false));
  }

  disableInputFields() {
    this.disableableFields().forEach((field) => (field.disabled = true));
  }
};
_on_recipient_form_changed = new WeakSet();
on_recipient_form_changed_fn = function() {
  if (this.checkboxInput.checked) {
    this.enableInputFields();
    this.recipientFieldsLiveRegion.innerText =  this.recipientFieldsLiveRegion.dataset.expanded;
  } else {
    this.disableInputFields();
    this.recipientFieldsLiveRegion.innerText = this.recipientFieldsLiveRegion.dataset.collapsed
  }
};
_cart_error2 = new WeakSet();
_cart_error2_fn = function(event) {
  if (!event.detail.isGiftCardRecipient) return;
  console.log(event.detail)
  getterRunFn(_displayErrorMessage, this, displayErrorMessage_fn).call(this, event.detail.error);
};

_displayErrorMessage = new WeakSet();
displayErrorMessage_fn = function(body) {
  getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).call(this);
  this.errorMessageWrapper.hidden = false;
  if (typeof body === 'object') {
    this.errorMessage.innerText = this.defaultErrorHeader;
    return Object.entries(body).forEach(([key, value]) => {
      const errorMessageId = `RecipientForm-${key}-error-${this.sectionId}`;
      const fieldSelector = `#Recipient-${key}-${this.sectionId}`;
      const message = `${value.join(', ')}`;
      const errorMessageElement = this.querySelector(`#${errorMessageId}`);
      const errorTextElement = errorMessageElement?.querySelector('.hdt-error-message');
      if (!errorTextElement) return;

      if (this.errorMessageList) {
        this.errorMessageList.appendChild(getterRunFn(_createErrorListItem, this, createErrorListItem_fn).call(this, fieldSelector, message));
      }

      errorTextElement.innerText = `${message}.`;
      errorMessageElement.removeAttribute('hidden');

      const inputElement = this[`${key}Input`];
      if (!inputElement) return;

      inputElement.setAttribute('aria-invalid', true);
      inputElement.setAttribute('aria-describedby', errorMessageId);
    });
  }

  this.errorMessage.innerText = body;
};

_createErrorListItem = new WeakSet();
createErrorListItem_fn = function(target, message) {
  const li = document.createElement('li');
  const a = document.createElement('a');
  a.setAttribute('href', target);
  a.innerText = message;
  li.appendChild(a);
  li.className = 'hdt-error-message';
  return li;
};

_clearErrorMessage = new WeakSet();
clearErrorMessage_fn = function() {
  this.errorMessageWrapper.hidden = true;

  if (this.errorMessageList) this.errorMessageList.innerHTML = '';

  this.querySelectorAll('.hdt-recipient-fields .hdt-form__message').forEach((field) => {
    field.setAttribute('hidden', '');
    const textField = field.querySelector('.hdt-error-message');
    if (textField) textField.innerText = '';
  });

  [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
    inputElement.setAttribute('aria-invalid', false);
    inputElement.removeAttribute('aria-describedby');
  });
};

customElements.define("wrapp-hdt-pr-frm", ProductForm);
customElements.define("wrapp-hdt-pr-frm-bundle", ProductFormBundle);
customElements.define("hdt-bundle-product", bundleProduct);
customElements.define("hdt-buy-buttons", BuyButtons);
customElements.define('hdt-recipient-form', RecipientForm);

var _on_value_change, on_value_change_fn,
_variants_data,
_find_closest_variant, find_closest_variant_fn,
_update_variant_statuses, update_variant_statuses_fn,
_update_url, update_url_fn,
_master_input_change, master_input_change_fn;

// Helper function to setup dropdown listeners
const setupDropdownListeners = (context, abortSignal) => {
  $$4('fieldset[type^="dropdown"]', context).forEach((fieldset) => {
    $4('hdt-popover', fieldset).addEventListener("richlist:change", (e) => {
      const input = $4(`input[type="hidden"][name="option${parseInt(fieldset.dataset.index) + 1}"]`, fieldset);
      if (input.value == e.detail.value) return;
      input.value = e.detail.value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: abortSignal });
  });
};

class VariantPicker extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_value_change, this);
    getterAdd(_find_closest_variant, this);
    getterAdd(_update_variant_statuses, this);
    getterAdd(_update_url, this);
  }
  async connectedCallback() {
    this.#abortController = new AbortController();
    if (!this.hasAttribute('handle')) return;
    
    // Save initial no-pick configuration
    this._isNoPickConfig = this.hasAttribute('no-pick');
    
    // Add loading state when variant pages are loading
    this.classList.add('loading');
    
    // Store choose an option placeholder text on load
    this._chooseText = themeHDN.extras.chooseOptions || 'Choose options';
    
    try {
      const productJSON = await (await getJSONProduct.load(this.getAttribute('handle'), this.getAttribute('variants-pages')));
      const variantsJSON = productJSON?.variants || [];
      this._optionNames = productJSON?.options || [];
      this._productJSON = productJSON;
      this._allVariantsJSON = variantsJSON;

      // Inject images and media mapping initially (using the complete variants list)
      this.updateVariantImagesAndMedia(this._allVariantsJSON);

      const variantScript = this.querySelector(`#selected-variant-${this.id.replace('variant-picker-', '')}`);
      if (!variantScript) return;

      this.masterInput = this.idELForm;

      if (!this.masterInput) return;
      this.masterInput.disabled = false;

      getterAdd(_master_input_change, this);
      this.addEventListener('change', getterRunFn(_on_value_change, this, on_value_change_fn).bind(this), { signal: this.#abortController.signal });
      this.masterInput.addEventListener('change', getterRunFn(_master_input_change, this, master_input_change_fn).bind(this), { signal: this.#abortController.signal });

      // Setup initial selection from DOM
      this.options = this.getSelectedOptions().map((val, idx) => this.isValidOptionValue(idx, val) ? val : null);

      // To trigger when use type dropdown
      setupDropdownListeners(this, this.#abortController.signal);

      const scriptContent = variantScript.textContent.trim();
      let currentVariant = null;

      if (scriptContent.indexOf('{') !== -1) {
        currentVariant = JSON.parse(scriptContent);
        const optionDataset = variantScript.dataset;
        currentVariant = Object.assign( currentVariant, {
          inventory_policy: optionDataset.inventorypolicy || null,
          inventory_quantity: parseInt(optionDataset.inventoryquantity),
          mdid: optionDataset.mdid || null
        });
        currentVariant.variant_state = {
          sold_out: !currentVariant.available,
          on_sale : currentVariant.compare_at_price > currentVariant.price,
          pre_order : currentVariant.inventory_management == 'shopify' && currentVariant.inventory_quantity <= 0 && currentVariant.available
        }
        if (!currentVariant.quantity_rule) currentVariant.quantity_rule = { min: 1, max: null, increment: 1, max4: true }
        const { inventory_quantity, inventory_management, inventory_policy} = currentVariant;
        if (!currentVariant.quantity_rule.max && inventory_quantity > 0 && inventory_management != null && inventory_policy != 'continue') {
          currentVariant.quantity_rule.max = inventory_quantity;
          currentVariant.quantity_rule.max4 = true;
        }
        this.currentVariant = currentVariant;
        this.lastValidVariant = currentVariant;
      }

      // Initialize indexing structures for client-side selection
      this.initVariantIndex(currentVariant);

      // Synchronize statuses initially
      this.updateOptionStatuses(this.options);
    } catch (e) {
      console.error("Error loading product variant data:", e);
    } finally {
      this.classList.remove('loading');
    }
  }

  initVariantIndex(currentVariant = null) {
    const realOptionCount = (this._optionNames && this._optionNames.length > 0)
      ? this._optionNames.length
      : (parseInt(this.dataset.size) || 3);

    const variants = this._allVariantsJSON.map((v) => {
      if (!v || !v.id) return null;
      let rawOpts = Array.isArray(v.options) && v.options.length > 0
        ? v.options
        : [v.option1, v.option2, v.option3].filter(x => x != null);

      const opts = rawOpts.slice(0, realOptionCount);

      // If it is the initial variant, merge detailed inventory information from the Liquid dataset
      let inventory_management = v.inventory_management;
      let inventory_quantity = v.inventory_quantity;
      let inventory_policy = v.inventory_policy;

      if (currentVariant && String(v.id) === String(currentVariant.id)) {
        inventory_management = currentVariant.inventory_management;
        inventory_quantity = currentVariant.inventory_quantity;
        inventory_policy = currentVariant.inventory_policy;
      }

      const variant_state = {
        sold_out: !v.available,
        on_sale: v.compare_at_price > v.price,
        pre_order: (inventory_management === 'shopify' && inventory_quantity <= 0 && v.available) || false
      };

      const quantity_rule = v.quantity_rule || { min: 1, max: null, increment: 1, max4: true };
      if (!quantity_rule.max && inventory_quantity > 0 && inventory_management != null && inventory_policy != 'continue') {
        quantity_rule.max = inventory_quantity;
        quantity_rule.max4 = true;
      }

      return { 
        ...v, 
        options: opts, 
        inventory_management,
        inventory_quantity,
        inventory_policy,
        variant_state,
        quantity_rule,
        mdid: v.featured_media?.id || v.featured_image?.id || null
      };
    }).filter(Boolean);
    this._variants = variants;
    console.log(this._variants)
    
    const { index, existingKeys, availableKeys } = this.buildVariantIndex(variants);
    this.variantIndex = index;
    this.existingKeys = existingKeys;
    this.availableKeys = availableKeys;

    getterAdd(_variants_data, this, this._variants, true); // Overwrite with full list of variants
  }

  buildVariantIndex(variants) {
    const index       = new Map();
    const existingKeys  = { o1o2: new Map(), o1o2o3: new Map() };
    const availableKeys = { o1: new Set(), o1o2: new Map(), o1o2o3: new Map() };

    for (const v of variants) {
      const [o1, o2, o3] = v.options;

      // lookup index
      if (!index.has(o1)) index.set(o1, new Map());
      const l2 = index.get(o1);
      if (o2 !== undefined) {
        if (o3 !== undefined) {
          if (!l2.has(o2)) l2.set(o2, new Map());
          l2.get(o2).set(o3, v);
        } else {
          l2.set(o2, v);
        }
      } else {
        index.set(o1, v);
      }

      // existing keys
      if (o2 !== undefined) {
        if (!existingKeys.o1o2.has(o1)) existingKeys.o1o2.set(o1, new Set());
        existingKeys.o1o2.get(o1).add(o2);
      }
      if (o3 !== undefined) {
        const key = `${o1}||${o2}`;
        if (!existingKeys.o1o2o3.has(key)) existingKeys.o1o2o3.set(key, new Set());
        existingKeys.o1o2o3.get(key).add(o3);
      }

      // available keys
      if (!v.available) continue;
      availableKeys.o1.add(o1);
      if (o2 !== undefined) {
        if (!availableKeys.o1o2.has(o1)) availableKeys.o1o2.set(o1, new Set());
        availableKeys.o1o2.get(o1).add(o2);
      }
      if (o3 !== undefined) {
        const key = `${o1}||${o2}`;
        if (!availableKeys.o1o2o3.has(key)) availableKeys.o1o2o3.set(key, new Set());
        availableKeys.o1o2o3.get(key).add(o3);
      }
    }

    return { index, existingKeys, availableKeys };
  }

  getOptionState(existingKeys, availableKeys, optionIndex, value, selected, showSoldOut) {
    const [o1, o2] = selected;

    if (optionIndex === 0) {
      const avail = availableKeys.o1.has(value);
      if (avail) return 'available';
      return showSoldOut ? 'soldout' : 'hidden';
    }

    if (optionIndex === 1) {
      if (!o1) return 'placeholder';
      if (!existingKeys.o1o2.get(o1)?.has(value)) return 'hidden';
      const avail = availableKeys.o1o2.get(o1)?.has(value);
      if (avail) return 'available';
      return showSoldOut ? 'soldout' : 'hidden';
    }

    if (optionIndex === 2) {
      if (!o1 || !o2) return 'placeholder';
      const key = `${o1}||${o2}`;
      if (!existingKeys.o1o2o3.get(key)?.has(value)) return 'hidden';
      const avail = availableKeys.o1o2o3.get(key)?.has(value);
      if (avail) return 'available';
      return showSoldOut ? 'soldout' : 'hidden';
    }

    return 'hidden';
  }

  getFirstAvailable(existingKeys, availableKeys, optionIndex, selected, onlyInStock = false) {
    const [o1, o2] = selected;
    if (optionIndex === 1) {
      const avail = availableKeys.o1o2.get(o1)?.values().next().value;
      if (avail !== undefined) return avail;
      return onlyInStock ? null : (existingKeys.o1o2.get(o1)?.values().next().value ?? null);
    }
    if (optionIndex === 2) {
      const key = `${o1}||${o2}`;
      const avail = availableKeys.o1o2o3.get(key)?.values().next().value;
      if (avail !== undefined) return avail;
      return onlyInStock ? null : (existingKeys.o1o2o3.get(key)?.values().next().value ?? null);
    }
    return null;
  }

  getSelectedOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset[data-index]'));
    const selected = new Array(fieldsets.length).fill(null);
    fieldsets.forEach((fieldset) => {
      const idx = parseInt(fieldset.dataset.index);
      const activeInput = fieldset.querySelector('input[is-value]:checked, input[is-value][type="hidden"]');
      if (activeInput) {
        selected[idx] = activeInput.value;
      } else {
        const activeBtn = fieldset.querySelector('button[role="option"][aria-selected="true"]');
        if (activeBtn) {
          selected[idx] = activeBtn.getAttribute('value') || activeBtn.textContent.trim();
        }
      }
    });
    return selected;
  }

  isValidOptionValue(optionIndex, value) {
    if (!value) return false;
    const optWithVals = this._productJSON?.options_with_values?.[optionIndex];
    if (optWithVals && Array.isArray(optWithVals.values)) {
      return optWithVals.values.includes(value);
    }
    const opt = this._productJSON?.options?.[optionIndex];
    if (opt && Array.isArray(opt.values)) {
      return opt.values.includes(value);
    }
    return true;
  }

  getVariantFromOptions(selected) {
    const [o1, o2, o3] = selected;
    if (!o1) return null;
    const l1 = this.variantIndex.get(o1);
    if (!(l1 instanceof Map)) return l1 ?? null;
    if (!o2) return null;
    const l2 = l1.get(o2);
    if (!(l2 instanceof Map)) return l2 ?? null;
    if (!o3) return null;
    return l2.get(o3) ?? null;
  }

  findClosestValidVariant(selected, clickedIdx) {
    const variants = this._variants;
    const totalSize = selected.length;
    const clickedVal = (clickedIdx !== undefined && clickedIdx !== null) ? selected[clickedIdx] : null;
    
    let bestVariant = null;
    let maxScore = -1;
    
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      if (clickedVal && v.options[clickedIdx] !== clickedVal) {
        continue;
      }
      
      let score = 0;
      for (let j = 0; j < totalSize; j++) {
        if (j === clickedIdx) continue;
        if (v.options[j] === selected[j]) {
          score += 2;
        }
      }
      
      if (v.available) {
        score += 1;
      }
      
      if (score > maxScore) {
        maxScore = score;
        bestVariant = v;
      }
    }
    
    return bestVariant;
  }

  updateDOMSelection(selected, clickedIdx = null) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset[data-index]'));
    const isNoPick = this.hasAttribute('no-pick') || this._isNoPickConfig;

    fieldsets.forEach((fieldset) => {
      const idx = parseInt(fieldset.dataset.index);
      const val = selected[idx];
      
      const updateValueEl = fieldset.querySelector('[update-value]');
      if (updateValueEl) {
        if (val) {
          updateValueEl.textContent = val;
        } else if (isNoPick) {
          updateValueEl.textContent = this._chooseText;
        }
      }
      
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const hiddenInput = fieldset.querySelector('input[type="hidden"][is-value]');
      const selectBtn = fieldset.querySelector('button.hdt-select');
      const richlist = fieldset.querySelector('hdt-richlist');
      const buttons = Array.from(fieldset.querySelectorAll('button[role="option"]'));

      if (val) {
        if (radios.length > 0) {
          radios.forEach((radio) => {
            radio.checked = (radio.value === val);
          });
        }
        
        if (hiddenInput) {
          hiddenInput.value = val;
        }
        
        if (selectBtn) {
          selectBtn.textContent = val;
        }
        
        if (richlist) {
          richlist.selected = val;
        }

        if (buttons.length > 0) {
          buttons.forEach((btn) => {
            btn.setAttribute('aria-selected', (btn.value || btn.getAttribute('value') || btn.textContent.trim()) === val ? 'true' : 'false');
          });
        }
      } else {
        // Reset DOM selection for this fieldset if the value is null
        if (radios.length > 0) {
          radios.forEach((radio) => {
            radio.checked = false;
          });
        }
        
        if (hiddenInput) {
          hiddenInput.value = '';
        }
        
        if (selectBtn) {
          if (isNoPick) {
            selectBtn.textContent = this._chooseText;
          }
        }
        
        if (richlist) {
          richlist.selected = '';
        }

        if (buttons.length > 0) {
          buttons.forEach((btn) => {
            btn.setAttribute('aria-selected', 'false');
          });
        }
      }
    });
  }

  updateOptionStatuses(selected) {
    const showSoldOut = !this.hideSoldOutVariants;
    const fieldsets = Array.from(this.querySelectorAll('fieldset[data-index]'));
    
    fieldsets.forEach((fieldset) => {
      const idx = parseInt(fieldset.dataset.index);
      const options = Array.from(fieldset.querySelectorAll('input[type="radio"], hdt-richlist > button, [role="option"]'));
      
      options.forEach((optEl) => {
        const val = optEl.value || optEl.getAttribute('value') || optEl.textContent.trim();
        const state = this.getOptionState(this.existingKeys, this.availableKeys, idx, val, selected, showSoldOut);
        
        const option_unavailable = (state === 'hidden');
        const option_soldout = (state === 'soldout');
        const option_placeholder = (state === 'placeholder');
        
        optEl.classList.toggle('is-disabled', option_soldout);
        optEl.classList.toggle('is-unavailable', option_unavailable);
        optEl.classList.toggle('is-placeholder', option_placeholder);
        
        const wrapper = optEl.closest('.hdt-swatch__item, .hdt-selector__item, .hdt-product-form_value');
        if (wrapper) {
          wrapper.classList.toggle('is-disabled', option_soldout);
          wrapper.classList.toggle('is-unavailable', option_unavailable);
          wrapper.classList.toggle('is-placeholder', option_placeholder);
          
          if (this.hideSoldOutVariants && state === 'soldout') {
            wrapper.style.display = 'none';
          } else {
            wrapper.style.display = '';
          }
        }
      });
    });
  }

  updateOptionsClientSide() {
    const hasNullBefore = this.options.some(val => val === null || val === undefined || val === '');
    let selected = this.getSelectedOptions().map((val, idx) => this.isValidOptionValue(idx, val) ? val : null);
    
    const idx = this.clickedCurrentIndex;
    if (idx !== undefined && idx !== null) {
      selected[idx] = this.clickedCurrentValue;
      
      if (this.lastValidVariant) {
        let canRestore = true;
        for (let i = 0; i < selected.length; i++) {
          if (selected[i] !== null && selected[i] !== this.lastValidVariant.options[i]) {
            canRestore = false;
            break;
          }
        }
        if (canRestore) {
          selected = [...this.lastValidVariant.options];
        }
      }
      
      const isNoPick = this.hasAttribute('no-pick') || this._isNoPickConfig;
      
      // Check the validity of subsequent options
      for (let i = idx + 1; i < selected.length; i++) {
        const val = selected[i];
        
        let is_valid = false;
        if (val) {
          if (i === 1) {
            const o1 = selected[0];
            if (o1) {
              if (this.hideSoldOutVariants) {
                if (this.availableKeys.o1o2.get(o1)?.has(val)) {
                  is_valid = true;
                }
              } else {
                if (this.existingKeys.o1o2.get(o1)?.has(val)) {
                  is_valid = true;
                }
              }
            }
          } else if (i === 2) {
            const o1 = selected[0];
            const o2 = selected[1];
            if (o1 && o2) {
              const key = `${o1}||${o2}`;
              if (this.hideSoldOutVariants) {
                if (this.availableKeys.o1o2o3.get(key)?.has(val)) {
                  is_valid = true;
                }
              } else {
                if (this.existingKeys.o1o2o3.get(key)?.has(val)) {
                  is_valid = true;
                }
              }
            }
          }
        }

        // If the combination is invalid or does not exist
        if (!is_valid) {
          selected[i] = null;
        }
      }
    }
    
    this.options = selected;
    this.updateDOMSelection(selected, idx);
    this.updateOptionStatuses(selected);
    
    const totalSize = parseInt(this.dataset.size);
    const isNoPick = this.hasAttribute('no-pick') || this._isNoPickConfig;
    const autoPickNearest = this.autoPickNearest;
    
    let variant = this.getVariantFromOptions(selected);    
    if (!variant && (autoPickNearest || (!isNoPick && hasNullBefore)) && idx !== undefined && idx !== null) {
      // Auto-select nearest valid variant if auto-pick-nearest is enabled or user clicked second time on null variant
      const closestVariant = this.findClosestValidVariant(selected, idx);
      if (closestVariant) {
        variant = closestVariant;
        selected = [...closestVariant.options];
        this.options = selected;
        this.updateDOMSelection(selected, idx);
        this.updateOptionStatuses(selected);
      }
    }
    
    const selectedCount = selected.filter(x => x !== null).length;
    
    if (selectedCount === totalSize) {
      this.removeAttribute('no-pick');
      this.currentVariant = variant;
      if (variant) {
        this.lastValidVariant = variant;
      }
      
      if (variant) {
        if (this.stickySelect) {
          if (this.stickySelect.tagName === 'SELECT') {
            let option = document.createElement("option");
            if (variant.featured_media) option.setAttribute("data-mdid", variant.featured_media.id);
            option.setAttribute("value", variant.id);
            let label = `${variant.title}`;
            if (!document.getElementById('shopify-currencies-js')) {
              label += ` - ${formatMoney(variant.price, currencyFormat)}`;
            }
            option.textContent = label;
            this.stickySelect.replaceChild(option, this.stickySelect.firstChild);
          } else {
            this.stickySelect.closest('form').querySelector('[name="id"]').value = variant.id;
            let label = `<span>${variant.title}</span>`;
            if (!document.getElementById('shopify-currencies-js')) {
              label += `<span> - ${formatMoney(variant.price, currencyFormat)}</span>`;
            }
            this.stickySelect.innerHTML = label;
          }
        }
      } else {
        selected[selected.length - 1] = null;
        this.options = selected;
        this.updateDOMSelection(selected, idx);
        this.updateOptionStatuses(selected);
        this.oldVariant = null;
      }
    } else {
      if (this._isNoPickConfig) {
        this.setAttribute('no-pick', '');
      }
      this.currentVariant = null;
      this.oldVariant = null;
      if (idx !== undefined && idx !== null) {
        const tmpOptions = ['nanthan94', 'nanthan94', "nanthan94"];
        tmpOptions[idx] = this.clickedCurrentValue;
        this.productMedia?.dispatchEvent(new CustomEvent('update:value', {
          detail: { options: tmpOptions }
        }));
      }
    }
    
    if (this.currentVariant) {
      this.selectVariant(true);
    } else {
      if (this.masterInput) {
        this.masterInput.value = '';
        this.masterInput.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { hasVariant: false } }));
      }
      getterRunFn(_update_url, this, update_url_fn).call(this);
      if (this.masterInput && this.masterInput.form) {
        this.masterInput.form.dispatchEvent(new CustomEvent(variantChange, {
          bubbles: true,
          detail: {
            variant: null,
            jumpMedia: false,
            isComplete: (selectedCount === totalSize) || !this._isNoPickConfig
          }
        }));
      }
    }
  }

  updateVariantImagesAndMedia(variantsJSON) {
    try {
      const productJSON = this._productJSON || {};
      const optionNames = this._optionNames || [];
      const getFeaturedImageSrc = (variant) => {
        const img = variant?.featured_image || variant?.image || null;
        if (!img) return null;
        if (typeof img === 'string') return img;
        return img.src || img.url || null;
      };
      const buildSizedImageUrl = (src, width) => {
        if (!src) return '';
        const separator = src.includes('?') ? '&' : '?';
        return `${src}${separator}width=${width}`;
      };
      const getOptionIndexFromInput = (input) => {
        const name = (input.getAttribute('name') || '').trim();
        const match = name.match(/^option(\d+)$/i);
        if (match) return Math.max(0, parseInt(match[1], 10) - 1);
        const idxByName = optionNames.findIndex((n) => n.name === name);
        return idxByName >= 0 ? idxByName : null;
      };
      const findLabelForInput = (input) => {
        if (input.id) {
          const byFor = this.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (byFor) return byFor;
        }
        return input.closest('label') || null;
      };

      const fieldsets = this.querySelectorAll('fieldset.hdt-product-form__input[type="image"]');
      fieldsets.forEach((fieldset) => {
        const inputs = fieldset.querySelectorAll('input');
        inputs.forEach((input) => {
          const optionIndex = getOptionIndexFromInput(input);
          if (optionIndex === null) return;

          const value = (input.value || '').trim();
          if (!value) return;

          const matched = variantsJSON.find((v) => (v?.options?.[optionIndex] === value || v?.[`option${optionIndex + 1}`] === value) && getFeaturedImageSrc(v))
            || variantsJSON.find((v) => v?.options?.[optionIndex] === value || v?.[`option${optionIndex + 1}`] === value);

          const src = getFeaturedImageSrc(matched);
          if (!src) return;
          const altText = matched?.name || matched?.title || productJSON?.title || '';
          const src50 = buildSizedImageUrl(src, 50);
          const src100 = buildSizedImageUrl(src, 100);
          const src160 = buildSizedImageUrl(src, 160);

          const label = findLabelForInput(input);
          if (!label) return;

          const tooltip = label.querySelector('hdt-tooltip');
          if (!tooltip) return;
          const existing = tooltip.querySelector('img');
          if (existing) {
            existing.src = src160;
            existing.srcset = `${src50} 50w, ${src100} 100w, ${src160} 160w`;
            existing.width = 160;
            existing.height = 192;
            existing.alt = altText;
            existing.loading = 'lazy';
            return;
          }
        });
      });

      const variantIdsByMediaId = new Map();
      variantsJSON.forEach((variant) => {
        const featuredImage = variant?.featured_image;
        const featuredMedia = variant?.featured_media;
        const mediaId = featuredMedia?.id || featuredImage?.id;
        if (!mediaId) return;

        let ids = [];
        if (Array.isArray(featuredImage?.variant_ids) && featuredImage.variant_ids.length) {
          ids = featuredImage.variant_ids;
        } else if (variant?.id) {
          ids = [variant.id];
        }
        if (!ids.length) return;

        if (!variantIdsByMediaId.has(mediaId)) {
          variantIdsByMediaId.set(mediaId, new Set());
        }
        ids.forEach((id) => {
          if (id !== null && id !== undefined && id !== '') {
            variantIdsByMediaId.get(mediaId).add(String(id));
          }
        });
      });

      const mediaItems = document.querySelectorAll('.hdt-product__media-item[data-media-id]');
      mediaItems.forEach((mediaItem) => {
        const mediaIdAttr = mediaItem.getAttribute('data-media-id');
        if (!mediaIdAttr) return;
        const mediaIdNum = parseInt(mediaIdAttr, 10);
        const variantsSet = variantIdsByMediaId.get(mediaIdNum) || variantIdsByMediaId.get(mediaIdAttr);
        if (!variantsSet || !variantsSet.size) return;

        mediaItem.setAttribute('data-variants-id', Array.from(variantsSet).join(';'));
      });
    } catch (e) {}
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get idELForm() {
    const formId = this.getAttribute("form");
    if (!document.forms[formId] ) {
      const formHtml = `<form id="${formId}" action="${Shopify.routes.root}cart/add.js" method="POST" hidden><input type="hidden" name="id" value="${this.getAttribute('selected-variant')}"></form>`;
      this.insertAdjacentHTML("afterend", formHtml);
    }
    return document.forms[formId].id;
  }
  get stickySelect() {
    const formId = this.getAttribute("form");
    return document.forms[formId].closest('.hdt-section--feature-product')?.querySelector('[tag-select]') || null;
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get autoPickNearest() {
    return this.hasAttribute("auto-pick-nearest");
  }
  get updateUrl() {
    return this.getAttribute("update-url");
  }
  get updateStatus() {
    return this.hasAttribute("update-status");
  }
  get productMedia() {
    return this._productMedia = this._productMedia || $4(`hdt-product-media[form="${this.getAttribute("form")}"]`);
  }
  get chooseText() {
    return this._chooseText;
  }
  getvariantObjById(id) {
    return getterGet(_variants_data, this).find((variant) => variant.id == id);
  }

  updateOptions() {
    this.updateOptionsClientSide();
    return Promise.resolve();
  }

  updateMasterId() {
    this.currentVariant = getterGet(_variants_data, this).find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  selectVariantByID(id, firstOption = null, jumpMedia = true) {
    if ( !this.hasAttribute('no-pick') ) {
      const variant = this.getvariantObjById(id);
      if (variant) {
        this.selectVariantByVariantObj(variant, jumpMedia);
      } else if (firstOption) {
        let lastElement = null;
        firstOption.forEach((optionId) => {
          const input = $4(`input[data-value-id="${optionId}"]`, this);
          if (input) {
            input.checked = true;
            lastElement = input;
          }
          
          const button = $4(`button[data-value-id="${optionId}"]`, this);
          if (button) {
            const container = button.closest('hdt-richlist');
            if (container) {              
                if (container) container.selected = button.value;
            }
            button.setAttribute('aria-selected', 'true');
            lastElement = button;
          }
        });
        
        if (lastElement) {
          getterRunFn(_on_value_change, this, on_value_change_fn).call(this, {
            target: lastElement
          });
        }
      }
    }
  }
  selectVariantByVariantObj(variant, jumpMedia = true, overwrite = false) {
    if (typeof variant != 'object') return;
    if ( getterGet(_variants_data, this).includes(variant) ) {
      this.options = variant.options;
      this.currentVariant = variant;
      this.lastValidVariant = variant;
      this.selectVariant(false, jumpMedia, overwrite);
    }
  }
  selectVariant(untriggerChangeEvent = false, jumpMedia = true, overwrite = false) {
    if (this.oldVariant && this.oldVariant.id === this.currentVariant.id && !overwrite) {
      return;
    }
    this.oldVariant = this.currentVariant;

    this.masterInput.value = this.currentVariant.id;
    this.masterInput.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { hasVariant: true, untriggerChangeEvent } }));

    getterRunFn(_update_url, this, update_url_fn).call(this);

    this.masterInput.form.dispatchEvent(new CustomEvent(variantChange, {
      bubbles: true,
      detail: {
        variant: this.currentVariant,
        jumpMedia
      }
    }));
  }
};
_variants_data = new WeakMap();
_on_value_change = new WeakSet();
on_value_change_fn = function(event) {
  if (!event.target.hasAttribute("is-value")) return;

  const fieldset = event.target.closest('fieldset');
  const idx = parseInt(fieldset.dataset.index);
  
  // Prevent selecting option 2 or 3 if the previous options have not been selected yet
  for (let i = 0; i < idx; i++) {
    if (!this.options[i]) {
      // Find the first unselected fieldset to trigger a warning effect
      const targetFieldset = this.querySelector(`fieldset[data-index="${i}"]`);
      if (targetFieldset) {
        targetFieldset.classList.add('hdt-shake-effect', 'hdt-flash-effect');
        setTimeout(() => {
          targetFieldset.classList.remove('hdt-shake-effect', 'hdt-flash-effect');
        }, 500);
      }
      // Re-sync DOM to the closest valid selected state (this.options)
      this.updateDOMSelection(this.options);
      return;
    }
  }

  this.clickedCurrentIndex = idx;
  this.clickedCurrentValue = event.target.value;

  this.classList.add('loading');
  this.updateOptionsClientSide();
  this.classList.remove('loading');
};
_master_input_change = new WeakSet();
master_input_change_fn = function(event) {
  if (!event.detail || !event.detail.hasVariant) {
    this.currentVariant = this.getvariantObjById(event.target.value);
  }
  if (!this.currentVariant) return;
  let arrInputChange = [];
  $$4('fieldset[data-index]', this).forEach((fieldset, index) => {
    let value              = this.currentVariant.options[index],
        type               = fieldset.getAttribute('type'),
        updateValue        = $4('[update-value]', fieldset),
        input              = $4(`input[type="radio"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"]`, fieldset),
        triggerChangeEvent = false;

    if (type.startsWith('dropdown')) {
      triggerChangeEvent = input.value !== value;
      input.value = value;
      const richlist = $4('hdt-richlist', fieldset);
      if (richlist) richlist.selected = value;
    } else {
      triggerChangeEvent = !input.checked && input.value === value;
      input.checked = true;
    }
    if ( event.detail && event.detail.untriggerChangeEvent) triggerChangeEvent = false;

    if (updateValue) updateValue.textContent = value;

    if (triggerChangeEvent) arrInputChange.push(input);
  });
  arrInputChange.forEach((input) => input.dispatchEvent(new CustomEvent("change", { bubbles: true })));
  arrInputChange = [];
};
_find_closest_variant = new WeakSet();
find_closest_variant_fn = function() {
  let found           ,
  optionSize          = parseInt(this.dataset.size),
  unRemoveSoldout     = !this.hideSoldOutVariants;
  if ( optionSize == 1 ) {
    found = getterGet(_variants_data, this).filter((variant) => variant.available);
  } else if ( optionSize == 3 ) {
    found = getterGet(_variants_data, this).filter((variant) => variant.option1 == this.options[0] && variant.option2 == this.options[1] && (unRemoveSoldout || variant.available));
  } else {
    found = getterGet(_variants_data, this).filter((variant) => variant.option1 == this.options[0] && (unRemoveSoldout || variant.available));
  }
  if (!found[0]) {
    found = getterGet(_variants_data, this).filter((variant) => variant.options[this.clickedCurrentIndex] == this.clickedCurrentValue && (unRemoveSoldout || variant.available));
  }
  this.currentVariant = found[0];
};
_update_variant_statuses = new WeakSet();
function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
update_variant_statuses_fn = function() {
  this.updateOptionStatuses(this.options);
};
_update_url = new WeakSet();
update_url_fn = function(isFrist) {
  if (!this.updateUrl || !history.replaceState) {
    document.dispatchEvent(new CustomEvent('hdt:updateUrl'));
    return;
  }
  const newUrl = new URL(window.location.href);
  const id = isFrist ? this.updateUrl : (this.currentVariant ? this.currentVariant.id : null);
  if (id) {
    newUrl.searchParams.set("variant", id);
  } else {
    newUrl.searchParams.delete("variant");
  }
  window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
  document.dispatchEvent(new CustomEvent('hdt:updateUrl'));
}
// test
// document.addEventListener("variant:change", (event)=> {
//   console.log('event variant change')
//   console.log(event.detail.variant)
// });
class VariantChangeBase extends HTMLElement {
  constructor() {
    super();
    this._onVariantChanged = this.onVariantChanged.bind(this);
  }
  get form() {
    return this._form = this._form || document.forms[this.getAttribute("form")];
  }
  connectedCallback() {
    this.form?.addEventListener(variantChange, this._onVariantChanged);
  }
  disconnectedCallback() {
    this.form?.removeEventListener(variantChange, this._onVariantChanged);
  }
  onVariantChanged() { }
};
class Price extends VariantChangeBase {
  // get price() {
  //   return this._price = this._price || $4('.hdt-money', this);
  // }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) {
      if (this._initialHTML) {
        this.innerHTML = this._initialHTML;
      }
      this.classList.remove("hdt-price-on-sale");
      return;
    }
    if (!this._initialHTML) this._initialHTML = this.innerHTML;
    $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(variant.price, currencyFormat)}</span>`;
    this.classList.toggle("hdt-price-on-sale", variant.variant_state.on_sale);
    document.dispatchEvent(new CustomEvent("currency:update"));
    this.dispatchEvent(new CustomEvent("price:update"));
  }
};
class CompareAtPrice extends Price {
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) {
      if (this._initialHTML) this.innerHTML = this._initialHTML;
      this.hidden = true;
      return;
    }
    if (!this._initialHTML) this._initialHTML = this.innerHTML;
    this.hidden = !(variant.compare_at_price > variant.price);
    if (!this.hidden) {
      $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(variant.compare_at_price, currencyFormat)}</span>`;
      //this.price.textContent = formatMoney(variant.compare_at_price, currencyFormat);
      document.dispatchEvent(new CustomEvent("currency:update"));
      this.dispatchEvent(new CustomEvent("price:update"));
    }
  }
};
class UnitPrice extends Price {
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) {
      this.hidden = true;
      return;
    }
    this.hidden = !variant.unit_price;
    if (!this.hidden) {
      //this.price.textContent = formatMoney(variant.unit_price, currencyFormat);
      $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(variant.unit_price, currencyFormat)}</span>`;
      document.dispatchEvent(new CustomEvent("currency:update"));
      this.dispatchEvent(new CustomEvent("price:update"));
    }
  }
};
class QtyPrice extends Price {
  constructor() {
    super();
    this._onVariantChanged = this.onVariantChanged.bind(this);
  }
  get qty() {
    return this._qty || $4(`[name="quantity"][form="${this.getAttribute("form")}"]`);
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) {
      this.removeAttribute('variant-price');
      this.hidden = true;
      return;
    }
    this.setAttribute('variant-price', variant.price);
    this.hidden = false;
    this.updatPrice();
  }
  connectedCallback() {
    super.connectedCallback();
    this.qty?.addEventListener('change', this.updatPrice.bind(this) );
    this.qty?.addEventListener('input', debounce( this.updatPrice.bind(this), 300));
  }
  updatPrice() {
    const price = parseFloat(this.getAttribute('variant-price'));
    $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(price * (this.qty ? this.qty.value : 1), currencyFormat)}</span>`;
    document.dispatchEvent(new CustomEvent("currency:update"));
  }
};
class Badge extends VariantChangeBase {
  constructor() {
    super();
    this.updateHiddenParent();
    if (this.parentElement) this.parentElement.classList.add('js-intent')
  }
  get is() {
    return this.getAttribute('is');
  }
  get type() {
    return this.getAttribute('type');
  }
  updateHiddenParent() {
    if (this.parentElement && this.hasAttribute('update-hidden')) {
      this.parentElement.removeAttribute('hidden');
      this.parentElement.hidden = !this.parentElement.clientHeight;
    }
  }

  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) {
      this.hidden = true;
      this.updateHiddenParent();
      return;
    }
    this.hidden = (this.is != 'available') ? !variant.variant_state[this.is] : !variant.available;
    this.updateHiddenParent();
    const percentEl = $4('[percent]', this);
    const amountEl = $4('[amount]', this);
    if (!this.hidden) {
      if (this.type === 'percentage' && percentEl) {
        const savePercent = ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price;
        if (savePercent != percentEl.textContent) percentEl.textContent = Math.max(1, Math.round(savePercent));
      }
      else if (this.type === 'fixed_amount' && amountEl) {
        const saveAmount = variant.compare_at_price - variant.price;
        if (saveAmount != amountEl.textContent) amountEl.innerHTML = formatMoney(saveAmount, currencyFormat);
      }
    }
  }
};
var _update_inventory_status, update_inventory_status_fn,
_show_quantity_inventory = new WeakMap(),
_threshold_inventory = new WeakMap(),
_progressBar_inventory = new WeakMap();
class VariantInventory extends VariantChangeBase {
  constructor() {
    super();
    getterAdd(_update_inventory_status, this);
    getterAdd(_show_quantity_inventory, this, this.hasAttribute('show-inventory-quantity'));
    getterAdd(_threshold_inventory, this, parseInt(this.getAttribute('inventory-threshold')));
    getterAdd(_progressBar_inventory, this, $4('.hdt-progress-bar', this));
  }
  get progressBar() {
    return getterGet(_progressBar_inventory, this);
  }
  onVariantChanged(event) {
    getterRunFn(_update_inventory_status, this,update_inventory_status_fn).call(this, event.detail.variant);
  }
};
_update_inventory_status = new WeakSet();
update_inventory_status_fn = function(variant){
  if (!variant) {
    this.setAttribute('hidden', '');
    return;
  }
  this.removeAttribute('hidden');
  let stringSelector = '';
  if (variant.available) {
    // continue : Continue selling when the variant is out of stock.
    // deny : Stop selling when the variant is out of stock.
    if (variant.inventory_quantity > 0) {
      if (variant.inventory_quantity <= getterGet(_threshold_inventory, this) && variant.requires_shipping) {
        stringSelector = getterGet(_show_quantity_inventory, this) ? 'low-stock-count' : 'low-stock';
      } else {
        stringSelector = getterGet(_show_quantity_inventory, this)? 'in-stock-count' : 'in-stock';
      }
    } else {
      //stringSelector = variant.next_incoming_date && variant.requires_shipping ? 'not-ship-stock' :  variant.inventory_management == 'shopify' ? 'pre-order-stock' : 'in-stock';
      stringSelector = variant.inventory_management == 'shopify' ? 'pre-order-stock' : 'in-stock';
    }
  } else {
    stringSelector = 'out-of-stock';
  }
  // else {
  //   stringSelector = variant.incoming && variant.next_incoming_date ? 'will-in-stock' : 'out-of-stock';
  // }
  // if (stringSelector == 'not-ship-stock' || stringSelector == 'will-in-stock') {
  //   $$4('[data-incoming-date]', this).forEach((dateEl) => dateEl.textContent = variant.next_incoming_date_format);
  // }
  
  if (stringSelector == 'low-stock' || stringSelector == 'in-stock' || stringSelector == 'low-stock-count' || stringSelector == 'in-stock-count') {

    $$4('[data-quantity]', this).forEach((dateEl) => dateEl.textContent = variant.inventory_quantity);
    // update progress bar
    if (this.progressBar) {
      this.progressBar.hidden = this.hasAttribute('inventory-tracked') && variant.inventory_management == null ? true : false;
      this.progressBar.valueNow = variant.inventory_quantity > 0 ? variant.inventory_quantity : this.progressBar.getAttribute("aria-valuemax");
      //this.progressBar.classList.toggle('hdt-continue-instock', continueInstock);
    }
  } else {
    this.progressBar?.setAttribute('hidden', '') ;
  }
  $4('.hdt-stock-status:not([hidden])', this)?.setAttribute('hidden', '') ;
  if (this.hasAttribute('inventory-tracked') && variant.inventory_management == null) {
    return;
  }
  $4(`.hdt-stock-status[${stringSelector || 'nt94'}]`, this)?.removeAttribute('hidden');
};
class VariantLive extends VariantChangeBase {
  get is() {
    return this.getAttribute('is'); // sku, available, barcode
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    const val = variant ? variant[this.is] : null;
    this.hidden = !val || String(val).trim() === '';
    if (!this.hidden) {
      const that = $4('[update-value]', this) || this;
      that.innerText = val;
    }
  }
};
var _pickup_availability, pickup_availability_fn;
class PickupAvailability extends VariantChangeBase {
  constructor() {
    super();
    getterAdd(_pickup_availability, this);
  }
  onVariantChanged(event) {
    getterRunFn(_pickup_availability, this, pickup_availability_fn).call(this, event.detail.variant);
  }
};
_pickup_availability = new WeakSet();
pickup_availability_fn = async function(variant) {
  if (!variant) {
    this.innerHTML = "";
  } else {
    const element = document.createElement("div");
    this.setAttribute('loading', '');
    element.innerHTML = await (await fetch(`${Shopify.routes.root}variants/${variant.id}?section_id=pickup-availability`)).text();
    this.replaceChildren(...element.querySelector("hdt-pickup-availability").childNodes);
    this.removeAttribute('loading', '');
  }
};
var _create_img2, create_img2_fn;
class VariantPreviewImg extends VariantChangeBase {
  constructor() {
    super();
    getterAdd(_create_img2, this);
  }
  onVariantChanged(event) {
    const variant = event.detail.variant,
    imgMain = $4('img', this);
    if (!variant || !variant.featured_image || !imgMain) return;
    imgMain.replaceWith(getterRunFn(_create_img2, this, create_img2_fn).call(this, variant.featured_image, imgMain));
  }
};
_create_img2 = new WeakSet();
create_img2_fn = function(objImage, imgMain) {
  return createImg({
    src: objImage.src + '&width=' + imgMain.getAttribute('width'),
    alt: imgMain.alt,
    onload: true,
    attrs: {
      width: imgMain.getAttribute('width'),
      class: imgMain.className,
      sizes: imgMain.sizes,
      'data-widths': imgMain.getAttribute('data-widths') || '[]'
    }
  });
};
class PaymentTerms extends VariantChangeBase {
  onVariantChanged(event) {
    const variant = event.detail.variant;
    const inputId = $4('[name="id"]', this);
    if (inputId) {
      inputId.value = variant ? variant.id : '';
      inputId.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};

class BackInStock extends VariantChangeBase {
  connectedCallback() {

    // Listen to form submit to store product handle and return_to search params if inside Quick View
    const notifyForm = this.querySelector('form');
    notifyForm?.addEventListener('submit', () => {
      const quickViewModal = this.closest('#hdt-quick-view-modal');
      if (quickViewModal) {
        const lazyModal = quickViewModal.parentElement;
        const handle = lazyModal?.btnOpening?.getAttribute('handle');
        if (handle) {
          const returnToInput = this.querySelector('[name="return_to"]');
          const returnToUrl = returnToInput ? returnToInput.value : '';
          let searchParams = '';
          if (returnToUrl) {
            try {
              searchParams = new URL(returnToUrl, location.origin).search;
            } catch (e) {
              console.error(e);
            }
          }
          sessionStorage.setItem('the4:quickview:reopen', JSON.stringify({
            handle: handle,
            search: searchParams
          }));
        }
      }
    });

    if ( this.hasAttribute('is-pr-default') ) return;
    this.select = $4('[back-instock-select]', this);
    this.return_to = $4('[back-instock-return-to]', this);
    this.originalText = $4('[back-instock-text]', this).textContent;
    this.elReplace = $4('[name="contact[product]"]', this);

    this.select?.addEventListener('change', (e) => {
      this.elReplace.textContent = this.originalText.replace('nt94_name', this.select.selectedOptions[0].textContent).replace('nt94_vid', this.select.value);
    });

    super.connectedCallback();
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (location.href.includes('contact%5Bid%5D') || location.href.includes('contact[id]') || location.href.includes('contact_posted=true')) {
      const url = new URL(location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('form_type');
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('contact[') || key.startsWith('contact%5B')) {
          url.searchParams.delete(key);
        }
      }
      url.hash = '';
      const newSearch = url.searchParams.toString();
      history.replaceState({}, '', url.pathname + (newSearch ? '?' + newSearch : '') + url.hash);
    }
    if (!variant) {
      this.hidden = true;
      this.removeAttribute('data-variant-available');
      return;
    }
    if (this.hasAttribute('toogle-hidden')) this.hidden = variant && variant.available;
    this.setAttribute('data-variant-available', variant.available);
    this.querySelectorAll('.hdt-form__message').forEach((el) => {
      el.remove();
    });
    if (variant && this.select && !variant.available && this.select.value != variant.id) {
      this.select.value = variant.id;
      this.select.dispatchEvent(new Event("change", { bubbles: false }));
    }
  }
};
/**
* Update incoming mess
*/
class IncomingMess extends VariantChangeBase {
  connectedCallback() {
    if ( this.hasAttribute('is-pr-default') ) return;
    super.connectedCallback();
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (!variant) {
      this.hidden = true;
      return;
    }
    const nextincomingdateformat = JSON.parse(this.dataset.obj)[variant.id];
    this.hidden = !nextincomingdateformat;
    if (!nextincomingdateformat) return;
    $4('[data-incoming-date]', variant.available ? this.firstElementChild : this.lastElementChild).textContent = nextincomingdateformat;
    this.firstElementChild.hidden = !variant.available || !variant.requires_shipping;
    this.lastElementChild.hidden = !this.firstElementChild.hidden;
  }
};

var _sticky_select = new WeakMap(),
_formElement = new WeakMap(),
_quickOrderElement = new WeakMap(),
_footerElement = new WeakMap(),
_intersection_observer = new WeakMap(),
_form_atc_visible,
form_atc_visible_fn,
_latestFormCondition = new WeakMap(),
stickyRunOne = true;
class StickyATC extends VariantChangeBase {
  #preVariantId;
  constructor() {
    super(...arguments);
    getterAdd(_form_atc_visible, this);
    getterAdd(_latestFormCondition, this, false);
    getterAdd(_intersection_observer, this, new IntersectionObserver(getterRunFn(_form_atc_visible, this, form_atc_visible_fn).bind(this)));
  }
  connectedCallback() {
    // show/hide sticky add to cart
    getterAdd(_formElement, this, document.forms[this.getAttribute("form")]);
    if (getterGet(_formElement, this)) {
      getterGet(_intersection_observer, this).observe(getterGet(_formElement, this));
      getterAdd(_quickOrderElement, this, $4('hdt-quick-order-list'));
      if (getterGet(_quickOrderElement, this)) getterGet(_intersection_observer, this).observe(getterGet(_quickOrderElement, this));
    }

    // Observe footer element for hide sticky when footer visible
    getterAdd(_footerElement, this, document.querySelector('footer'));
    if (getterGet(_footerElement, this)) {
      getterGet(_intersection_observer, this).observe(getterGet(_footerElement, this));
    }

    if ( this.hasAttribute('is-pr-default') ) return;
    // console.dir(this);
    getterAdd(_sticky_select, this, $4('[tag-select]', this));
    this.#preVariantId = getterGet(_sticky_select, this).value;
    super.connectedCallback();
    getterGet(_sticky_select, this).addEventListener('change', (e) => {
      this.variantPicker?.selectVariantByID(e.target.value, $4('.hdt-product-media__main hdt-slider')?.isActive);
    });
  }
  get variantPicker() {
    return this._variantPicker = this._variantPicker || $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`);
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    const submitBtn = $4('[name="add"]', this);
    if (!variant) {
      if (submitBtn) {
        submitBtn.disabled = true;
        const isComplete = event.detail.isComplete === true;
        let labelText, state;
        if (isComplete) {
          labelText = themeHDN.extras['unavailable'];
          state = 'unavailable';
        } else {
          const picker = document.querySelector(`hdt-variant-picker[form="${this.getAttribute("form")}"]`);
          labelText = picker?.chooseText || 'Select Options';
          state = 'incomplete';
        }
        submitBtn.firstElementChild.textContent = labelText;
        submitBtn.setAttribute('variant-state', state);
      }
      return;
    }
    if (variant && this.#preVariantId != variant.id) {
      getterGet(_sticky_select, this).value = variant.id;
      this.#preVariantId = getterGet(_sticky_select, this).value;
      //getterGet(_sticky_select, this).dispatchEvent(new Event("change", { bubbles: false }));
      // update img
      const imgMain = $4('[data-v-img]', this),
      featured_image = variant.featured_image;
      if (imgMain && featured_image) {
        const vimg = createImg({
          src: featured_image.src,
          width: imgMain.getAttribute('width'),
          height: imgMain.getAttribute('height'),
          alt: variant.featured_media?.alt || featured_image.alt || imgMain.alt,
          onload: true,
          attrs: {
            class: imgMain.className,
            sizes: imgMain.sizes,
            'data-widths': imgMain.getAttribute('data-widths') || '[]',
            'data-v-img': ''
          }
        });
        imgMain.replaceWith(vimg);
      }
      // Update qty
      $4('wrapp-hdt-pr-frm > form', this).dispatchEvent(new CustomEvent(variantChange, {
        bubbles: false,
        detail: { variant, jumpMedia: false }
      }));
      // Update btn atc
      if (submitBtn) {
        submitBtn.disabled = !variant || !variant.available;
        submitBtn.firstElementChild.textContent = themeHDN.extras[!variant ? 'unavailable' : variant.variant_state.pre_order ? 'preOrder' : variant.available ? 'addToCart' : 'soldOut'];
        const state = !variant ? 'unavailable' : variant.variant_state.pre_order ? 'pre-order' : variant.available ? 'available' : 'sold-out';
        submitBtn.setAttribute('variant-state', state);
      }
    }
  }
};
_form_atc_visible = new WeakSet();
form_atc_visible_fn = function(entries){

  if (this.variantPicker?.hasAttribute('no-pick')) {
    stickyRunOne = false;
    document.body.style.setProperty('--sticky-atc-height', '0px');
    return;
  }

  document.body.style.removeProperty('--sticky-atc-height');
  const formEntry = entries.find((entry) => entry.target === getterGet(_formElement, this));
  const quickOrderEntry = getterGet(_quickOrderElement, this) ? entries.find((entry) => entry.target === getterGet(_quickOrderElement, this)) : false;
  const footerEntry = getterGet(_footerElement, this) ? entries.find((entry) => entry.target === getterGet(_footerElement, this)) : false;  
  // console.log(formEntry)
  
  // Hide sticky when footer visible
  if (footerEntry && footerEntry.isIntersecting) {
    document.body.classList.remove("sticky-shown");
    return; // Exit early to prevent sticky from showing when footer is visible
  }
  
  if (formEntry) {
    getterAdd(_latestFormCondition, this, !formEntry.isIntersecting && formEntry.boundingClientRect.bottom < 0, true);
  }
  if (quickOrderEntry && getterGet(_quickOrderElement, this)) {
    getterAdd(_latestFormCondition, this, !quickOrderEntry.isIntersecting, true);
  }
  document.body.classList.toggle("sticky-shown", getterGet(_latestFormCondition, this));
  if (stickyRunOne && !getterGet(_latestFormCondition, this)) {
    setTimeout(() => {
      //getterAdd(_latestFormCondition, this, !formEntry.isIntersecting && (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight, true);

      getterAdd(_latestFormCondition, this, (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight, true);
      document.body.classList.toggle("sticky-shown", getterGet(_latestFormCondition, this));
      stickyRunOne = false
    }, 100);
  }
}

var _copy_to_clipboard, copy_to_clipboard_fn;
class CopyButton extends HTMLElement {
  constructor() {
    super();
    getterAdd(_copy_to_clipboard, this);
    this.addEventListener("click", getterRunFn(_copy_to_clipboard, this, copy_to_clipboard_fn).bind(this, this.input));
    this.actionCopy = !this.input ? 'textContent' : 'value';
    if (this.input && this.hasAttribute("get-document")) {
      this.closest('hdt-popover')?.addEventListener(dialogOpening, (event) => {
        this.input[this.actionCopy] = this.textCopy;
      });
    }
  }
  get input() {
    return $id4(this.getAttribute("text-id"));
  }
  get textCopy() {
    return this.hasAttribute("get-document") ? document.location.href : this.getAttribute("data-text") || "";
  }
};
_copy_to_clipboard = new WeakSet();
copy_to_clipboard_fn = async function(input) {
  if (!navigator.clipboard) return;
  await navigator.clipboard.writeText(this.textCopy);
  if (this.hasAttribute("data-success-message")) {
    input = input || this;
    const originalText = input[this.actionCopy];
    input[this.actionCopy] = this.getAttribute("data-success-message");
    setTimeout(() => {
      input[this.actionCopy] = originalText;
    }, 1500);
  }
};

var _native_share, native_share_fn;
class ShareButton extends HTMLElement {
  constructor() {
    super();
    getterAdd(_native_share, this);
    // https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
    //if (navigator.share && navigator.userAgent && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    if (navigator.share && !window.matchMedia("screen and (pointer: fine)").matches) {
      this.hidden = false;
      this.addEventListener("click", getterRunFn(_native_share, this, native_share_fn));
    }
  }
};
_native_share = new WeakSet();
native_share_fn = function() {
  navigator.share({
    title: this.getAttribute("share-title") || document.title,
    url: this.getAttribute("share-link") || document.location.href
  });
};

var _variant_toogle, variant_toogle_fn;
class VariantToogle extends HTMLElement {
  constructor() {
    super();
    getterAdd(_variant_toogle, this);
  }
  connectedCallback() {
    if ( this.firstElementChild ) document.addEventListener(variantChange, getterRunFn(_variant_toogle, this, variant_toogle_fn).bind(this));
  }
};
_variant_toogle = new WeakSet();
variant_toogle_fn = function(event) {
  const variant = event.detail.variant;
  //console.log(event, variant)
  $$4(`[variant-id]:not([hidden])`, this).forEach((variantInfo) => variantInfo.hidden = true);
  if (variant && variant.id) $4(`[variant-id="${variant.id}"]`, this)?.removeAttribute('hidden');
};

customElements.define('hdt-variant-picker', VariantPicker);
customElements.define('hdt-price', Price);
customElements.define('hdt-compare-at-price', CompareAtPrice);
customElements.define('hdt-unit-price', UnitPrice);
customElements.define('hdt-qty-price', QtyPrice);
customElements.define('hdt-badge', Badge);
customElements.define('hdt-variant-inventory', VariantInventory);
customElements.define('hdt-variant-live', VariantLive);
customElements.define('hdt-pickup-availability', PickupAvailability);
customElements.define('hdt-variant-preview-img', VariantPreviewImg);
customElements.define('hdt-payment-terms', PaymentTerms);
customElements.define('hdt-back-instock', BackInStock);
customElements.define('hdt-incoming-mess', IncomingMess);
customElements.define('hdt-sticky-btn-atc', StickyATC);
customElements.define("wrapp-hdt-copy-btn", CopyButton);
customElements.define("wrapp-hdt-share-btn", ShareButton);
customElements.define('hdt-variant-toogle-info', VariantToogle);

// document.addEventListener("currency:update", (e) =>  {
//   const _detail = e.detail;
//   if (!_detail || _detail.length == 0) return;
//   console.log(_detail);
//   CurrencyConvertAll(oldCurrency, newCurrency, _detail, format)
// });
// const CurrencyConvertAll = (oldCurrency, newCurrency, selector, format = '') => {

// }

var _onLoadingStart, onLoadingStart_fn, _onLoadingEnd, onLoadingEnd_fn;
class LoadingBar extends HTMLElement {
  constructor() {
    super();
    getterAdd(_onLoadingStart, this);
    getterAdd(_onLoadingEnd, this);
    document.addEventListener("theme:loading:doing", getterRunFn(_onLoadingStart, this, onLoadingStart_fn).bind(this));
    document.addEventListener("theme:loading:done", getterRunFn(_onLoadingEnd, this, onLoadingEnd_fn).bind(this));
  }
};
_onLoadingStart = new WeakSet();
onLoadingStart_fn = function() {
  animate(this, { opacity: [0, 1], transform: ["scaleX(0)", "scaleX(0.8)"] }, { duration: 0.5 });
};
_onLoadingEnd = new WeakSet();
onLoadingEnd_fn = async function() {
  await animate(this, { transform: [null, "scaleX(1)"] }, { duration: 0.25 }).finished;
  animate(this, { opacity: 0 }, { duration: 0.25 });
};
customElements.define("hdt-loading-bar", LoadingBar);

class RevealItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (matchMediaQuery("motion") && this.enabledReveal && $$4(this.selector, this).length > 0) {
    inView(this, this.reveal.bind(this));
    }
  }
  //disconnectedCallback() { }
  get selector() {
    const _selector = this.getAttribute('selector') || '.hdt-card-product';
    return (this.prependEl || '') + _selector + (this.appendEl || '').replaceAll(/nathan/g, _selector);
  }
  get enabledReveal() {
    return this.getAttribute('reveal-on-scroll') === 'true';
  }
  reveal() {
    animate($$4((this.selector), this), {
      opacity: [0, 1],
      transform: ["translateY(30px)", "translateY(0)"],
    },
    {
      duration: 0.25,
      easing: "ease",
      delay: stagger(0.05, { start: 0.3, easing: "ease" })
    });
    // .finished.then(() => {
    //   this.appendEl = '';
    // });
   // this.setEl = null;
    // .finished.then(() => {
    //   this.setEl = null;
    // });
  }
  revealInstant() {
    animate($$4((this.selector), this), {
      opacity: [0, 1],
      transform: ["translateY(30px)", "translateY(0)"],
    },
    {
      duration: 0.25,
      easing: "ease"
    });
  }
}
customElements.define("hdt-reval-items", RevealItems);

// Load More
var _load_more_url, load_more_url_fn,
_lm_render, lm_render_fn,
_lm_a = new WeakMap();
const str_shopify_section = 'shopify-section';
class LoadMore extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_load_more_url, this);
    getterAdd(_lm_render, this);
    getterAdd(_lm_a, this, $4('a', this));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.abortController2 = null;
    getterGet(_lm_a, this).addEventListener("click", getterRunFn(_load_more_url, this, load_more_url_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get idcontrol() {
    return '#'+ getterGet(_lm_a, this).getAttribute("append");
  }
};
_load_more_url = new WeakSet();
load_more_url_fn = function(event) {
  event.preventDefault();
  const url = new URL(getterGet(_lm_a, this).href);
  url.searchParams.set("section_id", getterGet(_lm_a, this).getAttribute("section-id"));
  getterRunFn(_lm_render, this, lm_render_fn).call(this, {detail:{ url, id: this.idcontrol }})
};
_lm_render = new WeakSet();
lm_render_fn = async function(event) {
  // console.log(event)
  if (this.abortController2) {
    this.abortController2.abort();
  }
  this.abortController2 = new AbortController();
  const url            = event.detail.url,
        section_id     = url.searchParams.get("section_id"),
        page_number    = url.searchParams.get("page"),
        idSelector     = this.getAttribute('tab-id') || `${str_shopify_section}-${section_id}`,
        shopifySection = document.getElementById(idSelector) || document.getElementById(`${str_shopify_section}-${section_id}`),
        clonedUrl      = new URL(url);
  clonedUrl.searchParams.delete("section_id");

  const mainContent        = $4(event.detail.id, shopifySection),
        $paginationWrapper = $4("[loadmore-btn-wrapp]", shopifySection);
  try {
    $paginationWrapper.setAttribute('loading', '');
    const tempContent = new DOMParser().parseFromString(await (await fetch(url.toString(), { signal: this.abortController2.signal }).then((response) => {
      // if (response.status === 200) {
      //   const contentType = response.headers.get("Content-Type");
      //   if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
      //     response.clone().text().then((content) => {
      //       // cache
      //     });
      //   }
      // }
      return response;
    })).text(), "text/html");
    //console.log(tempContent)
    const newMainContent = $4(`.${str_shopify_section} ${event.detail.id}`, tempContent);
    mainContent.lastElementChild.classList.add(`point-effect-${page_number}`);
    mainContent.append(...document.importNode(newMainContent, true).childNodes);
    mainContent.dispatchEvent(new CustomEvent("products:update", { bubbles: true }));
    if (matchMediaQuery("motion")) {
      mainContent.prependEl = `.point-effect-${page_number} ~ `;
      mainContent.reveal();
    }

    const $newPaginationWrapper = $4("[loadmore-btn-wrapp]", $4('#'+idSelector, tempContent));
    if ($newPaginationWrapper) {
      $paginationWrapper.replaceChildren(...document.importNode($newPaginationWrapper, true).childNodes);
      $paginationWrapper.removeAttribute('loading');
    } else {
      $paginationWrapper.remove();
    }

  } catch (e) { }
};
customElements.define("wrapp-hdt-lm-url", LoadMore);
var _qty_inputs = new WeakMap(),
ON_CHANGE_DEBOUNCE_TIMER = 300;
class QuantityWrapp extends HTMLElement {
  #abortController;
  constructor() {
    super(...arguments);
    //this.changeEvent = new Event('change', { bubbles: true });
    getterAdd(_qty_inputs, this, $4('input', this));
  }
  get input() {
    return getterGet(_qty_inputs, this);
  }
  async connectedCallback() {
    this.#abortController = new AbortController();
    if (!this.input) return;
    //this.input = $4('input', this);
    this.input.addEventListener('change', this.onInputChange.bind(this), { signal: this.#abortController.signal });
    $$4('button', this).forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this), { signal: this.#abortController.signal })
    );
    this.buttonMinus = $4(".hdt-quantity__button[name='minus']", this);
    this.buttonPlus = $4(".hdt-quantity__button[name='plus']", this);
    this.validateQtyRules();

    // product form quantity
    if (this.input.hasAttribute("form") && this.form) {
      this.form.addEventListener(variantChange, (event)=> {
        const variant = event.detail.variant;
        this.input.removeAttribute('max');
        if (!variant) return;
        // console.log('varaint: ', variant);
        if(variant.inventory_quantity > 0 && variant.inventory_management != null && variant.inventory_policy != 'continue') {
          this.input.max = variant.inventory_quantity;
          if(variant.inventory_quantity < parseInt(this.input.value)) {
            this.input.value = variant.inventory_quantity;
            this.validateQtyRules();
          }
        }
        if(variant.quantity_rule) {
          this.input.step = variant.quantity_rule.increment;
          this.input.min = variant.quantity_rule.min;
          if(variant.quantity_rule.max) this.input.max = variant.quantity_rule.max;
        }
      }, { signal: this.#abortController.signal });
    }
    // end product form quantity

    this.debouncedOnChange = debounce(() => {
      this.input.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { target: this.input } }));
    }, ON_CHANGE_DEBOUNCE_TIMER);
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }

  onInputChange() {
    this.validateQtyRules();
    this.input.dispatchEvent(new QuantitySelectorUpdateEvent(parseInt(this.input.value), Number(this.input.dataset.index)));
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.debouncedOnChange();
    }
    let show_mess = parseInt(previousValue) === parseInt(this.input.max) && parseInt(previousValue) === parseInt(this.input.value) ? true : false;
    if(show_mess) {
      this.input.classList.add('hdt-quantity-max-reached');
      setTimeout(() => {
        this.input.classList.remove('hdt-quantity-max-reached');
      }, 3500);
    }
    if(!this.form) return;
    const addToCartError = $4('[ref="addToCartTextError"]', this.form);
    if(!addToCartError) return;
    if(show_mess) {
      if (addToCartError) {
        addToCartError.removeAttribute('hidden');
        $4('.hdt-error-message', addToCartError).textContent = themeHDN.extras.quantity.notAvailable || 'The quantity you selected is not available.';
      }
    }
    if(parseInt(previousValue) === parseInt(this.input.max) && parseInt(previousValue) > parseInt(this.input.value)) {
      addToCartError.setAttribute('hidden', '');
    };
  }
  validateQtyRules() {
    const value = parseInt(this.input.value),
    _max = this.input.max || 9999,
    max = parseInt(String(_max) != 'null' ? _max : 9999);
    this.input.value = Math.min(value, max);
    //this.input.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { line: this.dataset.index, qty: value } }));
    if (this.input.min) this.buttonMinus.classList.toggle('disabled', value <= parseInt(this.input.min));
    this.buttonPlus.classList.toggle('disabled', value >= parseInt(max));
  }
  get form() {
    return this._form = this._form || document.forms[this.input.getAttribute("form")];
  }
}
customElements.define('hdt-quantity-wrapp', QuantityWrapp);

var _block_required_froms,
_block_required_detect,
_block_required_on_change, block_required_on_change_fn,
_block_required_on_submit, block_required_on_submit_fn;
class BlockRequired extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_block_required_on_submit, this);
    getterAdd(_block_required_on_change, this);
    getterAdd(_block_required_detect, this, this.getAttribute('detect'));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const arrRequireds = $$4('[required]', this);
    //this.form.checkBreak = false;
    if (arrRequireds.length == 0) return;
    getterAdd(_block_required_froms, this, document.forms[this.attrForm]);
    if (!this.form) return;
    const { signal } = this.#abortController;
    arrRequireds.forEach((el) => { el.removeAttribute("required"); this.classList.add("is-required") } );
    //this.form.checkBreak = ( $$4(`hdt-block-required [form="${this.attrForm}"]`).length != $$4(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length );
    this.updateBreak();
    if ( this.getAttribute('event') === 'change') {
      setTimeout(() => this.checked = $4('input:checked', this), 100); // fix when back tab will autocomplete
      this.addEventListener("change", getterRunFn(_block_required_on_change, this, block_required_on_change_fn).bind(this), { signal });
    } else {
      this.addEventListener("input", debounce( getterRunFn(_block_required_on_change, this, block_required_on_change_fn).bind(this), 150, { signal }));
    }
    this.form.addEventListener("submit", getterRunFn(_block_required_on_submit, this, block_required_on_submit_fn).bind(this), { signal });
  }
  updateBreak() {
    this.form.checkBreak = ( $$4(`hdt-block-required [form="${this.attrForm}"]`).length != $$4(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length );
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  createStyle() {
    const arr = [];
    let i,j = 0;
    for (i = 0; i < 10; i++) {
      arr.push(`translate3d(${arguments[j++]},0,0)`);
      if (j === arguments.length) j = 0;
    }
    return arr
  }
  /**
   * @param {any} value
   */
  set checked(value) {
    this.setChecked = value;
  }
  get checked() {
    return this.setChecked
  }
  get attrForm() {
    return this._attrForm = this._attrForm || $4('[form]', this).getAttribute("form");
  }
  get form() {
    return getterGet(_block_required_froms, this, document.forms[this.attrForm]);
  }
}
_block_required_froms = new WeakMap();
_block_required_detect = new WeakMap();
_block_required_on_change = new WeakSet();
block_required_on_change_fn = function() {
  this.checked = false;
  // checked, length
  if ( getterGet(_block_required_detect, this ) === 'checked') {
    if ($4('input:checked', this)) this.checked = true;
  } else {
    const element = $4('input[type="text"]', this) || $4('textarea', this) || $4('select', this);
    if (element && element.value.length > 0) this.checked = true;
  }
  // this.classList.remove('is-required');
  // this.classList.toggle('is-uncheck', !this.checked);
  this.classList.remove('is-uncheck');
  this.classList.toggle('is-required', !this.checked);
  this.updateBreak();
};
_block_required_on_submit = new WeakSet();
block_required_on_submit_fn = function(event) {
  if (this.checked || event.target?.getAttribute('id') !== this.attrForm) return;
  event.preventDefault();
  event.stopPropagation();
  this.classList.remove('is-required');
  this.classList.add('is-uncheck');
  //$4('label', this)?.focus();
  $4(`hdt-block-required.is-uncheck [form="${this.attrForm}"]`).focus();
  animate(
    this,
    {
      transform: this.createStyle(0, '-10px', '10px')
    },
    {
      offset: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      duration: 1,
      ease: "ease"
    }
  );
};

customElements.define("hdt-block-required", BlockRequired);
class CheckedToUse extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const input = $id4(this.getAttribute('get-id'));
    if (input) {
      input.addEventListener('change', (e) => this.firstElementChild.toggleAttribute('disabled', !input.checked), { signal: this.#abortController.signal });
    } else {
      this.firstElementChild.removeAttribute('disabled');
    }
    this.addEventListener('click', (e) => {
      if (input.checked) return
      this.closest('form')?.dispatchEvent(new Event("submit", { bubbles: true }));
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
customElements.define("hdt-need-checked-to-use", CheckedToUse);

// CART
// _cart_on_submit = new WeakSet();
// cart_on_submit_fn = function() {
// };
// remove item
var _remove_item_on_cart = new WeakSet(), remove_item_on_cart_fn;
class RemoveItemOnCart extends btnTooltip {
  #abortController;
  constructor() {
    super();
    getterAdd(_remove_item_on_cart, this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.#abortController = new AbortController();
    this.addEventListener("click", getterRunFn(_remove_item_on_cart, this, remove_item_on_cart_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }
}
remove_item_on_cart_fn = function(e) {
  e.preventDefault();
  this.dispatchEvent(new QuantitySelectorUpdateEvent(0, Number(this.dataset.index)));
};


// cart discount
class CartDiscount extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }

  connectedCallback() {
    this.#abortController = new AbortController();
    
    // Add input handler to show/hide Apply button
    const input = this.querySelector('[data-cart-discount-input]');
    if (input) {
      input.addEventListener('input', this.handleInputChange.bind(this), { signal: this.#abortController.signal });
    }
    
    // Add click handler for Apply button
    const applyButton = this.querySelector('[data-cart-discount-apply]');
    if (applyButton) {
      applyButton.addEventListener('click', this.handleApplyClick.bind(this), { signal: this.#abortController.signal });
    }
    
    // Add click handler for remove discount buttons - use document with early return for performance
    document.addEventListener('click', this.handleRemoveDiscount.bind(this), { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  handleInputChange(event) {
    const input = event.target;
    const applyButton = this.querySelector('[data-cart-mini-discount-apply]');
    if (applyButton) {
      applyButton.style.display = input.value ? 'inline-flex' : 'none';
    }
  }

  async handleApplyClick(event) {
    const input = this.querySelector('[data-cart-discount-input]');
    if (!input) return;

    var discount = input.value;
    if (input.hasAttribute('data-value')) {
      const inputValue = input.value.trim();
      const dataValue = input.getAttribute('data-value').trim();
      if (dataValue) {
        discount = `${inputValue},${dataValue}`;
        input.setAttribute('data-value', discount);
      }
    }
    const errorElement = this.querySelector('[data-cart-discount-error]');
    const sections = [this.closest('.shopify-section').id.replace('shopify-section-', '')];
    
    // Trigger loading start
    document.dispatchEvent(new CustomEvent('theme:loading:doing'));
    
    try {
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: discount,
          sections: sections
        })
      });

      const data = await response.json();
      if (response.ok && data.discount_codes[0].applicable) {

        // Clear any previous error messages
        if (errorElement) {
          errorElement.textContent = '';
          errorElement.style.display = 'none';
        }

        // Refresh cart drawer if it exists
        document.dispatchEvent(new CustomEvent(cartReload));
      } else {
        // Handle error case
        if (errorElement) {
          // errorElement.textContent = data.description || 'Invalid discount code';
          errorElement.style.display = 'block';
        }
        input.value = ''; // Clear invalid input
        const applyButton = this.querySelector('[data-cart-mini-discount-apply]');
        if (applyButton) {
          applyButton.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error applying discount:', error);
      if (errorElement) {
        errorElement.textContent = 'Error applying discount code';
        errorElement.style.display = 'block';
      }
    } finally {
      // Trigger loading end
      document.dispatchEvent(new CustomEvent('theme:loading:done'));
    }
  }

  async handleRemoveDiscount(event) {
    // Early return if click is not on remove button - optimize performance
    const removeButton = event.target.closest('.hdt-discount-remove');
    if (!removeButton) return;

    const discountCodeToRemove = removeButton.dataset.discountCode;
    if (!discountCodeToRemove) return;

    const sections = [this.closest('.shopify-section').id.replace('shopify-section-', '')];

    // Trigger loading start
    document.dispatchEvent(new CustomEvent('theme:loading:doing'));

    try {
      // Get current discount codes from data-value attribute
      const discountInput = this.querySelector('[data-cart-discount-input]');
      let currentDiscountCodes = [];
      
      if (discountInput && discountInput.hasAttribute('data-value')) {
        const dataValue = discountInput.getAttribute('data-value').trim();
        if (dataValue) {
          // Parse comma-separated discount codes
          currentDiscountCodes = dataValue.split(',').map(code => code.trim()).filter(code => code);
        }
      }

      // Remove the specific discount code
      const remainingDiscountCodes = currentDiscountCodes.filter(code => code !== discountCodeToRemove);

      // Update cart with remaining discount codes (or empty string if none left)
      const discountValue = remainingDiscountCodes.length > 0 
        ? remainingDiscountCodes.join(',') 
        : '';

      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: discountValue,
          sections: sections
        })
      });
      const data = await response.json();

      if (response.ok) {
        // Trigger cart refresh
        document.dispatchEvent(new CustomEvent(cartReload));
        // document.dispatchEvent(new DiscountUpdateEvent(data, this.id));

        // Update discount input and data-value attribute
        if (discountInput) {
          if (remainingDiscountCodes.length === 0) {
            discountInput.value = '';
            discountInput.removeAttribute('data-value');
          } else {
            discountInput.setAttribute('data-value', remainingDiscountCodes.join(','));
          }
        }
      }
    } catch (error) {
      console.error('Error removing discount:', error);
    } finally {
      // Trigger loading end
      document.dispatchEvent(new CustomEvent('theme:loading:done'));
    }
  }
}
// ... existing code ...

// cart note
var _cart_note_on_change  = new WeakSet(), cart_note_on_change_fn;
class CartNote extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_cart_note_on_change, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.addEventListener("change", getterRunFn(_cart_note_on_change, this, cart_note_on_change_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
cart_note_on_change_fn = function(event) {
  const note = event.target.value;
  fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
    keepalive: true
  });
  $$4('[data-label-note]').forEach((label) => {
    if (label.childElementCount === 2 ) {
      label.firstElementChild.toggleAttribute("hidden", note.length > 0);
      label.lastElementChild.toggleAttribute("hidden", note.length === 0);
    }
  });
};

class CartCountComponent extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  #updateCount(event) {
    this.textContent = event.detail.item_count;
  }
  
  async #handleCartReload() {
    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ sections: [this.sectionId] }),
      });
      const response = await fetch(`${Shopify.routes.root}cart/update`, {...config});
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      // console.log('Cart reloaded:', cartData.item_count);      
      document.dispatchEvent(new CartCountEvent(cartData.item_count, cartData.total));
      document.dispatchEvent(new CustomEvent(currencyUpdate));
    } catch (error) {
      console.error('Failed to reload cart:', error);
    }
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    document.addEventListener(ThemeEvents.cartCount, this.#updateCount.bind(this), { signal: this.#abortController.signal });
    if (themeHDN.settings.actionAfterATC == 'no') {
      document.addEventListener(ThemeEvents.cartReload, this.#handleCartReload.bind(this), { signal: this.#abortController.signal });
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
class CartTotalComponent extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }

  #updateCount(event) {
    this.innerHTML = `<span class="hdt-money">${event.detail.total_price}</span>`
  }
  
  async #handleCartReload() {
    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ sections: [this.sectionId] }),
      });
      const response = await fetch(`${Shopify.routes.root}cart/update`, {...config});
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      // console.log('Cart reloaded:', cartData.item_count);      
      document.dispatchEvent(new CartCountEvent(cartData.item_count, cartData.total));
      document.dispatchEvent(new CustomEvent(currencyUpdate));
    } catch (error) {
      console.error('Failed to reload cart:', error);
    }
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    document.addEventListener(ThemeEvents.cartCount, this.#updateCount.bind(this), { signal: this.#abortController.signal });
    if (themeHDN.settings.actionAfterATC == 'no') {
      document.addEventListener(ThemeEvents.cartReload, this.#handleCartReload.bind(this), { signal: this.#abortController.signal });
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
customElements.define("wrapp-remove-item-oncart", RemoveItemOnCart);
customElements.define("hdt-cart-note", CartNote);
customElements.define("hdt-cart-discount", CartDiscount);
customElements.define("hdt-cart-count", CartCountComponent);
customElements.define("hdt-cart-total", CartTotalComponent);
// customElements.define("hdt-cart-dot", CartDot);
//customElements.define("hdt-cart-drawer", CartDrawer);
// END CART
var _allow_update_progress_bar, _update_progress_bar, update_progress_bar_fn,
_color_progress_bar;
class ProgressBar extends HTMLElement {
  constructor() {
    super();
    getterAdd(_update_progress_bar, this);
    getterAdd(_allow_update_progress_bar, this, !this.hasAttribute("reveal-in-view"));
    getterAdd(_color_progress_bar, this, this.getAttribute('data-colors'));
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    if (this.hasAttribute("reveal-in-view")) {
      inView(this, () => {
        getterAdd(_allow_update_progress_bar, this, true, true);
        getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
      }, { margin: "-50px 0px" });
    }
  }
  get progress() {
    return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"));
  }
  /**
   * @param {string} value
   */
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  /**
   * @param {string} value
   */
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    if (getterGet(_allow_update_progress_bar, this)) {
      getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
    }
  }
};

_color_progress_bar = new WeakMap();
_allow_update_progress_bar = new WeakMap();
_update_progress_bar = new WeakSet();
update_progress_bar_fn = function() {
  const findRange = (value, ranges) => {
    const sortedRanges = [...ranges].sort((a, b) => a - b);
    return sortedRanges.find((range, i) => 
      value >= range && (i === sortedRanges.length - 1 || value < sortedRanges[i + 1])
    ) ?? sortedRanges[0];
  };

  const colors = JSON.parse(getterGet(_color_progress_bar, this) ?? '{}');
  const fixedNum = parseFloat((this.progress + '').slice(0, 3));
  
  const ranges = Object.keys(colors)
    .map(Number)
    .sort((a, b) => a - b);
  
  const rangeValue = findRange(fixedNum, ranges);
  Object.entries(colors)?.forEach(([key, item]) => {
    this.parentElement?.classList.toggle(item, parseFloat(key) === rangeValue);
  });
  this.style.setProperty('--progress-rate', `${this.progress}`);

  // this.parentElement?.addEventListener(ThemeEvents.progressBarChange, (event) => {
  //   console.log(event.detail.rangeValue);
  // });
  if( this.parentElement?.tagName == 'HDT-FREE-SHIPPING-BAR') {
    this.parentElement?.dispatchEvent(new CustomEvent(ThemeEvents.progressBarChange, { bubbles: true, detail: { rangeValue: this.progress } }));
  }
};
customElements.define("hdt-progress-bar", ProgressBar);


var _onCountryChanged, onCountryChanged_fn;
class CountryProvinceSelector extends HTMLElement {
  #abortController;
  constructor() {
    super(...arguments);
    getterAdd(_onCountryChanged, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.countryEl = $4('[name="address[country]"]', this);
    this.provinceEl = $4('[name="address[province]"]', this);
    this.countryEl.addEventListener("change", getterRunFn(_onCountryChanged, this, onCountryChanged_fn).bind(this), { signal: this.#abortController.signal });
    if (this.getAttribute("country") !== "") {
      this.countryEl.selectedIndex = Math.max(0, Array.from(this.countryEl.options).findIndex((option) => option.textContent === this.getAttribute("country")));
    }
    this.countryEl.dispatchEvent(new Event("change"));
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
_onCountryChanged = new WeakSet();
onCountryChanged_fn = function() {
  const option = this.countryEl.options[this.countryEl.selectedIndex],
  provinces = JSON.parse(option.getAttribute("data-provinces"));
  this.provinceEl.parentElement.hidden = provinces.length === 0;
  this.provinceEl.disabled = provinces.length === 0;
  if (provinces.length === 0) {
    return;
  }
  this.provinceEl.innerHTML = "";
  provinces.forEach((data) => {
    const selected = data[1] === this.getAttribute("province") || data[0] === this.getAttribute("province");
    this.provinceEl.options.add(new Option(data[1], data[0], selected, selected));
  });
};
customElements.define("hdt-country-province-selector", CountryProvinceSelector);

/**
 * https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
 * https://community.shopify.com/c/shopify-design/cart-add-a-shipping-rates-calculator-to-your-cart/td-p/616554
 */
var _estimateShipping, estimateShipping_fn, _getAsyncShippingRates, getAsyncShippingRates_fn, _formatShippingRates, formatShippingRates_fn, _formatError, formatError_fn;
var ShippingCalculator = class extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_estimateShipping, this);
    getterAdd(_getAsyncShippingRates, this);
    getterAdd(_formatShippingRates, this);
    getterAdd(_formatError, this);
    this.langRates = JSON.parse( $4('template[data-lang-rates]', this).innerHTML );
  }
  currencyMulti(amount) {
    if (themeHDN.settings.currencyFormat.indexOf("with_comma_separator") !== -1) {
      amount = amount.replace(/[,.]/g, function(match) {
        return match === "," ? "." : ",";
      });
    }
    return parseFloat(amount.replace(/^[^0-9]+|[^0-9.]/g, '', ''), 10) * (parseFloat(Shopify.currency.rate) * (themeHDN.settings.currencyFormat.indexOf("with_comma_separator") == -1 ? 100 : 1));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.submitButton = $4('[type="button"]', this);
    this.resultsElement = $4('[aria-live="polite"]', this);
    this.submitButton.addEventListener("click", getterRunFn(_estimateShipping, this, estimateShipping_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
_estimateShipping = new WeakSet();
estimateShipping_fn = async function(event) {
  event.preventDefault();
  const zip = $4('[name="address[zip]"]', this).value,
  country = $4('[name="address[country]"]', this).value,
  $province = $4('[name="address[province]"]', this),
  province = $province.disabled ? '' : $province.value;
  this.submitButton.setAttribute("aria-busy", "true");
  document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
  const prepareResponse = await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
  document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
  if (prepareResponse.ok) {
    const shippingRates = await getterRunFn(_getAsyncShippingRates, this, getAsyncShippingRates_fn).call(this, zip, country, province);
    getterRunFn(_formatShippingRates, this, formatShippingRates_fn).call(this, shippingRates);
  } else {
    const jsonError = await prepareResponse.json();
    getterRunFn(_formatError, this, formatError_fn).call(this, jsonError);
  }
  this.resultsElement.hidden = false;
  this.submitButton.removeAttribute("aria-busy");
};
_getAsyncShippingRates = new WeakSet();
getAsyncShippingRates_fn = async function(zip, country, province) {
  const response = await fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
  const responseAsText = await response.text();
  if (responseAsText === "null") {
    return getterRunFn(_getAsyncShippingRates, this, getAsyncShippingRates_fn).call(this, zip, country, province);
  } else {
    return JSON.parse(responseAsText).shipping_rates;
  }
};
_formatShippingRates = new WeakSet();
formatShippingRates_fn = function(shippingRates) {
  let ratesList = shippingRates.map((shippingRate) => {
    return `<li>${shippingRate.presentment_name}: ${ shippingRate.price == "0.00" ? this.langRates.free : `<span class="hdt-money">${formatMoney(this.currencyMulti(shippingRate.price), themeHDN.settings.currencyFormat)}</span>` }</li>`;
  });
  this.resultsElement.innerHTML = `
    <div class="hdt-mess__rates is--rates-success">
      <p>${shippingRates.length === 0 ? this.langRates.no_rates : shippingRates.length === 1 ? this.langRates.one_rate : this.langRates.multiple_rates}</p>
      ${ratesList === "" ? "" : `<ul role="list">${ratesList.join('')}</ul>`}
    </div>
  `;
  document.dispatchEvent(new CustomEvent("currency:update"));
};
_formatError = new WeakSet();
formatError_fn = function(errors) {
  let errorHtml = Object.keys(errors).map((errorKey) => {
    return `<li><span class="hdt-key__rate">${errorKey}:</span> ${errors[errorKey]}</li>`;
  });
  this.resultsElement.innerHTML = `
      <div class="hdt-mess__rates is--rates-error">
        <p>${this.langRates.errors}</p>
        <ul role="list">${errorHtml.join('')}</ul>
      </div>
    `;
};
customElements.define("hdt-shipping-calculator", ShippingCalculator);


// MEDIA PLAYER
class player extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._createPlayer(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerApi(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};
class ModelPlayer extends player {
  connectedCallback() {
    super.connectedCallback();
    this.player;
  }
  _createPlayer() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = $4("model-viewer", this);
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerApi(target, action) {
    // console.log(target, action, target[action])
    // target[action]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));

    } else {
      const modelJson = $id4('ModelJson-' + this.getAttribute('section-id'));
      //console.log(JSON.parse(modelJson.textContent))
      window.ShopifyXR.addModels(JSON.parse(modelJson.textContent));
      window.ShopifyXR.setupXRElements();
      this.closest('hdt-slider')?.reInit()
    }
  }
};

var onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class VideoPlayer extends player {
  #mustRemoveControlsAfterSuspend = false;
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { once: true, signal: this._abortController.signal });
    }
    // if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
    //   this.attachShadow({ mode: "open" }).appendChild(document.getElementById("video-media-default-template").content.cloneNode(true));
    // }
    if (this.getAttribute("type") === "video") {
      inView(this, () => {
        $4("video", this)?.setAttribute("preload", "metadata");
      }, { margin: "800px" });
    }
  }
  _createPlayer() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = $4("template", this);
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        if (this.getAttribute('type') === 'background') {
          this.sizeBackgroundVideo();
          // Listen to resize to keep a background-size:cover-like layout
          window.addEventListener('resize', debounce( this.sizeBackgroundVideo.bind(this), 300));
        }
        const muteVideo = this.hasAttribute("autoplay") || matchMediaQuery("mobile");
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          const player = new YT.Player($4("iframe", this), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player($4("iframe", this));
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = $4("video", this);
      this.setAttribute("loaded", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
        this.removeAttribute("suspended");
        if (this.#mustRemoveControlsAfterSuspend) {
          videoElement.controls = false;
        }
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerApi(target, action) {
    if (this.getAttribute("host") === "youtube") {
      target[`${action}Video`]();
    } else {
      // video html5 + play
      if (action === "play" && !this.hasAttribute("host")) {
        target.play().catch((error) => {
          if (error.name === "NotAllowedError") {
            this.setAttribute("suspended", "");
            if (!this.hasAttribute("controls")) {
              this.#mustRemoveControlsAfterSuspend = true;
              target.controls = true;
            }
          }
        });
      } else {
        // vimeo or video html5 + pause
        target[action]();
      }
    }
  }
  sizeBackgroundVideo() {
    var iframeW  ,
    iframeH      ,
    marginLeft   ,
    marginTop    ,
    containerW   = this.clientWidth,
    containerH   = this.clientHeight;

    containerW / containerH < 16 / 9 ?
    (
       iframeW = containerH * (16 / 9),
       iframeH = containerH,
       marginLeft = -Math.round((iframeW - containerW) / 2),
       marginTop = -Math.round((iframeH - containerH) / 2)
    ) : (
       iframeH = (iframeW = containerW) * (9 / 16),
       marginTop = -Math.round((iframeH - containerH) / 2),
       marginLeft = -Math.round((iframeW - containerW) / 2)
    );
    $4("iframe", this).style.cssText = `max-width: 1000%; margin-left: ${marginLeft}px; margin-top: ${marginTop}px; width: ${iframeW}px; height: ${iframeH}px;`;
  }
};

import { Lightbox, Zoom } from "@theme/zoom-psw";
const svgPath = `<svg aria-hidden="true" viewBox="0 0 24 24" stroke="currentColor" stroke-width="0.8" fill="none" stroke-linecap="round" stroke-linejoin="round" class="pswp__icn"`;
var _on_variant_changed_media, on_variant_changed_media_fn,
_slider_main_select, slider_main_select_fn,
_lightbox_psw_media_init = new WeakMap(),
_ui_register = new WeakSet(), ui_register_fn,
_media_image_click, media_image_click_fn,
_media_image_zoom, media_image_zoom_fn,
_update_group_media, update_group_media_fn;
class ProductMedia extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_variant_changed_media, this);
    getterAdd(_update_group_media, this);
    getterAdd(_slider_main_select, this);
    getterAdd(_media_image_click, this);
    getterAdd(_media_image_zoom, this);
    getterAdd(_ui_register, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.form?.addEventListener(variantChange, getterRunFn(_on_variant_changed_media, this, on_variant_changed_media_fn).bind(this), { signal: this.#abortController.signal });
    if (this.sliderMain) {
      this.sliderMain.addEventListener('select:slide', getterRunFn(_slider_main_select, this, slider_main_select_fn).bind(this), { signal: this.#abortController.signal });
      this.sliderMain.addEventListener('init:slide', this.updateAttrPsw.bind(this));
    }
    if (this.updateGroupFilter) this.addEventListener('update:value', getterRunFn(_update_group_media, this, update_group_media_fn).bind(this), { signal: this.#abortController.signal });

    if ((this.imageZoom == 'zoom' || this.imageZoom == 'zoom_lightbox') && matchMediaQuery("hover")) {
      getterRunFn(_media_image_zoom, this, media_image_zoom_fn).call(this);
    }

    if (this.imageZoom != 'no') {
      if(this.imageZoom == 'zoom' && matchMediaQuery("hover")) return; 
      $$4('.hdt-product-media__main [data-media-type="image"]', this).forEach((imageWrap) => {
        imageWrap.addEventListener("click", getterRunFn(_media_image_click, this, media_image_click_fn).bind(this, imageWrap), { signal: this.#abortController.signal });
      });
      this.addEventListener("lightbox:psw:open", (event) => this.openLightBox(event?.detail?.index));
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get form() {
    return this._form = this._form || document.forms[this.getAttribute("form")];
  }
  get sliderMain() {
    return this._sliderMain = this._sliderMain || $4(`.hdt-product-media__main hdt-slider`, this);
  }
  get sliderThumb() {
    return this._sliderThumb = this._sliderThumb || $4(`hdt-slider-thumb`, this);
  }
  get variantPicker() {
    return this._variantPicker = this._variantPicker || $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`);
  }
  get updateGroupFilter() {
    return this.hasAttribute('can-has-media-group');
  }
  get imageZoom() {
    return this.getAttribute('image-zoom');
  }
  get sectionId() {
    return this.getAttribute('section-id');
  }
  /**
   * Create the PhotoSwipe instance if it does not already exist. This is done on demand, so until the lightbox is
   * open, nothing is created to not impact performance
   */
  get lightBox() {
    if (getterGet(_lightbox_psw_media_init, this)) {
      return getterGet(_lightbox_psw_media_init, this);
    }
    let secondaryZoomLevel = parseInt(this.getAttribute("max-zoom")) || 2;
    getterAdd(_lightbox_psw_media_init, this, new Lightbox({
      pswpModule: () => import("@theme/psw"),
      bgOpacity: 1,
      secondaryZoomLevel,
      maxZoomLevel: ++secondaryZoomLevel,
      closeTitle: themeHDN.extras.pswp.close,
      zoomTitle: themeHDN.extras.pswp.zoom,
      arrowPrevTitle: themeHDN.extras.pswp.prev,
      arrowNextTitle: themeHDN.extras.pswp.next,
      errorMsg: themeHDN.extras.pswp.errorMsg,
      // UX - https://photoswipe.com/styling/
      arrowPrevSVG: `${svgPath} width="24" height="24"><polyline points="15 18 9 12 15 6"></polyline></svg>`,
      arrowNextSVG: `${svgPath} width="24" height="24"><polyline points="9 18 15 12 9 6"></polyline></svg>`,
      closeSVG: `${svgPath} width="28" height="28"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
      zoomSVG: `${svgPath} width="22" height="22"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line id="pswp__icn-plus" x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`,
    }));
    // getterGet(_lightbox_psw_media_init, this).on("uiRegister", __privateMethod(this, _registerLightboxUi, registerLightboxUi_fn).bind(this));
    getterGet(_lightbox_psw_media_init, this).addFilter("thumbEl", (thumbEl, data) => data.thumbEl);
    getterGet(_lightbox_psw_media_init, this).on('close', () => {
      const target = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden])')[getterGet(_lightbox_psw_media_init, this).pswp.currIndex];
      if (!target) return;
      if (this.sliderMain && this.sliderMain.isActive) {
        //this.sliderMain.goToIndex(currIndex, true);
        this.sliderMain.goToTarget(target, true);
      } else {
        target.scrollIntoView({ block: "start", behavior: "instant" });
      }
    });
    getterGet(_lightbox_psw_media_init, this).on('uiRegister', getterRunFn(_ui_register, this, ui_register_fn).bind(this));
    getterGet(_lightbox_psw_media_init, this).on('openingAnimationEnd', ()=> getterGet(_lightbox_psw_media_init, this).pswp.template.classList.add('hdt-psw-animate'));
    getterGet(_lightbox_psw_media_init, this).on('closingAnimationStart', ()=> getterGet(_lightbox_psw_media_init, this).pswp.template.classList.remove('hdt-psw-animate'));
    getterGet(_lightbox_psw_media_init, this).init();
    return getterGet(_lightbox_psw_media_init, this);
  }
  /**
   * Open the lightbox at the given index (by default, it opens the selected image)
   */
  openLightBox(index = 0) {
    const images = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]', this);
    const dataSource = images.map((image) => {
      return {
        thumbEl: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: true
      };
    });
    if (index == 'get') index = this.indexImage;
    this.lightBox.loadAndOpen(index, dataSource);
  }
  updateAttrPsw(event) {
    this.removeAttribute('show-btn-pswp');
    this.indexImage = 0;
    if(!event.detail.sliderApi) return;
    const selectedSlide = event.detail.sliderApi.slideNodes()[event.detail.sliderApi.selectedScrollSnap()];
    if (selectedSlide.dataset.mediaType == 'image') {
      const images = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]', this),
      image = $4('img[hdt-el]', selectedSlide);
      this.indexImage = Math.max(images.indexOf(image), 0);
      this.setAttribute('show-btn-pswp', '');
    }
  }
};
_on_variant_changed_media = new WeakSet();
on_variant_changed_media_fn = function(event) {

  const variant = event.detail.variant;
  if (!variant) return;
  getterRunFn(_update_group_media, this, update_group_media_fn).call(this, variant);
  // if (this.updateGroupFilter) {
  //   let isreInit = false;
  //   variant.options.forEach((value, index) => {
  //     if ($$4(`[data-group-name="option${index}"][data-group-value="${value}"][hidden]`).length && this.sliderMain.isActive) {
  //       //console.log(this, $4('[data-media-type].is-selected hdt-video-player', this))
  //       $4('[data-media-type].is-selected hdt-video-player[loaded]', this)?.pause();
  //       isreInit = true;
  //     }
  //     //console.log(isreInit && this.sliderMain.isActive)
  //     $$4(`[data-group-name="option${index}"]`, this).forEach((media) => {
  //       if ( media.getAttribute('data-group-value') == value) {
  //         media.removeAttribute('hidden');
  //       } else {
  //         media.setAttribute('hidden', '');
  //       }
  //     });
  //   });
  //   if (isreInit) {
  //     this.sliderMain.reInit();
  //     this.sliderThumb?.reInit();
  //   }
  // }
  if (variant.mdid && event.detail.jumpMedia) {
    const media = $4(`.hdt-product-media__main [data-media-id="${variant.mdid}"]`, this);
    if (media) {
      if (this.sliderMain.isActive) {
        //this.disableSelectVariant = true;
        if(media.dataset.variantsId.indexOf(variant.id+"") < 0){
          let original = media.dataset.variantsId.split(';');
          let newItem = variant.id+"";
          let uniqueResult = [...new Set([...original, newItem])];
          media.dataset.variantsId = uniqueResult.join(';')
        }
        this.sliderMain.goToTarget(media);
      } else {
        //console.log(gotoMedia)
        media.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  }
};
_update_group_media = new WeakSet();
update_group_media_fn = function(variantOrEvent) {
  const options = variantOrEvent.options || variantOrEvent.detail.options;
  if (!this.updateGroupFilter) return;
  let isreInit = false;
  options.forEach((value, index) => {
    if ($$4(`[data-group-name="option${index}"][data-group-value="${value}"][hidden]`).length && this.sliderMain.isActive) {
      //console.log(this, $4('[data-media-type].is-selected hdt-video-player', this))
      $4('[data-media-type].is-selected hdt-video-player[loaded]', this)?.pause();
      isreInit = true;
    }
    //console.log(isreInit && this.sliderMain.isActive)
    $$4(`[data-group-name="option${index}"]`, this).forEach((media) => {
      if ( media.getAttribute('data-group-value') == value) {
        media.removeAttribute('hidden');
      } else {
        media.setAttribute('hidden', '');
      }
    });
  });
  if (isreInit) {
    this.sliderMain.reInit();
    this.sliderThumb?.reInit();
  }
};
_slider_main_select = new WeakSet();
slider_main_select_fn = function(event) {
  //console.log('slider_main_select_fn: ', event.detail)
  // if (this.disableSelectVariant) {
  //   this.disableSelectVariant = false;
  //   return;
  // }
  this.updateAttrPsw(event);
  const sliderApi = event.detail.sliderApi,
        selectedSlide = sliderApi.slideNodes()[sliderApi.selectedScrollSnap()],
        prevSlide = sliderApi.slideNodes()[sliderApi.previousScrollSnap()],
        mediaId   = selectedSlide.getAttribute('data-media-id') || null,
        variantsId = (selectedSlide.dataset.variantsId || '').split(';'),
        firstOption = (selectedSlide.dataset.firstOption || '').split(',');

  // variantsId.indexOf(this.form.id.value to detech media has need run fn selected
  if (mediaId && this.variantPicker && this.hasAttribute('update-when-variant-change') && variantsId[0] && variantsId.indexOf(this.form.id.value) < 0 ) {
    //console.log('mediaId', mediaId)
    this.variantPicker.selectVariantByID(variantsId[0], firstOption, false);
  }
  switch (prevSlide.getAttribute("data-media-type")) {
    case "video":
    case "external_video":
    //case "model":
      //$4('hdt-video-player[loaded], hdt-model-player[loaded]', prevSlide)?.pause();
      $4('hdt-video-player[loaded]', prevSlide)?.pause();
  }

  switch (selectedSlide.getAttribute("data-media-type")) {
    case "video":
    case "external_video":
      if (this.hasAttribute("autoplay-media")) $4('hdt-video-player', selectedSlide).play();
      break;
    case "model":
      if (!matchMediaQuery("mobile")) $4('hdt-model-player', selectedSlide).play();
      break;
  }
};
_media_image_click = new WeakSet();
media_image_click_fn = function(imageWrap) {
  const imagesWrap = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden])', this);
  this.dispatchEvent(new CustomEvent("lightbox:psw:open", { bubbles: true, detail: { index: imagesWrap.indexOf(imageWrap) } }));
};
_media_image_zoom = new WeakSet();
media_image_zoom_fn = function() {
  var classFadeMedia = 'zoom_fade_media',
      classFadeInfo  = 'zoom_fade_info',
      options        = JSON.parse( this.getAttribute('zoom-options') ),
      zoomWrapper    = $id4(`product-zoom-${this.sectionId}`),
      info           = $id4(`product-info-${this.sectionId}`),
      zoomType       = options.type,  // external, inner, inner2 zoom
      zoomFactor     = options.magnify,
      isExternal     = zoomType  == 'external';

  if(Shopify.designMode) $4('.drift-zoom-pane, .drift-bounding-box')?.remove();
  html.classList.add(`zoom-type--${zoomType}`);
  $$4('.hdt-product-media__main [data-media-type="image"] img', this).forEach((image) => {
    new Zoom(image, {
      sourceAttribute: 'src',
      zoomFactor,
      inlinePane: !isExternal && zoomType == 'inner2',
      containInline: isExternal,
      paneContainer: isExternal ? zoomWrapper : image.parentElement,
      hoverBoundingBox: isExternal, //false , true
      handleTouch: false,
      onShow: () => {
       this.classList.add(classFadeMedia);
       info.classList.add(classFadeInfo);
      },
      onHide: () => {
       this.classList.remove(classFadeMedia);
       info.classList.remove(classFadeInfo);
      }
    });
  });
};

ui_register_fn = function(){
  if (getterGet(_lightbox_psw_media_init, this).pswp.options.dataSource.length < 2 || !this.hasAttribute('show-thumb')) return;

  getterGet(_lightbox_psw_media_init, this).pswp.ui.registerElement({
    name: 'thumbnails',
    className: 'pswp__thumbnails',
    appendTo: 'root',
    //tagName: 'hdt-slider',
    onInit: (el, pswp) => {
      let prevIndex = -1,
      stringHTMl = '',
      i,
      l = pswp.getNumItems();

      for (i = 0; i < l; i++) {
        const { src, srcset, alt } = pswp.options.dataSource[i];
        stringHTMl += `<div class="hdt-slider__slide" can-reveal><div class="pswp__thumbnail" data-index="${i}"><img src="${src}" srcset="${srcset}" alt="${alt}" loading="lazy" sizes="70px"></div></div>`;
      }
      el.insertAdjacentHTML(
        'beforeend',
        `<hdt-slider reveal-on-scroll="true" class="hdt-slider" config='{"dragFree": true,"slidesToScroll": 1,"ntCenter": true}'><div class='hdt-slider__viewport'><div class='hdt-slider__container'>${stringHTMl}</div></div></hdt-slider>`,
      );
      stringHTMl = ''; //reset cache
      pswp.thumbs = $$4('.pswp__thumbnail', el);

      pswp.on('change', () => {
        const {currIndex} = pswp;
        if (prevIndex >= 0) {
          pswp.thumbs[prevIndex].classList.remove('pswp__thumbnail--active');
        }
        pswp.thumbs[currIndex].classList.add('pswp__thumbnail--active');
        prevIndex = currIndex;
        this?.slider?.goToIndex(currIndex)
      });
    },
   // when user clicks or taps on element
    onClick: function (e, el, pswp) {
      const {index} = e.target.dataset;
      if (index) pswp.goTo(parseInt(index));
    }
  });
};

class OpenLightboxPSWMedia extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("lightbox:psw:open", { bubbles: true, detail: { index: 'get' } })));
  }
};

var _lightbox_psw_init, lightbox_psw_init_fn,
_lightbox_psws = new WeakMap();
class OpenLightboxPSW extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_lightbox_psw_init, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    if (!this.dataset.objImg) return;
    getterRunFn(_lightbox_psw_init, this, lightbox_psw_init_fn).call(this);
    this.addEventListener("click", () => this.lightBox?.loadAndOpen(this.dataset.index || 0), { signal: this.#abortController.signal });
    //this.addEventListener("lightbox:pswp:open", () => this.openLightBox(this.dataset.index || 0));
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get lightBox() {
    return getterGet(_lightbox_psws, this);
  }
  get objImg() {
    return this.getAttribute('obj-img');
  }
};
_lightbox_psw_init = new WeakSet();
lightbox_psw_init_fn = function(){
  let dataSource = null;
  //if (this.dataset.objImg) {
    const _objImg = JSON.parse(this.dataset.objImg);
    _objImg.srcset = renderSrcset(_objImg.src, JSON.parse(this.dataset.widths || `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${_objImg.width}]`));
     dataSource = [_objImg]
  // }
  // console.log(dataSource)
  // if (!dataSource) return;
  const options = {
    bgOpacity: 1,
    showHideAnimationType: 'fade', // 'zoom', 'fade', 'none
    pswpModule: () => import("@theme/psw"),
    dataSource,
    // UX - https://photoswipe.com/styling/
    arrowPrevSVG: `${svgPath} width="24" height="24"><polyline points="15 18 9 12 15 6"></polyline></svg>`,
    arrowNextSVG: `${svgPath} width="24" height="24"><polyline points="9 18 15 12 9 6"></polyline></svg>`,
    closeSVG: `${svgPath} width="28" height="28"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
    zoomSVG: `${svgPath} width="22" height="22"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line id="pswp__icn-plus" x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`,
  };
  getterAdd(_lightbox_psws, this, new Lightbox(options));
  this.lightBox.init();
  // Clear memory
  dataSource = null;
}

var _lightbox_psw_init = new WeakMap();
class GalleryModal extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    if (this.images.length == 0) return;
    this.images.forEach( (image, index) => image.addEventListener('click', this.openLightBox.bind(this, index), { signal: this.#abortController.signal }));
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get images() {
    return $$4( this.getAttribute("selector") || "img", this)
  }
  get lightBox() {
    if (getterGet(_lightbox_psw_init, this)) return getterGet(_lightbox_psw_init, this);
    const {close, zoom, prev, next, errorMsg} = themeHDN.extras.pswp;

    let secondaryZoomLevel = parseInt(this.getAttribute("max-zoom")) || 2,
    dataSource = this.images.map((image) => {
      const {src, currentSrc, alt} = image;
      const srcset = renderSrcset(src, JSON.parse(image.dataset.widths || `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${image.getAttribute("width")}]`));
      return {
        thumbnailElement: image,
        src,
        srcset,
        msrc: currentSrc || src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt,
        thumbCropped: true
      };
    });

    getterAdd(_lightbox_psw_init, this, new Lightbox({
      pswpModule: () => import("@theme/psw"),
      //showHideAnimationType: 'zoom',
      dataSource,
      bgOpacity: 1,
      secondaryZoomLevel,
      maxZoomLevel: ++secondaryZoomLevel,
      closeTitle: close,
      zoomTitle: zoom,
      arrowPrevTitle: prev,
      arrowNextTitle: next,
      errorMsg: errorMsg,
      // UX - https://photoswipe.com/styling/
      arrowPrevSVG: `${svgPath} width="24" height="24"><polyline points="15 18 9 12 15 6"></polyline></svg>`,
      arrowNextSVG: `${svgPath} width="24" height="24"><polyline points="9 18 15 12 9 6"></polyline></svg>`,
      closeSVG: `${svgPath} width="28" height="28"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
      zoomSVG: `${svgPath} width="22" height="22"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line id="pswp__icn-plus" x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`,
    }));
    getterGet(_lightbox_psw_init, this).init();
    // Clear memory
    dataSource = null;
    return getterGet(_lightbox_psw_init, this);
  }
  openLightBox(index = 0) {
    this.lightBox.loadAndOpen(index);
  }
};

customElements.define("hdt-video-player", VideoPlayer);
customElements.define("hdt-model-player", ModelPlayer);
customElements.define("hdt-product-media", ProductMedia);
customElements.define("wrapp-open-pswp-media", OpenLightboxPSWMedia);
customElements.define("wrapp-open-pswp-btn", OpenLightboxPSW);
customElements.define('hdt-gallery-modal', GalleryModal);

// END MEDIA PLAYER
var _items_compare_color = new WeakMap(),
_item_compare_color,
item_compare_color_fn;
class CompareToogle extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_items_compare_color, this, $$4('.hdt-compare-color-item', this.closest('.hdt-modal__compare-color')));
    getterAdd(_item_compare_color, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.indexOrder = 0;
    $$4('button', this).forEach((btn, index) => {
      ++this.indexOrder;
      btn.addEventListener('click', getterRunFn(_item_compare_color, this, item_compare_color_fn).bind(this, btn, index), { signal: this.#abortController.signal });
    });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
_item_compare_color = new WeakSet();
item_compare_color_fn = function(btn, index) {
  const isHideColor = btn.classList.toggle('is-hide-color');
  btn.firstElementChild.toggleAttribute('hidden', isHideColor);
  btn.lastElementChild.toggleAttribute('hidden', !isHideColor);
  console.log(this.indexOrder, index, getterGet(_items_compare_color, this))
  if (isHideColor) {
    --this.indexOrder
    getterGet(_items_compare_color, this)[index].setAttribute('hidden', '');
  } else {
    ++this.indexOrder
    getterGet(_items_compare_color, this)[index].removeAttribute('hidden');
    getterGet(_items_compare_color, this)[index].style.order = this.indexOrder;
  }
};
customElements.define("hdt-compare-color-toogle", CompareToogle);

// TF
class closeAnnounceWrap extends HTMLElement {
  constructor() {
    super();
    if (sessionStorage.getItem(announceSize) === "true") {
      announceSize = null;
      return;
    }
    this.addEventListener('click', (e) => {
      if (!Shopify.designMode) sessionStorage.setItem(announceSize, "true");
      let $section = this.closest('.hdt-section-group');
      $section.style.setProperty('overflow', 'hidden');
      animate($section, { height: [`${$section.clientHeight}px`, '0px'] }).finished.then(() => {
        $section.classList.add('hdt-announcement-hidden');
        announceSize = null; // announceSize can be garbage collected
      });
    });
  }
}
customElements.define("wrapp-close-announce", closeAnnounceWrap);

// --------------------------
// lazyHTML- https://web.dev/articles/fetch-priority
// --------------------------
class lazyHTML extends HTMLElement {
  #abortController;
  check = true;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const options = {
      priority: this.getAttribute('priority') || 'low',
      signal: this.#abortController.signal
    },
    url = this.url || this.getAttribute('url') || `${Shopify.routes.root}?section_id=${this.getAttribute('section-id')}`;
    if (url) this.lazyFetch(url, options);
  }
  disconnectedCallback() {
    if (this.check) this.#abortController.abort();
  }
  async lazyFetch(url, options) {
    const response = await fetchCache(url, '', options),
          tempDiv  = new DOMParser().parseFromString(await response.text(), "text/html");
    this.check = false;
    const formLocal = $4('.shopify-localization-form', tempDiv);
    if (formLocal) {
      const language = $id4('localization_form_language');
      $4('[name="return_to"]', formLocal).value = language && language.return_to ? language.return_to.value : location.pathname;
    }
    this._replace(tempDiv);
  }
  _replace(tempDiv) {
    this.replaceWith(...tempDiv.body.children);
    this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: true }));
  }
}
// --------------------------
// Lazy Submenu
// --------------------------
var cachMenuURl = new Map();
class lazySubmenu extends lazyHTML {
  check = true;
  url = `${Shopify.routes.root}search?type=product&q=submenu${this.getAttribute('key') || ''}&section_id=${this.dataset.section}`;
  constructor() {
    super();
  }
  async lazyFetch(url, options) {
    if (!cachMenuURl.has(url)) {
      cachMenuURl.set(url, true);
      const response = await fetchCache(url, '', options),
            tempDiv  = new DOMParser().parseFromString(await response.text(), "text/html");
      this.check = false;
      this._replace(tempDiv);
      $$4(`hdt-lazy-submenu[data-section="${this.dataset.section}"]:not([id="${this.id}"])`).forEach( (el) => {
        el.dispatchEvent(new CustomEvent(`loaded:lazy`, { bubbles: false, detail: { tempDiv } }));
      });
    } else {
      this.addEventListener('loaded:lazy', (event) => this._replace( event.detail.tempDiv) );
    }
  }
  _replace(tempDiv) {
    this.innerHTML = tempDiv.querySelector(`#${this.id}`).innerHTML;
    this.dispatchEvent(new CustomEvent("products:update", { bubbles: true }));
    this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: true }));
  }
}

customElements.define("hdt-lazy-html", lazyHTML);
customElements.define("hdt-lazy-submenu", lazySubmenu);

// end TF

(() => {
  // LIST
  // 1. Reveal
  // 2. Scrollbar Width
  // 3. Hover 3d button
  // 4. Table, iframe wrapper

  // 1. Reveal
  const reveal_attribute = 'hdt-reveal';
  const reveal_ANIMATION_OFFSCREEN_CLASSNAME = reveal_attribute + '--offscreen';
  const reveal_ANIMATION_CANCEL_CLASSNAME = reveal_attribute + '--cancel';
  const _animationend = (e) => {
    const elementTarget = e.target;
    //console.log("Animation ended", e.target, this, elementTarget.isAnimationend);
    if (elementTarget.isAnimationend) {
      //console.log("Animation ended 2", e.target, this);
      // setTimeout(() => {
      // }, 0);
        elementTarget.setAttribute('animationend','');
        elementTarget.removeEventListener("animationend", _animationend)
    }
  };

  function getNearestClippingParent(el) {
    let parent = el.parentElement;
    while (parent && parent !== document.body) {
      const style = getComputedStyle(parent);
      if (/(auto|scroll|hidden|clip)/.test(style.overflowY + style.overflowX) || style.clipPath !== 'none') {
        return parent;
      }
      if (parent.classList.contains('shopify-section')) {
        break;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  // Map: OBSERVED target (may be a clipping container) -> list of actual reveal elements
  const observedTargetMap = new WeakMap();

  function registerObservedTarget(observedTarget, revealElement) {
    const list = observedTargetMap.get(observedTarget) || [];
    list.push(revealElement);
    observedTargetMap.set(observedTarget, list);
  }

  function onIntersection(entries, observer) {
    entries.forEach((entry) => {
      const observedTarget = entry.target;
      const revealTargets = observedTargetMap.get(observedTarget) || [observedTarget];

      revealTargets.forEach((elementTarget, index) => {
        elementTarget.setAttribute('observed', '');

        if (entry.isIntersecting) {
          if (elementTarget.classList.contains(reveal_ANIMATION_OFFSCREEN_CLASSNAME)) {
            elementTarget.classList.remove(reveal_ANIMATION_OFFSCREEN_CLASSNAME);
            if (elementTarget.hasAttribute('timeline')) elementTarget.style.setProperty('--animation-order', index);
          }
        } else {
          elementTarget.classList.add(reveal_ANIMATION_OFFSCREEN_CLASSNAME);
          elementTarget.classList.remove(reveal_ANIMATION_CANCEL_CLASSNAME);
        }

        elementTarget.isAnimationend = true;
        elementTarget.addEventListener('animationend', _animationend);
      });

      if (entry.isIntersecting) observer.unobserve(observedTarget);
    });
  }

  function intRevealScrollTrigger(rootEl = document, isDesignModeEvent = false) {
    const animationTriggerElements = $$4(`[${reveal_attribute}]:not([observed])`, rootEl);
    if (animationTriggerElements.length === 0) return;

    if (isDesignModeEvent) {
      animationTriggerElements.forEach((element) => {
        element.classList.add(reveal_attribute + '--design-mode');
      });
      return;
    }

    const defaultObserver = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px -50px 0px',
    });

    animationTriggerElements.forEach((element) => {
      const clippingParent = getNearestClippingParent(element);

      if (clippingParent) {
        // Observe the overflow-hidden container instead of the element
        // translated outside of it, since only the container's geometry
        // is unaffected by the transform
        registerObservedTarget(clippingParent, element);
        defaultObserver.observe(clippingParent);
      } else {
        defaultObserver.observe(element);
      }
    });
  }
  
  if (themeHDN.settings.revealInView && matchMedia("motion")) {
    html.classList.add('hdt-reveal-in-view')
    window.addEventListener('DOMContentLoaded', () => intRevealScrollTrigger());

    if (Shopify.designMode) {
      document.addEventListener(adnmEvts.seLoad, (event) => intRevealScrollTrigger(event.target, true));
      document.addEventListener(adnmEvts.seReorder, () => intRevealScrollTrigger(document, true));
    }
  }

  // 2. Scrollbar Width
  // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
  const getScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    if (scrollbarWidth >= 0) html.style.setProperty("--scrollbar-w", `${scrollbarWidth}px`);
    // calc first section height full
    const firstSection = $4('#MainContent .hdt-section');
    if (!firstSection) return;
    const fullFirst = $4('.md\\:hdt-height--full, .hdt-height--full', firstSection);
    if (fullFirst && fullFirst.offsetTop < window.innerHeight) firstSection.style.setProperty("--fill-height-first", `${100 - fullFirst.offsetTop / (window.innerHeight / 100)}vh`);
  };
  getScrollbarWidth();
  window.addEventListener("resize", throttle(getScrollbarWidth));

  // 3. Hover 3d button
  // https://vault.uicore.co/corporate/
  if (matchMediaQuery("hover")) {
    var $buttons3d = $$4('.hdt-btn-effect-3d');
    $buttons3d.forEach((btn) => {
      btn.addEventListener('mousemove', function(e) {
        const pos = btn.getBoundingClientRect();
        const mx = e.clientX - pos.left - pos.width / 2;
        const my = e.clientY - pos.top - pos.height / 2;
        // btn.setProperty('--rx', `${ dy/-1 }deg`)
        btn.style.transform = 'translate(' + mx * 0.15 + 'px, ' + my * 0.3 + 'px)';
        btn.style.transform += 'rotate3d(' + mx * -0.1 + ', ' + my * -0.3 + ', 0, 12deg)';
        if (btn.children[0]) {
          btn.children[0].style.transition = 'all .2s linear';
          btn.children[0].style.transform = 'translate(' + mx * 0.07 + 'px, ' + my * 0.14 + 'px)'
        }
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = 'translate3d(0px, 0px, 0px)';
        btn.style.transform += 'rotate3d(0, 0, 0, 0deg)';
          if (btn.children[0]) btn.children[0].style.transform = 'translate3d(0px, 0px, 0px)'
      });
    });
  }

  // 4. Table, iframe wrapper
  // Theme-specific selectors to make tables scrollable
  rteWrapTable();
  accessibleLinks();
  localeUrl();

  // ADDED: Kityfly and Nathan
  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
  // https://stackoverflow.com/questions/2915833/how-to-check-browser-for-touchstart-support-using-js-jquery
  // https://stackoverflow.com/questions/27173272/300ms-delay-removal-using-fastclick-js-vs-using-ontouchstart
  // if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
  //   $4('meta[name="viewport"]', document.head).content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  // } else  if ("ontouchend" in document) {
  //   let indexFixFristClick = 0;
  //   const FixFristClick = () => { ++indexFixFristClick; if( indexFixFristClick > 1) document.removeEventListener('touchend', FixFristClick) };
  //   document.addEventListener('touchend', FixFristClick);
  // }
  if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
    $4('meta[name="viewport"]', document.head).content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  }
  if ("ontouchend" in document) {
    let indexFixFristClick = 0;
    const FixFristClick = () => { ++indexFixFristClick; if( indexFixFristClick > 1) document.removeEventListener('touchend', FixFristClick) };
    document.addEventListener('touchend', FixFristClick);
  }
  if ( !$4('hdt-cart-drawer') && themeHDN.settings.pageType != 'cart') {
    document.addEventListener(cartUpdate, (event) => {
      const actionAfterATC = event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
      if (actionAfterATC.indexOf('go_') > -1) window.location.href = `${Shopify.routes.root}${actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
    });
  }
  if ($4('hdt-cart-drawer')) {
    document.addEventListener(cartUpdate, () => {
      // const actionAfterATC = event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
      // console.log(event, actionAfterATC)
      if ($4('#hdt-quick-view-modal')?.hasAttribute('open') && $4('#CartDrawer')?.hasAttribute('open')) $4('#hdt-quick-view-modal').parentElement.close();
    });
  }

})();

// Optimized Swatch Card Components for Kalles Theme
class HdtCardProduct extends HTMLElement {
  constructor() {
    super();
    this._currentId = this.querySelector('[name="id"]')?.value || null;
    this._currentVariant = [];
    this._currentImageSrc = null;
    this._initialized = false;
  }

  // Optimized: Combined URL manipulation methods
  updateImageUrl(url, newUrl) {
    if (!url || !newUrl) return url;

    // Path from newUrl; query string (width=..., v=...) from url.
    try {
      const base = window.location.origin;
      const current = new URL(url, base);
      const incoming = new URL(newUrl, base);
      const merged = `${incoming.pathname}${current.search}`;
      const storeHost = new URL(base).host;

      // Protocol-relative CDN: //cdn.shopify.com/s/files/...
      if (typeof url === 'string' && url.startsWith('//')) {
        return `//${current.host}${merged}`;
      }

      // Original on CDN; newUrl is store-relative (/s/files/... or /cdn/shop/...)
      if (current.host && current.host !== storeHost && incoming.host === storeHost) {
        return `${current.protocol}//${current.host}${merged}`;
      }

      // newUrl is a full absolute/CDN URL
      if (incoming.host && incoming.host !== storeHost) {
        if (typeof newUrl === 'string' && newUrl.startsWith('//')) {
          return `//${incoming.host}${merged}`;
        }
        return `${incoming.protocol}//${incoming.host}${merged}`;
      }

      return merged;
    } catch {
      const urlQuery = url.includes('?') ? url.split('?').slice(1).join('?') : '';
      const newPath = newUrl.split('?')[0];
      const merged = urlQuery ? `${newPath}?${urlQuery}` : newPath;
      if (typeof url === 'string' && url.startsWith('//')) {
        const hostMatch = url.match(/^\/\/([^/]+)/);
        if (hostMatch) return `//${hostMatch[1]}${merged}`;
      }
      return merged;
    }
  }

  // Optimized: Streamlined image replacement
  replaceImageWithJSON(imgElement, imageData) {
    if (!imgElement) return imgElement;
    
    const newSrc = imageData?.src;
    
    if (imgElement.src && newSrc) {
      imgElement.src = this.updateImageUrl(imgElement.src, newSrc);
    }
    
    if (imgElement.srcset && newSrc) {
      imgElement.srcset = imgElement.srcset
        .split(',')
        .map(part => {
          const [url, descriptor] = part.trim().split(' ');
          const updatedUrl = this.updateImageUrl(url, newSrc);
          return descriptor ? `${updatedUrl} ${descriptor}` : updatedUrl;
        })
        .join(', ');
    }
    
    // Batch attribute updates
    Object.assign(imgElement, {
      alt: imageData.alt ?? '',
      ...(imageData.width && { width: imageData.width }),
      ...(imageData.height && { height: imageData.height })
    });
    
    return imgElement;
  }

  // Optimized: Simplified image rebuilding with early returns
  rebuildImage(variant, cardProduct = this) {
    const mediaMain = cardProduct.querySelector('.hdt-card-product__media-wrapp');
    if (!mediaMain) return;
    
    let fmedia = variant.featured_media;
    
    // Handle fallback to data-vimg
    if (!fmedia?.preview_image) {
      const dataVimg = this.getAttribute('data-vimg');
      if (!dataVimg) return;
      
      const cleanUrl = dataVimg.replace(/[?&]width=\d+/g, '');
      const url = new URL(cleanUrl, window.location.origin);
      
      fmedia = {
        preview_image: {
          src: cleanUrl,
          width: parseInt(url.searchParams.get('width')) || '',
          height: parseInt(url.searchParams.get('height')) || '',
          alt: variant.title || ''
        }
      };
    }
    
    // Skip if image unchanged
    if (cardProduct._currentImageSrc === fmedia.preview_image.src) return;
    
    cardProduct._currentImageSrc = fmedia.preview_image.src;
    
    // Update images
    this.replaceImageWithJSON(mediaMain.querySelector('img.hdt-card-product__media--main'), fmedia.preview_image);
    if (variant.next_media) {
      this.replaceImageWithJSON(mediaMain.querySelector('img.hdt-card-product__media--hover'), variant.next_media.preview_image);
    }
  }

  // Optimized: Simplified button update (currently disabled)
  updateATC(variant, cardProduct = this) {
    return;
    const button = cardProduct.querySelector('.hdt-card-product__btn-ultra');
    if (!button) return;
    
    const buttonName = button.querySelector('.add-item-jx-text') || button;
    const isAvailable = variant.available;
    
    button.toggleAttribute('disabled', !isAvailable);
    buttonName.innerHTML = isAvailable ? themeHDN.extras.addToCart : themeHDN.extras.soldOut;
  }
  
  // Optimized: Cleaner price update with element caching
  updatePrice(variant, cardProduct = this) {
    const vprice = Number(variant.price);
    if (!vprice) return;
    
    const $price = $4('hdt-price', cardProduct);
    if (!$price) return;
    
    // Update main price
    $price.classList.remove('hdt-price-item--range');
    $price.innerHTML = `<span class="hdt-money">${formatMoney(vprice)}</span>`;
    
    // Handle compare at price
    const vcpprice = Number(variant.compare_at_price);
    let $cpprice = $4('hdt-compare-at-price', cardProduct);
    
    if (vcpprice) {
      if ($cpprice) {
        // Update existing compare price
        $cpprice.removeAttribute('hidden');
        $cpprice.classList.remove('hdt-hidden');
        $cpprice.innerHTML = `<span class="hdt-money">${formatMoney(vcpprice)}</span>`;
      } else {
        // Create new compare price element
        $cpprice = document.createElement('hdt-compare-at-price');
        $cpprice.className = 'hdt-compare-at-price';
        $cpprice.innerHTML = `<span class="hdt-money">${formatMoney(vcpprice)}</span>`;
        $price.parentElement.prepend($cpprice);
      }
    } else if ($cpprice) {
      // Hide compare price if not available
      $cpprice.setAttribute('hidden', '');
      $cpprice.innerHTML = '';
    }
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    
    const mediaMain = this.querySelector('.hdt-card-product__media-wrapp img');
    if (mediaMain) {
      this._currentImageSrc = mediaMain.src;
    }
  }

  disconnectedCallback() {}
}

customElements.define("hdt-card-product", HdtCardProduct);


class HdtSwatchCard extends HdtCardProduct {
  constructor() {
    super();
    this._inputId = this.querySelector('[name="id"]');
    this._productUrl = this.dataset.productUrl || this.closest('hdt-card-product')?.querySelector('[data-pr-url]')?.href;
    this._fetchCache = {};
    this._debounceTimer = null;
    
    this._clickHandler = this.handleClick.bind(this);
    this._mouseenterHandler = () => this.rebuildImage([], this.closest('hdt-card-product'));
  }
  
  // Optimized: Centralized event listener setup
  setupEventListeners() {
    const variantOption = this.closest('hdt-variant-option');
    const eventType = variantOption?.getAttribute('event');
    const isTouchDevice = !matchMediaQuery("hover") || matchMediaQuery("mobile");
    
    if (isTouchDevice || eventType === 'click') {
      this.addEventListener("click", this._clickHandler);
    } else {
      this.addEventListener("mouseenter", this._mouseenterHandler);
    }
  }

  handleClick() {
    const cardProduct = this.closest('hdt-card-product');
    const variantsList = this.closest('.hdt-variants-list');
    
    // Update active state
    variantsList?.querySelector('.hdt-swatch-item.active')?.classList.remove("active");
    this.parentElement.classList.add("active");
    cardProduct.classList.add("loading");
    
    const valueId = this.dataset.valueId;
    if (!valueId) return;
    
    this.debouncedUpdate(this.getActiveDataValueIds().join(','));
  }

  debouncedUpdate(activeIds) {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => this.updateSwatchInternal(activeIds), 150);
  }

  getActiveDataValueIds() {
    const cardProduct = this.closest('hdt-card-product');
    if (!cardProduct) return [];
    
    return Array.from(cardProduct.querySelectorAll('.hdt-swatch-item.active hdt-swatch-card'))
      .map(card => card.getAttribute('data-value-id'));
  }

  // Optimized: Streamlined fetch and cache handling
  async updateSwatchInternal(activeIds) {
    const cardProduct = this.closest('hdt-card-product');
    
    if (!this._productUrl) {
      console.error('Product URL not found');
      cardProduct?.classList.remove("loading");
      return;
    }
    
    const cacheKey = `${this._productUrl.split('?')[0]}?option_values=${activeIds}`;
    
    try {
      // Check cache first
      if (!this._fetchCache[cacheKey]) {
        const response = await fetch(`${cacheKey}&section_id=product-options`, { 
          // Revalidate option HTML so theme, colour and availability changes do not stay stale.
          cache: "no-cache", 
          mode: "same-origin" 
        });
        this._fetchCache[cacheKey] = await response.text();
      }
      
      this.processSwatchResponse(this._fetchCache[cacheKey]);
    } catch (e) {
      console.error('Swatch update error:', e);
      cardProduct?.classList.remove("loading");
    }
  }

  // Optimized: Cleaner DOM manipulation
  processSwatchResponse(text) {
    const element = new DOMParser().parseFromString(text, 'text/html');
    const options = element.querySelectorAll('[data-option-position]');
    const selectedVariant = element.getElementById('selected-variant');
    const cardProduct = this.closest('hdt-card-product');
    
    if (!selectedVariant) {
      cardProduct.classList.remove("loading");
      return;
    }
    
    // Update options
    options.forEach((option, index) => {
      const elOption = cardProduct.querySelector(`[data-option-position="${index + 1}"]`);
      if (!elOption) return;
      
      let optionHTML = option.innerHTML;
      
      // Handle action-all modifications
      if (elOption.classList.contains('is--action-all') || !elOption.querySelector('.is--swatch-limit')) {
        optionHTML = optionHTML.replace(/is--swatch-limit/g, '');
        
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = optionHTML;
        tempDiv.querySelectorAll('.is--swatch-link').forEach(el => el.setAttribute('hidden', ''));
        optionHTML = tempDiv.innerHTML;
      }
      
      elOption.innerHTML = optionHTML;
      
      // Re-initialize view-more functionality
      if (elOption.tagName === 'HDT-VARIANT-OPTION' && elOption.hasAttribute('action-all')) {
        elOption.reinitializeViewMore();
      }
    });
    
    // Update variant and UI
    this._currentVariant = JSON.parse(selectedVariant.textContent);
    this._currentVariant.next_media = JSON.parse(selectedVariant.getAttribute('data-next-media'));
    if (this._inputId) this._inputId.value = this._currentVariant.id;
    
    // Batch UI updates
    this.updateATC(this._currentVariant, cardProduct);
    this.rebuildImage(this._currentVariant, cardProduct);
    this.updatePrice(this._currentVariant, cardProduct);
    
    cardProduct.classList.remove("loading");
    
    // Dispatch event
    this.dispatchEvent(new CustomEvent('variant:updated', { 
      detail: { variant: this._currentVariant }, 
      bubbles: true,
      cancelable: true 
    }));
  }

  connectedCallback() {
    this.setupEventListeners();
    if (this._initialized) return;
    this._initialized = true;
    super.connectedCallback();
  }

  disconnectedCallback() {
    clearTimeout(this._debounceTimer);
    this.removeEventListener("click", this._clickHandler);
    this.removeEventListener("mouseenter", this._mouseenterHandler);
    super.disconnectedCallback();
  }
}

customElements.define('hdt-swatch-card', HdtSwatchCard);


class HdtVariantOption extends HdtCardProduct {
  constructor() {
    super();
    this._delegate = new Delegate(this);
    this._variantsList = null;
    this._itemFirst = null;
    this._itemLast = null;
    this._widthList = 0;
    this._slider = null;
    this._resizeObserver = null;
    this._limitInitialized = false;
    this._viewMoreInitialized = false;
    this._viewMoreClickHandler = null;
    this.isVoLimit = 'is--swatch-limit';
    this.isAcAll = 'is--action-all';
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    
    this._variantsList = this.querySelector('.hdt-variants-list');
    if (!this._variantsList || this._variantsList.childElementCount <= 2) return;
    
    this._itemFirst = this._variantsList.firstChild;
    this._itemLast = this._variantsList.lastChild;
    this._slider = this.closest('.hdt-slider__products');
    
    if (this.hasAttribute('auto-limit')) {
      this.initAutoLimit();
    }
    
    if (this.hasAttribute('action-all')) {
      this.initViewMore();
    }
  }

  disconnectedCallback() {
    this._delegate.off();
    this._resizeObserver?.disconnect();
    
    if (this._viewMoreClickHandler && this._itemLast) {
      this._itemLast.removeEventListener("click", this._viewMoreClickHandler);
    }
    super.disconnectedCallback();
  }

  initAutoLimit() {
    if (this._limitInitialized) return;
    this._limitInitialized = true;
    
    if (window.ResizeObserver) {
      this._resizeObserver = new ResizeObserver(throttle(this.handleResize.bind(this)));
      this._resizeObserver.observe(this);
    } else {
      this.handleLimit();
    }
  }

  initViewMore() {
    if (this._viewMoreInitialized) return;
    this._viewMoreInitialized = true;
    
    this._viewMoreClickHandler = this.handleViewMoreClick.bind(this);
    this._itemLast.addEventListener("click", this._viewMoreClickHandler);
    
    if (window.ResizeObserver && !this.hasAttribute('auto-limit')) {
      this._resizeObserver = new ResizeObserver(throttle(this.handleResize.bind(this)));
      this._resizeObserver.observe(this);
    }
  }

  reinitializeViewMore() {
    this._variantsList = this.querySelector('.hdt-variants-list');
    if (!this._variantsList) return;
    
    this._itemLast = this._variantsList.lastChild;
    
    if (this._viewMoreClickHandler) {
      this._itemLast.removeEventListener("click", this._viewMoreClickHandler);
    }
    
    this._viewMoreClickHandler = this.handleViewMoreClick.bind(this);
    this._itemLast.addEventListener("click", this._viewMoreClickHandler);
  }

  // Optimized: Simplified calculation logic with better variable names
  handleLimit() {
    const itemRect = this._itemFirst.getBoundingClientRect();
    const moreRect = this._itemLast.getBoundingClientRect();
    const computedStyles = getComputedStyle(this._variantsList);
    const gap = parseFloat(computedStyles.gap || computedStyles.columnGap || 10);
    const totalItems = this._variantsList.childElementCount - 1;
    const containerWidth = this._variantsList.getBoundingClientRect().width;
    
    const maxFit = Math.floor(containerWidth / (itemRect.width + gap));
    const maxFitWithMore = Math.floor((containerWidth - moreRect.width) / (itemRect.width + gap));
    const totalItemsWidth = itemRect.width * totalItems + (totalItems - 1) * gap;

    if (maxFit >= totalItems || (this._widthList && totalItemsWidth <= this._widthList)) {
      // All items fit, hide "more" button
      console.log('All items fit, hide "more" button');
      this._itemLast.setAttribute('hidden', '');
      this.querySelector(`.${this.isVoLimit}`)?.classList.remove(this.isVoLimit);
    } else {
      // Items overflow, show "more" button with count
      console.log('Items overflow, show "more" button with count');
      this._variantsList.childNodes[maxFitWithMore]?.classList.add(this.isVoLimit);
      this.querySelector(`.${this.isVoLimit}`)?.classList.remove(this.isVoLimit);
      this._itemLast.lastElementChild.textContent = `+${totalItems - maxFitWithMore}`;
      this._itemLast.style.opacity = 1;
    }
  }

  // Optimized: Cleaner resize handling
  handleResize(entries) {
    // Reinit slider if exists
    this._slider?._sliderApi?.reInit();
    
    const newWidth = entries[0].contentRect.width;
    if (this._widthList === newWidth) return;
    this._widthList = newWidth;

    if (this.hasAttribute('auto-limit')) {
      this.querySelector(`.${this.isVoLimit}`)?.classList.remove(this.isVoLimit);
      this._variantsList.childNodes[1]?.classList.add(this.isVoLimit);
      this._itemLast.removeAttribute('hidden');
      this._itemLast.style.opacity = 0;
      this.handleLimit();
    } else {
      const maximum = parseInt(this.getAttribute('maximum'));
      this._variantsList.childNodes[maximum]?.classList.add(this.isVoLimit);
      this._itemLast.removeAttribute('hidden');
    }
  }

  // Optimized: Streamlined view-more animation
  handleViewMoreClick(e) {
    e.preventDefault();
    
    this._resizeObserver?.disconnect();
    
    const limitElement = this.querySelector(`.${this.isVoLimit}`);
    limitElement?.classList.remove(this.isVoLimit);
    this._itemLast.setAttribute('hidden', '');
    this.style.minHeight = `${this.clientHeight}px`;
    
    animate(
      this._variantsList.children,
      { 
        opacity: [0, 1], 
        transform: ["scale(.5) translateY(10px)", "scale(1) translateY(0)"] 
      },
      { 
        duration: 0.35, 
        delay: stagger(0.05, { easing: "ease-out" }), 
        easing: "ease" 
      }
    ).finished.then(() => {
      this.style.minHeight = null;
      this._slider?._sliderApi?.reInit();
    });
    
    this.closest('hdt-variant-option')?.classList.add(this.isAcAll);
    limitElement?.previousElementSibling.querySelector('input')?.focus();
  }
}

customElements.define('hdt-variant-option', HdtVariantOption);

class Return extends HTMLElement {
  #controller;
  #input
  #oldSeach;
  connectedCallback() {
    this.#input = $4('[name="return_to"]', this);
    if (!this.#input) return;
    this.#oldSeach = this.#input.value.split('?')[1];
    this.udateURL();
    this.#controller = new AbortController();
    document?.addEventListener('hdt:updateUrl', this.udateURL, { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.#controller?.abort();
  }
  udateURL = () => {
    // console.log('udateURL', this)
    // Update return url
    const params = new URLSearchParams(location.search);
    [...params.keys()].forEach(key => {
      if ( key.startsWith('contact[') || key === 'contact_posted' || key === 'form_type' ) params.delete(key);
    });
    const search = params.toString();
    this.#input.value = `${location.pathname}?${search ? `${search}&` : ''}${this.#oldSeach}`;
  }
}
customElements.define("hdt-return", Return);

export {
  getterAdd, getterGet, getterRunFn,
  isRTL,
  getUID,
  btnTooltip,
  ModalComponent,
  DrawerComponent,
  VariantChangeBase,
  localeUrl
}
